var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUtilityManagementFeatures(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430.81 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#d4dbdb;}.cls-3{fill:#006970;}.cls-4{fill:#bacacd;}.cls-5{fill:#a9b9bc;}.cls-6{fill:#524a48;}.cls-7{fill:#beced3;}.cls-8{fill:#219da4;}.cls-9{opacity:.3;}.cls-9,.cls-10{mix-blend-mode:multiply;}.cls-11{fill:url(#linear-gradient-7);}.cls-12{fill:url(#linear-gradient-5);}.cls-13{fill:url(#linear-gradient-9);}.cls-14{fill:url(#linear-gradient-4);}.cls-15{fill:url(#linear-gradient-3);}.cls-16{fill:url(#linear-gradient-2);}.cls-17{opacity:.7;}.cls-17,.cls-18,.cls-19{fill:#fff;}.cls-17,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99,.cls-100{mix-blend-mode:overlay;}.cls-101{fill:#9db6ba;}.cls-102{fill:#d4dcf0;}.cls-103{fill:#58afa5;}.cls-104{fill:url(#linear-gradient);}.cls-105{fill:#c5c1bf;}.cls-18,.cls-10{opacity:.2;}.cls-106{fill:#b85e27;}.cls-107{fill:#016779;}.cls-108{fill:#d0dbdc;}.cls-109{fill:#6bb7af;}.cls-110{fill:#1c6b7d;}.cls-111{fill:#03626f;}.cls-112{fill:#739aa0;}.cls-113{fill:#e68424;}.cls-114{isolation:isolate;}.cls-115{fill:#fdfeff;}.cls-116{fill:#047379;}.cls-117{fill:#a7cded;}.cls-20{fill:url(#linear-gradient-8);}.cls-21{fill:url(#linear-gradient-6);}.cls-118{fill:#447c8b;}.cls-119{fill:#b8c9cc;}.cls-120{fill:#5e8a94;}.cls-121{fill:#5c8992;}.cls-22{fill:url(#linear-gradient-10);}.cls-23{fill:url(#linear-gradient-12);}.cls-24{fill:url(#linear-gradient-84);}.cls-25{fill:url(#linear-gradient-82);}.cls-26{fill:url(#linear-gradient-88);}.cls-27{fill:url(#linear-gradient-80);}.cls-28{fill:url(#linear-gradient-86);}.cls-29{fill:url(#linear-gradient-92);}.cls-30{fill:url(#linear-gradient-94);}.cls-31{fill:url(#linear-gradient-90);}.cls-32{fill:url(#linear-gradient-98);}.cls-33{fill:url(#linear-gradient-96);}.cls-34{fill:url(#linear-gradient-54);}.cls-35{fill:url(#linear-gradient-56);}.cls-36{fill:url(#linear-gradient-50);}.cls-37{fill:url(#linear-gradient-52);}.cls-38{fill:url(#linear-gradient-58);}.cls-39{fill:url(#linear-gradient-78);}.cls-40{fill:url(#linear-gradient-72);}.cls-41{fill:url(#linear-gradient-76);}.cls-42{fill:url(#linear-gradient-74);}.cls-43{fill:url(#linear-gradient-70);}.cls-44{fill:url(#linear-gradient-68);}.cls-45{fill:url(#linear-gradient-64);}.cls-46{fill:url(#linear-gradient-66);}.cls-47{fill:url(#linear-gradient-60);}.cls-48{fill:url(#linear-gradient-62);}.cls-49{fill:url(#linear-gradient-22);}.cls-50{fill:url(#linear-gradient-20);}.cls-51{fill:url(#linear-gradient-14);}.cls-52{fill:url(#linear-gradient-30);}.cls-53{fill:url(#linear-gradient-16);}.cls-54{fill:url(#linear-gradient-28);}.cls-55{fill:url(#linear-gradient-32);}.cls-56{fill:url(#linear-gradient-26);}.cls-57{fill:url(#linear-gradient-24);}.cls-58{fill:url(#linear-gradient-34);}.cls-59{fill:url(#linear-gradient-18);}.cls-60{fill:url(#linear-gradient-36);}.cls-61{fill:url(#linear-gradient-38);}.cls-62{fill:url(#linear-gradient-42);}.cls-63{fill:url(#linear-gradient-40);}.cls-64{fill:url(#linear-gradient-48);}.cls-65{fill:url(#linear-gradient-44);}.cls-66{fill:url(#linear-gradient-46);}.cls-67{fill:url(#linear-gradient-158);}.cls-68{fill:url(#linear-gradient-160);}.cls-69{fill:url(#linear-gradient-164);}.cls-70{fill:url(#linear-gradient-162);}.cls-71{fill:url(#linear-gradient-108);}.cls-72{fill:url(#linear-gradient-142);}.cls-73{fill:url(#linear-gradient-140);}.cls-74{fill:url(#linear-gradient-146);}.cls-75{fill:url(#linear-gradient-166);}.cls-76{fill:url(#linear-gradient-154);}.cls-77{fill:url(#linear-gradient-152);}.cls-78{fill:url(#linear-gradient-156);}.cls-79{fill:url(#linear-gradient-150);}.cls-80{fill:url(#linear-gradient-148);}.cls-81{fill:url(#linear-gradient-144);}.cls-82{fill:url(#linear-gradient-106);}.cls-83{fill:url(#linear-gradient-104);}.cls-84{fill:url(#linear-gradient-102);}.cls-85{fill:url(#linear-gradient-100);}.cls-86{fill:url(#linear-gradient-124);}.cls-87{fill:url(#linear-gradient-122);}.cls-88{fill:url(#linear-gradient-126);}.cls-89{fill:url(#linear-gradient-120);}.cls-90{fill:url(#linear-gradient-128);}.cls-91{fill:url(#linear-gradient-134);}.cls-92{fill:url(#linear-gradient-136);}.cls-93{fill:url(#linear-gradient-138);}.cls-94{fill:url(#linear-gradient-130);}.cls-95{fill:url(#linear-gradient-132);}.cls-96{fill:url(#linear-gradient-116);}.cls-97{fill:url(#linear-gradient-112);}.cls-98{fill:url(#linear-gradient-118);}.cls-99{fill:url(#linear-gradient-114);}.cls-100{fill:url(#linear-gradient-110);}.cls-122{fill-rule:evenodd;}.cls-122,.cls-123{fill:#e4e9ea;}.cls-124{fill:#d6dfe0;}.cls-125{fill:#56aea4;}.cls-126{fill:url(#linear-gradient-43);}.cls-127{fill:url(#linear-gradient-41);}.cls-128{fill:url(#linear-gradient-49);}.cls-129{fill:url(#linear-gradient-45);}.cls-130{fill:url(#linear-gradient-47);}.cls-131{fill:url(#linear-gradient-11);}.cls-132{fill:url(#linear-gradient-13);}.cls-133{fill:url(#linear-gradient-19);}.cls-134{fill:url(#linear-gradient-21);}.cls-135{fill:url(#linear-gradient-23);}.cls-136{fill:url(#linear-gradient-25);}.cls-137{fill:url(#linear-gradient-31);}.cls-138{fill:url(#linear-gradient-33);}.cls-139{fill:url(#linear-gradient-15);}.cls-140{fill:url(#linear-gradient-17);}.cls-141{fill:url(#linear-gradient-35);}.cls-142{fill:url(#linear-gradient-27);}.cls-143{fill:url(#linear-gradient-29);}.cls-144{fill:url(#linear-gradient-37);}.cls-145{fill:url(#linear-gradient-39);}.cls-146{fill:url(#linear-gradient-57);}.cls-147{fill:url(#linear-gradient-59);}.cls-148{fill:url(#linear-gradient-53);}.cls-149{fill:url(#linear-gradient-55);}.cls-150{fill:url(#linear-gradient-51);}.cls-151{fill:url(#linear-gradient-67);}.cls-152{fill:url(#linear-gradient-69);}.cls-153{fill:url(#linear-gradient-63);}.cls-154{fill:url(#linear-gradient-65);}.cls-155{fill:url(#linear-gradient-61);}.cls-156{fill:url(#linear-gradient-79);}.cls-157{fill:url(#linear-gradient-75);}.cls-158{fill:url(#linear-gradient-77);}.cls-159{fill:url(#linear-gradient-71);}.cls-160{fill:url(#linear-gradient-73);}.cls-161{fill:url(#linear-gradient-87);}.cls-162{fill:url(#linear-gradient-89);}.cls-163{fill:url(#linear-gradient-85);}.cls-164{fill:url(#linear-gradient-83);}.cls-165{fill:url(#linear-gradient-81);}.cls-166{fill:url(#linear-gradient-99);}.cls-167{fill:url(#linear-gradient-97);}.cls-168{fill:url(#linear-gradient-93);}.cls-169{fill:url(#linear-gradient-91);}.cls-170{fill:url(#linear-gradient-95);}.cls-171{fill:#4e8190;}.cls-172{fill:#1f877a;}.cls-173{fill:#83a5aa;}.cls-174{fill:#37aeb9;}.cls-175{fill:#35585f;}.cls-176{fill:#398186;}.cls-177{fill:#6d959d;}.cls-178{fill:#598997;}.cls-179{fill:#6b8f95;}.cls-180{fill:#374a76;}.cls-181{fill:#397687;}.cls-182{fill:url(#linear-gradient-159);}.cls-183{fill:url(#linear-gradient-163);}.cls-184{fill:url(#linear-gradient-161);}.cls-185{fill:url(#linear-gradient-155);}.cls-186{fill:url(#linear-gradient-167);}.cls-187{fill:url(#linear-gradient-165);}.cls-188{fill:url(#linear-gradient-175);}.cls-189{fill:url(#linear-gradient-174);}.cls-190{fill:url(#linear-gradient-173);}.cls-191{fill:url(#linear-gradient-172);}.cls-192{fill:url(#linear-gradient-171);}.cls-193{fill:url(#linear-gradient-170);}.cls-194{fill:url(#linear-gradient-179);}.cls-195{fill:url(#linear-gradient-178);}.cls-196{fill:url(#linear-gradient-177);}.cls-197{fill:url(#linear-gradient-176);}.cls-198{fill:url(#linear-gradient-145);}.cls-199{fill:url(#linear-gradient-153);}.cls-200{fill:url(#linear-gradient-151);}.cls-201{fill:url(#linear-gradient-157);}.cls-202{fill:url(#linear-gradient-149);}.cls-203{fill:url(#linear-gradient-168);}.cls-204{fill:url(#linear-gradient-169);}.cls-205{fill:url(#linear-gradient-141);}.cls-206{fill:url(#linear-gradient-147);}.cls-207{fill:url(#linear-gradient-143);}.cls-208{fill:url(#linear-gradient-107);}.cls-209{fill:url(#linear-gradient-109);}.cls-210{fill:url(#linear-gradient-105);}.cls-211{fill:url(#linear-gradient-103);}.cls-212{fill:url(#linear-gradient-101);}.cls-213{fill:url(#linear-gradient-125);}.cls-214{fill:url(#linear-gradient-123);}.cls-215{fill:url(#linear-gradient-129);}.cls-216{fill:url(#linear-gradient-121);}.cls-217{fill:url(#linear-gradient-231);}.cls-218{fill:url(#linear-gradient-230);}.cls-219{fill:url(#linear-gradient-209);}.cls-220{fill:url(#linear-gradient-226);}.cls-221{fill:url(#linear-gradient-224);}.cls-222{fill:url(#linear-gradient-225);}.cls-223{fill:url(#linear-gradient-222);}.cls-224{fill:url(#linear-gradient-220);}.cls-225{fill:url(#linear-gradient-221);}.cls-226{fill:url(#linear-gradient-223);}.cls-227{fill:url(#linear-gradient-228);}.cls-228{fill:url(#linear-gradient-229);}.cls-229{fill:url(#linear-gradient-227);}.cls-230{fill:url(#linear-gradient-215);}.cls-231{fill:url(#linear-gradient-212);}.cls-232{fill:url(#linear-gradient-218);}.cls-233{fill:url(#linear-gradient-219);}.cls-234{fill:url(#linear-gradient-216);}.cls-235{fill:url(#linear-gradient-210);}.cls-236{fill:url(#linear-gradient-211);}.cls-237{fill:url(#linear-gradient-217);}.cls-238{fill:url(#linear-gradient-214);}.cls-239{fill:url(#linear-gradient-213);}.cls-240{fill:url(#linear-gradient-208);}.cls-241{fill:url(#linear-gradient-207);}.cls-242{fill:url(#linear-gradient-206);}.cls-243{fill:url(#linear-gradient-205);}.cls-244{fill:url(#linear-gradient-203);}.cls-245{fill:url(#linear-gradient-204);}.cls-246{fill:url(#linear-gradient-201);}.cls-247{fill:url(#linear-gradient-202);}.cls-248{fill:url(#linear-gradient-200);}.cls-249{fill:url(#linear-gradient-190);}.cls-250{fill:url(#linear-gradient-196);}.cls-251{fill:url(#linear-gradient-197);}.cls-252{fill:url(#linear-gradient-192);}.cls-253{fill:url(#linear-gradient-198);}.cls-254{fill:url(#linear-gradient-193);}.cls-255{fill:url(#linear-gradient-191);}.cls-256{fill:url(#linear-gradient-195);}.cls-257{fill:url(#linear-gradient-194);}.cls-258{fill:url(#linear-gradient-189);}.cls-259{fill:url(#linear-gradient-187);}.cls-260{fill:url(#linear-gradient-188);}.cls-261{fill:url(#linear-gradient-186);}.cls-262{fill:url(#linear-gradient-181);}.cls-263{fill:url(#linear-gradient-185);}.cls-264{fill:url(#linear-gradient-184);}.cls-265{fill:url(#linear-gradient-183);}.cls-266{fill:url(#linear-gradient-182);}.cls-267{fill:url(#linear-gradient-180);}.cls-268{fill:url(#linear-gradient-117);}.cls-269{fill:url(#linear-gradient-115);}.cls-270{fill:url(#linear-gradient-113);}.cls-271{fill:url(#linear-gradient-111);}.cls-272{fill:url(#linear-gradient-133);}.cls-273{fill:url(#linear-gradient-139);}.cls-274{fill:url(#linear-gradient-135);}.cls-275{fill:url(#linear-gradient-137);}.cls-276{fill:url(#linear-gradient-131);}.cls-277{fill:url(#linear-gradient-199);}.cls-278{fill:url(#linear-gradient-127);}.cls-279{fill:url(#linear-gradient-119);}.cls-280{fill:#086370;}.cls-281{fill:#5a8891;}.cls-10,.cls-282{fill:#136572;}.cls-283{fill:#91d2c1;}.cls-284{fill:#023a45;}.cls-285{fill:#759ba1;}.cls-286{fill:#35707b;}.cls-287{fill:#64b4ab;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 293.6,
    y1: 189.08,
    x2: 276.81,
    y2: 105.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#fff",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#fff",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#fff",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#fff",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#fff",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 316.03,
    y1: 136.57,
    x2: 332.97,
    y2: 177.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#157597"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#58c1a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#58c1a7",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 309.08,
    y1: 157.42,
    x2: 316.99,
    y2: 170.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#157597"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#58c1a7",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 308.06,
    y1: 120.61,
    x2: 318.06,
    y2: 153.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#157597"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58c1a7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 296.41,
    y1: 221.04,
    x2: 325.93,
    y2: 221.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdba12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed9322"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 310.39,
    y1: 221.08,
    x2: 325.93,
    y2: 221.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 296.42,
    y1: 215.03,
    x2: 325.93,
    y2: 215.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fedd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdb714"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 315.86,
    y1: 203.32,
    x2: 310.48,
    y2: 216.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 299.88,
    y1: 215.03,
    x2: 322.47,
    y2: 215.03,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 301.02,
    y1: 212.28,
    x2: 322.46,
    y2: 212.28,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    y1: 216.93,
    y2: 216.93,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    y1: 216.98,
    y2: 216.98,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    y1: 210.92,
    y2: 210.92,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 315.86,
    y1: 199.21,
    x2: 310.48,
    y2: 212.66,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 299.88,
    y1: 210.92,
    x2: 322.47,
    y2: 210.92,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 301.02,
    y1: 208.17,
    x2: 322.46,
    y2: 208.17,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    y1: 212.82,
    y2: 212.82,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    y1: 212.87,
    y2: 212.87,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    y1: 206.82,
    y2: 206.82,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 315.86,
    y1: 195.1,
    x2: 310.48,
    y2: 208.55,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 299.88,
    y1: 206.82,
    x2: 322.47,
    y2: 206.82,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 301.02,
    y1: 204.07,
    x2: 322.46,
    y2: 204.07,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    y1: 208.72,
    y2: 208.72,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    y1: 208.77,
    y2: 208.77,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    y1: 202.71,
    y2: 202.71,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    y1: 191,
    x2: 310.48,
    y2: 204.45,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 299.88,
    y1: 202.71,
    x2: 322.47,
    y2: 202.71,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 301.02,
    y1: 199.96,
    x2: 322.46,
    y2: 199.96,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    y1: 204.61,
    y2: 204.61,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    y1: 204.66,
    y2: 204.66,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    y1: 198.61,
    y2: 198.61,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 315.86,
    y1: 186.89,
    x2: 310.48,
    y2: 200.34,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 299.88,
    y1: 198.61,
    x2: 322.47,
    y2: 198.61,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 301.02,
    y1: 195.85,
    x2: 322.46,
    y2: 195.85,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    y1: 200.51,
    y2: 200.51,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    y1: 200.55,
    y2: 200.55,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    y1: 194.5,
    y2: 194.5,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 315.86,
    y1: 182.79,
    x2: 310.48,
    y2: 196.24,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 299.88,
    y1: 194.5,
    x2: 322.47,
    y2: 194.5,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 301.02,
    y1: 191.75,
    x2: 322.46,
    y2: 191.75,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    y1: 196.4,
    y2: 196.4,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    y1: 196.45,
    y2: 196.45,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    y1: 190.39,
    y2: 190.39,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 315.86,
    y1: 178.68,
    x2: 310.48,
    y2: 192.13,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 299.88,
    y1: 190.39,
    x2: 322.47,
    y2: 190.39,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 301.02,
    y1: 187.64,
    x2: 322.46,
    y2: 187.64,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    y1: 192.3,
    y2: 192.3,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    y1: 192.34,
    y2: 192.34,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    y1: 186.29,
    y2: 186.29,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 315.86,
    y1: 174.58,
    x2: 310.48,
    y2: 188.03,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 299.88,
    y1: 186.29,
    x2: 322.47,
    y2: 186.29,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 301.02,
    y1: 183.54,
    x2: 322.46,
    y2: 183.54,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    y1: 188.19,
    y2: 188.19,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    y1: 188.24,
    y2: 188.24,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    y1: 182.18,
    y2: 182.18,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 315.86,
    y1: 170.47,
    x2: 310.48,
    y2: 183.92,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 299.88,
    y1: 182.18,
    x2: 322.47,
    y2: 182.18,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 301.02,
    y1: 179.43,
    x2: 322.46,
    y2: 179.43,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    y1: 184.08,
    y2: 184.08,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    y1: 184.13,
    y2: 184.13,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    y1: 178.08,
    y2: 178.08,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 315.86,
    y1: 166.36,
    x2: 310.48,
    y2: 179.81,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 299.88,
    y1: 178.08,
    x2: 322.47,
    y2: 178.08,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 301.02,
    y1: 175.33,
    x2: 322.46,
    y2: 175.33,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    y1: 179.98,
    y2: 179.98,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    y1: 180.03,
    y2: 180.03,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    y1: 173.97,
    y2: 173.97,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 315.86,
    y1: 162.26,
    x2: 310.48,
    y2: 175.71,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 299.88,
    y1: 173.97,
    x2: 322.47,
    y2: 173.97,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 301.02,
    y1: 171.22,
    x2: 322.46,
    y2: 171.22,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 323.27,
    y1: 220.13,
    x2: 352.78,
    y2: 220.13,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 337.24,
    y1: 220.16,
    x2: 352.78,
    y2: 220.16,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 323.28,
    y1: 214.12,
    x2: 352.78,
    y2: 214.12,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 323.28,
    y1: 209.91,
    x2: 352.78,
    y2: 209.91,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 326.73,
    y1: 214.12,
    x2: 349.33,
    y2: 214.12,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 327.03,
    y1: 210.11,
    x2: 348.98,
    y2: 210.11,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 323.27,
    y1: 216.34,
    x2: 352.78,
    y2: 216.34,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 337.24,
    y1: 216.37,
    x2: 352.78,
    y2: 216.37,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 323.28,
    y1: 210.33,
    x2: 352.78,
    y2: 210.33,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 323.28,
    y1: 206.11,
    x2: 352.78,
    y2: 206.11,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 326.73,
    y1: 210.33,
    x2: 349.33,
    y2: 210.33,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 327.03,
    y1: 206.31,
    x2: 348.98,
    y2: 206.31,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 323.27,
    y1: 212.55,
    x2: 352.78,
    y2: 212.55,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 337.24,
    y1: 212.58,
    x2: 352.78,
    y2: 212.58,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 323.28,
    y1: 206.54,
    x2: 352.78,
    y2: 206.54,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 323.28,
    y1: 202.32,
    x2: 352.78,
    y2: 202.32,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 326.73,
    y1: 206.54,
    x2: 349.33,
    y2: 206.54,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 327.03,
    y1: 202.52,
    x2: 348.98,
    y2: 202.52,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 323.27,
    y1: 208.75,
    x2: 352.78,
    y2: 208.75,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 337.24,
    y1: 208.79,
    x2: 352.78,
    y2: 208.79,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 323.28,
    y1: 202.75,
    x2: 352.78,
    y2: 202.75,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 323.28,
    y1: 198.53,
    x2: 352.78,
    y2: 198.53,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 326.73,
    y1: 202.75,
    x2: 349.33,
    y2: 202.75,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 327.03,
    y1: 198.73,
    x2: 348.98,
    y2: 198.73,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 323.27,
    y1: 204.96,
    x2: 352.78,
    y2: 204.96,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 337.24,
    y1: 205,
    x2: 352.78,
    y2: 205,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 323.28,
    y1: 198.96,
    x2: 352.78,
    y2: 198.96,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 323.28,
    y1: 194.74,
    x2: 352.78,
    y2: 194.74,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 326.73,
    y1: 198.96,
    x2: 349.33,
    y2: 198.96,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 327.03,
    y1: 194.94,
    x2: 348.98,
    y2: 194.94,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 323.27,
    y1: 201.17,
    x2: 352.78,
    y2: 201.17,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 337.24,
    y1: 201.21,
    x2: 352.78,
    y2: 201.21,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 323.28,
    y1: 195.17,
    x2: 352.78,
    y2: 195.17,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 323.28,
    y1: 190.95,
    x2: 352.78,
    y2: 190.95,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 326.73,
    y1: 195.17,
    x2: 349.33,
    y2: 195.17,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 327.03,
    y1: 191.15,
    x2: 348.98,
    y2: 191.15,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 323.27,
    y1: 197.38,
    x2: 352.78,
    y2: 197.38,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 337.24,
    y1: 197.42,
    x2: 352.78,
    y2: 197.42,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 323.28,
    y1: 191.38,
    x2: 352.78,
    y2: 191.38,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 323.28,
    y1: 187.16,
    x2: 352.78,
    y2: 187.16,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 326.73,
    y1: 191.38,
    x2: 349.33,
    y2: 191.38,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 327.03,
    y1: 187.36,
    x2: 348.98,
    y2: 187.36,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 323.27,
    y1: 193.59,
    x2: 352.78,
    y2: 193.59,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 337.24,
    y1: 193.63,
    x2: 352.78,
    y2: 193.63,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 323.28,
    y1: 187.58,
    x2: 352.78,
    y2: 187.58,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 323.28,
    y1: 183.37,
    x2: 352.78,
    y2: 183.37,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 326.73,
    y1: 187.58,
    x2: 349.33,
    y2: 187.58,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 327.03,
    y1: 183.57,
    x2: 348.98,
    y2: 183.57,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 323.1,
    y1: 183.36,
    x2: 352.89,
    y2: 183.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 335.4,
    y1: 185.79,
    x2: 322.49,
    y2: 180.46,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 323.71,
    y1: 179.51,
    x2: 352.92,
    y2: 179.51,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 323.72,
    y1: 176.54,
    x2: 352.21,
    y2: 176.54,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 327.13,
    y1: 179.51,
    x2: 349.5,
    y2: 179.51,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 327.13,
    y1: 176.69,
    x2: 347.83,
    y2: 176.69,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 307.7,
    y1: 239.46,
    x2: 337.22,
    y2: 239.46,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 321.68,
    y1: 239.51,
    x2: 337.22,
    y2: 239.51,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 307.71,
    y1: 233.45,
    x2: 337.22,
    y2: 233.45,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 327.15,
    y1: 221.74,
    x2: 321.77,
    y2: 235.19,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 311.17,
    y1: 233.45,
    x2: 333.77,
    y2: 233.45,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 312.32,
    y1: 230.7,
    x2: 333.75,
    y2: 230.7,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 307.7,
    y1: 235.35,
    x2: 337.22,
    y2: 235.35,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 321.68,
    y1: 235.4,
    x2: 337.22,
    y2: 235.4,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 307.71,
    y1: 229.35,
    x2: 337.22,
    y2: 229.35,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 327.15,
    y1: 217.63,
    x2: 321.77,
    y2: 231.08,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 311.17,
    y1: 229.35,
    x2: 333.77,
    y2: 229.35,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 312.32,
    y1: 226.59,
    x2: 333.75,
    y2: 226.59,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 307.7,
    y1: 231.25,
    x2: 337.22,
    y2: 231.25,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 321.68,
    y1: 231.29,
    x2: 337.22,
    y2: 231.29,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 307.71,
    y1: 225.24,
    x2: 337.22,
    y2: 225.24,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 327.15,
    y1: 213.53,
    x2: 321.77,
    y2: 226.98,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 311.17,
    y1: 225.24,
    x2: 333.77,
    y2: 225.24,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 312.32,
    y1: 222.49,
    x2: 333.75,
    y2: 222.49,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 307.7,
    y1: 227.14,
    x2: 337.22,
    y2: 227.14,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 321.68,
    y1: 227.19,
    x2: 337.22,
    y2: 227.19,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 307.71,
    y1: 221.13,
    x2: 337.22,
    y2: 221.13,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 327.15,
    y1: 209.42,
    x2: 321.77,
    y2: 222.87,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 311.17,
    y1: 221.14,
    x2: 333.77,
    y2: 221.14,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 312.32,
    y1: 218.38,
    x2: 333.75,
    y2: 218.38,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 307.7,
    y1: 223.04,
    x2: 337.22,
    y2: 223.04,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 321.68,
    y1: 223.08,
    x2: 337.22,
    y2: 223.08,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 307.71,
    y1: 217.03,
    x2: 337.22,
    y2: 217.03,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 327.15,
    y1: 205.32,
    x2: 321.77,
    y2: 218.77,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 311.17,
    y1: 217.03,
    x2: 333.77,
    y2: 217.03,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 312.32,
    y1: 214.28,
    x2: 333.75,
    y2: 214.28,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 307.7,
    y1: 218.93,
    x2: 337.22,
    y2: 218.93,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 321.68,
    y1: 218.98,
    x2: 337.22,
    y2: 218.98,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 307.71,
    y1: 212.92,
    x2: 337.22,
    y2: 212.92,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 327.15,
    y1: 201.21,
    x2: 321.77,
    y2: 214.66,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 311.17,
    y1: 212.92,
    x2: 333.77,
    y2: 212.92,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 312.32,
    y1: 210.17,
    x2: 333.75,
    y2: 210.17,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 327,
    y1: 170.66,
    x2: 356.64,
    y2: 170.66,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 325.14,
    y1: 167.4,
    x2: 340.82,
    y2: 173.75,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 327.3,
    y1: 164.23,
    x2: 356.74,
    y2: 164.23,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 327.31,
    y1: 162.04,
    x2: 353.31,
    y2: 162.04,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 330.75,
    y1: 164.23,
    x2: 353.29,
    y2: 164.23,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 330.76,
    y1: 161.72,
    x2: 348.97,
    y2: 161.72,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 86.53,
    y1: 95.4,
    x2: 123.81,
    y2: 137.14,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 27.78,
    y1: 123.49,
    x2: 55.83,
    y2: 123.49,
    gradientTransform: "translate(10.16 225.68) rotate(-117.96) scale(1.02 .98) skewX(2.78)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 85.46,
    y1: 70.3,
    x2: 97.23,
    y2: 109.18,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 299.34,
    y1: 226.55,
    x2: 304.29,
    y2: 275.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d4c69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#489390"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 283.92,
    y1: 205.86,
    x2: 303.31,
    y2: 347.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#398186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#317478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f6f73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 322.74,
    y1: 200.53,
    x2: 342.12,
    y2: 341.89,
    xlinkHref: "#linear-gradient-171"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 200.11,
    y1: 107.03,
    x2: 214.94,
    y2: 107.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#becccf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 212.76,
    y1: 148.32,
    x2: 205.28,
    y2: 48.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#137792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ac09a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 175.51,
    y1: 121.27,
    x2: 190.34,
    y2: 121.27,
    xlinkHref: "#linear-gradient-173"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 187.23,
    y1: 150.22,
    x2: 179.76,
    y2: 50.03,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 150.9,
    y1: 135.51,
    x2: 165.73,
    y2: 135.51,
    xlinkHref: "#linear-gradient-173"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 161.7,
    y1: 152.13,
    x2: 154.23,
    y2: 51.93,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 198.11,
    y1: 181.14,
    x2: 243.32,
    y2: 226.35,
    xlinkHref: "#linear-gradient-171"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 235.97,
    y1: 254.27,
    x2: 275.59,
    y2: 209.59,
    xlinkHref: "#linear-gradient-173"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 184.5,
    y1: 208.63,
    x2: 224.12,
    y2: 163.95,
    xlinkHref: "#linear-gradient-173"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 172.48,
    y1: 197.97,
    x2: 212.1,
    y2: 153.29,
    xlinkHref: "#linear-gradient-173"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 60.71,
    y1: 71.91,
    x2: 144.98,
    y2: 212.23,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 181.41,
    y1: 220.71,
    x2: 194,
    y2: 163.52,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 103.28,
    y1: 174.81,
    x2: 157.75,
    y2: 174.81,
    xlinkHref: "#linear-gradient-173"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 288.36,
    y1: 226.01,
    x2: 284.77,
    y2: 245.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16444c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#35707b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 252.86,
    y1: 243.54,
    x2: 243.07,
    y2: 267.35,
    xlinkHref: "#linear-gradient-186"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 92.7,
    y1: 429.74,
    x2: 102.65,
    y2: 228.71,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 32.44,
    y1: 249.71,
    x2: 376.63,
    y2: 225.69,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 71.6,
    y1: 428.69,
    x2: 81.55,
    y2: 227.66,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 33.21,
    y1: 260.83,
    x2: 377.4,
    y2: 236.8,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: 111.03,
    y1: 221.17,
    x2: 121.16,
    y2: 221.17,
    xlinkHref: "#linear-gradient-186"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: 126.24,
    y1: 230.03,
    x2: 136.37,
    y2: 230.03,
    xlinkHref: "#linear-gradient-186"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: 141.45,
    y1: 238.89,
    x2: 151.57,
    y2: 238.89,
    xlinkHref: "#linear-gradient-186"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: 156.66,
    y1: 247.76,
    x2: 166.78,
    y2: 247.76,
    xlinkHref: "#linear-gradient-186"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: 171.87,
    y1: 256.62,
    x2: 181.99,
    y2: 256.62,
    xlinkHref: "#linear-gradient-186"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: 281.5,
    y1: 195.27,
    x2: 281.68,
    y2: 194.55,
    xlinkHref: "#linear-gradient-170"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: 278.75,
    y1: 206.57,
    x2: 298.13,
    y2: 347.92,
    xlinkHref: "#linear-gradient-171"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: 214.1,
    y1: 369.88,
    x2: 191.6,
    y2: 337.47,
    xlinkHref: "#linear-gradient-170"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: 178.78,
    y1: 276.94,
    x2: 178.78,
    y2: 228.88,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: 144.19,
    y1: 432.28,
    x2: 154.13,
    y2: 231.25,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: 34.71,
    y1: 282.23,
    x2: 378.9,
    y2: 258.2,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: 157,
    y1: 276.94,
    x2: 157,
    y2: 228.88,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: 123.09,
    y1: 431.24,
    x2: 133.03,
    y2: 230.21,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: 35.48,
    y1: 293.34,
    x2: 379.67,
    y2: 269.32,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: 288.1,
    y1: 232.49,
    x2: 302.79,
    y2: 265.43,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: 327.32,
    y1: 266.52,
    x2: 332.43,
    y2: 221.72,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 321.18,
    y1: 247.74,
    x2: 335.31,
    y2: 247.74,
    xlinkHref: "#linear-gradient-173"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 298.12,
    y1: 228.02,
    x2: 312.81,
    y2: 260.96,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: 162.12,
    y1: 213.43,
    x2: 194.38,
    y2: 246.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#aab7ba"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: 205.11,
    y1: 226.91,
    x2: 244.74,
    y2: 182.23,
    xlinkHref: "#linear-gradient-173"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: 186.47,
    y1: 189.55,
    x2: 218.74,
    y2: 222.46,
    xlinkHref: "#linear-gradient-210"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: 213.31,
    y1: 234.18,
    x2: 252.94,
    y2: 189.5,
    xlinkHref: "#linear-gradient-173"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: 210.83,
    y1: 165.67,
    x2: 243.1,
    y2: 198.57,
    xlinkHref: "#linear-gradient-210"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: 221.52,
    y1: 241.46,
    x2: 261.14,
    y2: 196.78,
    xlinkHref: "#linear-gradient-173"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: 140.59,
    y1: 196.88,
    x2: 137.14,
    y2: 126.39,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: 128.42,
    y1: 129.76,
    x2: 158.08,
    y2: 129.76,
    xlinkHref: "#linear-gradient-170"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: 118.31,
    y1: 179.53,
    x2: 65.83,
    y2: 199.83,
    xlinkHref: "#linear-gradient-170"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    x1: 97.06,
    y1: 192.2,
    x2: 34.64,
    y2: 252.04,
    xlinkHref: "#linear-gradient-170"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    x1: 121.25,
    y1: 132.73,
    x2: 131.27,
    y2: 102,
    xlinkHref: "#linear-gradient-170"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: 105.98,
    y1: 369.74,
    x2: 102.53,
    y2: 299.25,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    x1: 93.8,
    y1: 302.62,
    x2: 123.46,
    y2: 302.62,
    xlinkHref: "#linear-gradient-170"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    x1: 83.69,
    y1: 352.39,
    x2: 31.21,
    y2: 372.69,
    xlinkHref: "#linear-gradient-170"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-224",
    x1: 62.44,
    y1: 365.06,
    x2: 0.02,
    y2: 424.9,
    xlinkHref: "#linear-gradient-170"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    x1: 86.64,
    y1: 305.59,
    x2: 96.65,
    y2: 274.86,
    xlinkHref: "#linear-gradient-170"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    x1: 97.81,
    y1: 255.73,
    x2: 95.88,
    y2: 227.07,
    xlinkHref: "#linear-gradient-174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    x1: 175.79,
    y1: 427.91,
    x2: 213.82,
    y2: 427.91,
    gradientTransform: "translate(-132.55 788.93) rotate(-119.29) skewX(9.56)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    x1: 100.84,
    y1: 348.48,
    x2: 113.64,
    y2: 345.19,
    gradientTransform: "translate(-26.45 -18.51) rotate(-2.9) scale(.93 1.07) skewX(2.59)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    x1: 108.01,
    y1: 317.56,
    x2: 93.24,
    y2: 369.52,
    gradientTransform: "translate(-26.45 -18.51) rotate(-2.9) scale(.93 1.07) skewX(2.59)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    x1: 191,
    y1: 421.32,
    x2: 216.36,
    y2: 421.32,
    gradientTransform: "translate(-132.55 788.93) rotate(-119.29) skewX(9.56)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-231",
    x1: 135.06,
    y1: 136.4,
    x2: 135.69,
    y2: 116.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#eeb023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf7721"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 256.27,
    y: 113.83,
    width: 16,
    height: 18.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M258.42,123.01c0-1.28.1-2.37.31-3.28.21-.91.48-1.67.81-2.28.33-.62.71-1.11,1.13-1.48.42-.37.85-.65,1.28-.85s.85-.32,1.26-.38c.4-.06.76-.09,1.06-.09s.66.03,1.06.09c.4.06.82.19,1.26.38s.86.47,1.28.85c.42.37.8.87,1.13,1.48.33.62.61,1.38.81,2.28.21.91.31,2,.31,3.28s-.1,2.37-.31,3.28c-.21.91-.48,1.67-.81,2.28s-.71,1.11-1.13,1.48c-.42.37-.85.66-1.28.85-.43.19-.85.32-1.26.38-.4.06-.76.09-1.06.09s-.66-.03-1.06-.09c-.4-.06-.82-.19-1.26-.38-.43-.19-.86-.47-1.28-.85-.42-.37-.8-.87-1.13-1.48s-.61-1.38-.81-2.28c-.21-.91-.31-2-.31-3.28ZM261.16,123.01c0,.5.03,1.09.1,1.75.07.66.21,1.29.42,1.88.21.59.53,1.1.94,1.51s.96.62,1.65.62,1.23-.21,1.65-.62c.41-.41.72-.91.94-1.51.21-.59.35-1.22.42-1.88.07-.66.1-1.25.1-1.75s-.03-1.08-.1-1.75c-.07-.66-.21-1.29-.42-1.88-.21-.59-.53-1.1-.94-1.51s-.96-.62-1.65-.62-1.23.21-1.65.62c-.41.41-.72.91-.94,1.51-.21.59-.35,1.22-.42,1.88-.07.66-.1,1.25-.1,1.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 275.36,
    y: 155.29,
    width: 16,
    height: 18.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M277.51,164.48c0-1.28.1-2.37.31-3.28.21-.91.48-1.67.81-2.28.33-.62.71-1.11,1.13-1.48.42-.37.85-.65,1.28-.85s.85-.32,1.26-.38c.4-.06.76-.09,1.06-.09s.66.03,1.06.09c.4.06.82.19,1.26.38s.86.47,1.28.85c.42.37.8.87,1.13,1.48.33.62.61,1.38.81,2.28.21.91.31,2,.31,3.28s-.1,2.37-.31,3.28c-.21.91-.48,1.67-.81,2.28s-.71,1.11-1.13,1.48c-.42.37-.85.66-1.28.85-.43.19-.85.32-1.26.38-.4.06-.76.09-1.06.09s-.66-.03-1.06-.09c-.4-.06-.82-.19-1.26-.38-.43-.19-.86-.47-1.28-.85-.42-.37-.8-.87-1.13-1.48s-.61-1.38-.81-2.28c-.21-.91-.31-2-.31-3.28ZM280.25,164.48c0,.5.03,1.09.1,1.75.07.66.21,1.29.42,1.88.21.59.53,1.1.94,1.51s.96.62,1.65.62,1.23-.21,1.65-.62c.41-.41.72-.91.94-1.51.21-.59.35-1.22.42-1.88.07-.66.1-1.25.1-1.75s-.03-1.08-.1-1.75c-.07-.66-.21-1.29-.42-1.88-.21-.59-.53-1.1-.94-1.51s-.96-.62-1.65-.62-1.23.21-1.65.62c-.41.41-.72.91-.94,1.51-.21.59-.35,1.22-.42,1.88-.07.66-.1,1.25-.1,1.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 315.08,
    y: 131.62,
    width: 6.75,
    height: 7.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M315.99,135.5c0-.54.04-1,.13-1.38.09-.38.2-.7.34-.96.14-.26.3-.47.48-.63.18-.16.36-.28.54-.36s.36-.13.53-.16c.17-.03.32-.04.45-.04s.28.01.45.04c.17.03.35.08.53.16s.36.2.54.36c.18.16.34.37.48.63.14.26.26.58.34.96.09.38.13.84.13,1.38s-.04,1-.13,1.38c-.09.38-.2.7-.34.96-.14.26-.3.47-.48.63-.18.16-.36.28-.54.36-.18.08-.36.13-.53.16-.17.03-.32.04-.45.04s-.28-.01-.45-.04c-.17-.03-.35-.08-.53-.16-.18-.08-.36-.2-.54-.36-.18-.16-.34-.37-.48-.63-.14-.26-.26-.58-.34-.96-.09-.38-.13-.84-.13-1.38ZM317.15,135.5c0,.21.01.46.04.74.03.28.09.54.18.8.09.25.22.46.4.64.17.17.4.26.69.26s.52-.09.69-.26.31-.39.4-.64.15-.52.18-.8c.03-.28.04-.53.04-.74s-.01-.46-.04-.74c-.03-.28-.09-.54-.18-.8-.09-.25-.22-.46-.4-.64s-.41-.26-.69-.26-.52.09-.69.26c-.17.17-.31.39-.4.64-.09.25-.15.52-.18.8-.03.28-.04.53-.04.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 280.43,
    y: 102.57,
    width: 6.75,
    height: 7.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M281.34,106.44c0-.54.04-1,.13-1.38.09-.38.2-.7.34-.96.14-.26.3-.47.48-.63.18-.16.36-.28.54-.36s.36-.13.53-.16c.17-.03.32-.04.45-.04s.28.01.45.04c.17.03.35.08.53.16s.36.2.54.36c.18.16.34.37.48.63.14.26.26.58.34.96.09.38.13.84.13,1.38s-.04,1-.13,1.38c-.09.38-.2.7-.34.96-.14.26-.3.47-.48.63-.18.16-.36.28-.54.36-.18.08-.36.13-.53.16-.17.03-.32.04-.45.04s-.28-.01-.45-.04c-.17-.03-.35-.08-.53-.16-.18-.08-.36-.2-.54-.36-.18-.16-.34-.37-.48-.63-.14-.26-.26-.58-.34-.96-.09-.38-.13-.84-.13-1.38ZM282.5,106.44c0,.21.01.46.04.74.03.28.09.54.18.8.09.25.22.46.4.64.17.17.4.26.69.26s.52-.09.69-.26.31-.39.4-.64.15-.52.18-.8c.03-.28.04-.53.04-.74s-.01-.46-.04-.74c-.03-.28-.09-.54-.18-.8-.09-.25-.22-.46-.4-.64s-.41-.26-.69-.26-.52.09-.69.26c-.17.17-.31.39-.4.64-.09.25-.15.52-.18.8-.03.28-.04.53-.04.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 322.12,
    y: 106.4,
    width: 6.75,
    height: 7.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M323.02,110.28c0-.54.04-1,.13-1.38.09-.38.2-.7.34-.96.14-.26.3-.47.48-.63.18-.16.36-.28.54-.36s.36-.13.53-.16c.17-.03.32-.04.45-.04s.28.01.45.04c.17.03.35.08.53.16s.36.2.54.36c.18.16.34.37.48.63.14.26.26.58.34.96.09.38.13.84.13,1.38s-.04,1-.13,1.38c-.09.38-.2.7-.34.96-.14.26-.3.47-.48.63-.18.16-.36.28-.54.36-.18.08-.36.13-.53.16-.17.03-.32.04-.45.04s-.28-.01-.45-.04c-.17-.03-.35-.08-.53-.16-.18-.08-.36-.2-.54-.36-.18-.16-.34-.37-.48-.63-.14-.26-.26-.58-.34-.96-.09-.38-.13-.84-.13-1.38ZM324.18,110.28c0,.21.01.46.04.74.03.28.09.54.18.8.09.25.22.46.4.64.17.17.4.26.69.26s.52-.09.69-.26.31-.39.4-.64.15-.52.18-.8c.03-.28.04-.53.04-.74s-.01-.46-.04-.74c-.03-.28-.09-.54-.18-.8-.09-.25-.22-.46-.4-.64s-.41-.26-.69-.26-.52.09-.69.26c-.17.17-.31.39-.4.64-.09.25-.15.52-.18.8-.03.28-.04.53-.04.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 301.77,
    y: 160.54,
    width: 6.75,
    height: 7.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M302.68,164.42c0-.54.04-1,.13-1.38.09-.38.2-.7.34-.96.14-.26.3-.47.48-.63.18-.16.36-.28.54-.36s.36-.13.53-.16c.17-.03.32-.04.45-.04s.28.01.45.04c.17.03.35.08.53.16s.36.2.54.36c.18.16.34.37.48.63.14.26.26.58.34.96.09.38.13.84.13,1.38s-.04,1-.13,1.38c-.09.38-.2.7-.34.96-.14.26-.3.47-.48.63-.18.16-.36.28-.54.36-.18.08-.36.13-.53.16-.17.03-.32.04-.45.04s-.28-.01-.45-.04c-.17-.03-.35-.08-.53-.16-.18-.08-.36-.2-.54-.36-.18-.16-.34-.37-.48-.63-.14-.26-.26-.58-.34-.96-.09-.38-.13-.84-.13-1.38ZM303.84,164.42c0,.21.01.46.04.74.03.28.09.54.18.8.09.25.22.46.4.64.17.17.4.26.69.26s.52-.09.69-.26.31-.39.4-.64.15-.52.18-.8c.03-.28.04-.53.04-.74s-.01-.46-.04-.74c-.03-.28-.09-.54-.18-.8-.09-.25-.22-.46-.4-.64s-.41-.26-.69-.26-.52.09-.69.26c-.17.17-.31.39-.4.64-.09.25-.15.52-.18.8-.03.28-.04.53-.04.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 298.1,
    y: 105.57,
    width: 16,
    height: 18.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M300.26,114.76c0-1.28.1-2.37.31-3.28.21-.91.48-1.67.81-2.28.33-.62.71-1.11,1.13-1.48.42-.37.85-.65,1.28-.85s.85-.32,1.26-.38c.4-.06.76-.09,1.06-.09s.66.03,1.06.09c.4.06.82.19,1.26.38s.86.47,1.28.85c.42.37.8.87,1.13,1.48.33.62.61,1.38.81,2.28.21.91.31,2,.31,3.28s-.1,2.37-.31,3.28c-.21.91-.48,1.67-.81,2.28s-.71,1.11-1.13,1.48c-.42.37-.85.66-1.28.85-.43.19-.85.32-1.26.38-.4.06-.76.09-1.06.09s-.66-.03-1.06-.09c-.4-.06-.82-.19-1.26-.38-.43-.19-.86-.47-1.28-.85-.42-.37-.8-.87-1.13-1.48s-.61-1.38-.81-2.28c-.21-.91-.31-2-.31-3.28ZM303,114.76c0,.5.03,1.09.1,1.75.07.66.21,1.29.42,1.88.21.59.53,1.1.94,1.51s.96.62,1.65.62,1.23-.21,1.65-.62c.41-.41.72-.91.94-1.51.21-.59.35-1.22.42-1.88.07-.66.1-1.25.1-1.75s-.03-1.08-.1-1.75c-.07-.66-.21-1.29-.42-1.88-.21-.59-.53-1.1-.94-1.51s-.96-.62-1.65-.62-1.23.21-1.65.62c-.41.41-.72.91-.94,1.51-.21.59-.35,1.22-.42,1.88-.07.66-.1,1.25-.1,1.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 282.1,
    y: 129.84,
    width: 6.21,
    height: 7.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M284.96,131.49l-1.18,1.09-.62-.74,1.9-1.58h.97v6.28h-1.06v-5.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 300.8,
    y: 139.24,
    width: 12.39,
    height: 14.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M306.5,142.53l-2.35,2.18-1.24-1.47,3.79-3.15h1.93v12.53h-2.12v-10.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 238.77,
    y: 143.05,
    width: 19.25,
    height: 21.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M247.63,148.16l-3.66,3.38-1.92-2.28,5.88-4.89h3v19.46h-3.3v-15.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 267.01,
    y: 139.93,
    width: 8.33,
    height: 9.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M270.84,142.14l-1.58,1.46-.83-.99,2.55-2.12h1.3v8.42h-1.43v-6.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 332.91,
    y: 126.65,
    width: 8.33,
    height: 9.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M336.75,128.86l-1.58,1.46-.83-.99,2.55-2.12h1.3v8.42h-1.43v-6.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 233.08,
    y: 114.65,
    width: 104.25,
    height: 65.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "331.31 172.41 315.89 181.63 316.04 153.21 310.9 156.28 321.29 131.2 336.61 140.92 331.47 143.99 331.31 172.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "315.89 181.63 313.32 180.02 313.44 154.77 316.04 153.21 315.89 181.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "310.9 156.28 308.35 154.69 319.24 129.91 321.29 131.2 310.9 156.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M325.93,215.07v3.51c-.02,2.17-1.44,4.34-4.3,6-5.74,3.34-15.09,3.34-20.87,0-2.91-1.68-4.36-3.89-4.36-6.09v-3.51c0,2.2,1.46,4.41,4.37,6.09,5.78,3.34,15.12,3.34,20.87,0,2.85-1.66,4.28-3.83,4.29-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M321.64,221.08c-3.08,1.79-7.21,2.61-11.26,2.48v3.51c4.05.13,8.17-.69,11.25-2.48,2.85-1.66,4.28-3.83,4.29-6v-3.51c0,2.17-1.42,4.34-4.28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M321.58,208.98c-5.78-3.34-15.13-3.34-20.87,0-5.74,3.34-5.71,8.75.07,12.09,5.78,3.34,15.12,3.34,20.87,0,5.74-3.34,5.71-8.75-.06-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M321.58,208.98c-5.78-3.34-15.13-3.34-20.87,0-2.13,1.24-3.46,2.76-4,4.35l27.97,5.15c2.38-3.14,1.35-6.93-3.1-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M300.78,221.32c5.78,3.34,15.12,3.34,20.87,0,2.87-1.67,4.3-3.85,4.29-6.04h0s0-.08,0-.11c-.05,2.14-1.47,4.26-4.28,5.9-5.74,3.34-15.09,3.34-20.87,0-2.85-1.64-4.29-3.79-4.35-5.94-.05,2.24,1.39,4.49,4.35,6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M319.14,210.21c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M319.14,210.4c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M301.02,212.15l21.3,3.92c.54-2-.51-4.12-3.18-5.67-4.43-2.56-11.58-2.55-15.98,0-.9.52-1.61,1.12-2.14,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M303.27,211.07c4.4-2.55,11.55-2.56,15.98,0,1.81,1.05,2.88,2.36,3.21,3.73-.11-1.6-1.2-3.18-3.31-4.39-4.43-2.56-11.58-2.55-15.98,0-2.59,1.51-3.64,3.56-3.16,5.52-.12-1.75.96-3.52,3.26-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M315.55,213.34l1.45-.84-1.35-.78-1.5.87c-1.47-.58-2.99-.59-4.08.04-2.52,1.46,2.01,3.2.75,3.93-.41.24-.98.15-1.55-.17-.75-.43-1.42-1.32-1.52-2.11l-2.09.4c.11.69.61,1.42,1.39,2.03l-1.57.91,1.35.78,1.53-.89c1.49.68,3.21.83,4.46.1,2.57-1.49-1.9-3.26-.68-3.98.34-.2.83-.12,1.3.15.58.34,1.23,1.06,1.54,1.75l2.09-.42c-.21-.58-.77-1.23-1.53-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M325.93,210.96v3.51c-.02,2.17-1.44,4.34-4.3,6-5.74,3.34-15.09,3.34-20.87,0-2.91-1.68-4.36-3.89-4.36-6.09v-3.51c0,2.2,1.46,4.41,4.37,6.09,5.78,3.34,15.12,3.34,20.87,0,2.85-1.66,4.28-3.83,4.29-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M321.64,216.98c-3.08,1.79-7.21,2.61-11.26,2.48v3.51c4.05.13,8.17-.69,11.25-2.48,2.85-1.66,4.28-3.83,4.29-6v-3.51c0,2.17-1.42,4.34-4.28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M321.58,204.88c-5.78-3.34-15.13-3.34-20.87,0-5.74,3.34-5.71,8.75.07,12.09,5.78,3.34,15.12,3.34,20.87,0,5.74-3.34,5.71-8.75-.06-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M321.58,204.88c-5.78-3.34-15.13-3.34-20.87,0-2.13,1.24-3.46,2.76-4,4.35l27.97,5.15c2.38-3.14,1.35-6.93-3.1-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M300.78,217.22c5.78,3.34,15.12,3.34,20.87,0,2.87-1.67,4.3-3.85,4.29-6.04h0s0-.08,0-.11c-.05,2.14-1.47,4.26-4.28,5.9-5.74,3.34-15.09,3.34-20.87,0-2.85-1.64-4.29-3.79-4.35-5.94-.05,2.24,1.39,4.49,4.35,6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M319.14,206.1c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M319.14,206.3c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M301.02,208.04l21.3,3.92c.54-2-.51-4.12-3.18-5.67-4.43-2.56-11.58-2.55-15.98,0-.9.52-1.61,1.12-2.14,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M303.27,206.96c4.4-2.55,11.55-2.56,15.98,0,1.81,1.05,2.88,2.36,3.21,3.73-.11-1.6-1.2-3.18-3.31-4.39-4.43-2.56-11.58-2.55-15.98,0-2.59,1.51-3.64,3.56-3.16,5.52-.12-1.75.96-3.52,3.26-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M315.55,209.23l1.45-.84-1.35-.78-1.5.87c-1.47-.58-2.99-.59-4.08.04-2.52,1.46,2.01,3.2.75,3.93-.41.24-.98.15-1.55-.17-.75-.43-1.42-1.32-1.52-2.11l-2.09.4c.11.69.61,1.42,1.39,2.03l-1.57.91,1.35.78,1.53-.89c1.49.68,3.21.83,4.46.1,2.57-1.49-1.9-3.26-.68-3.98.34-.2.83-.12,1.3.15.58.34,1.23,1.06,1.54,1.75l2.09-.42c-.21-.58-.77-1.23-1.53-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M325.93,206.86v3.51c-.02,2.17-1.44,4.34-4.3,6-5.74,3.34-15.09,3.34-20.87,0-2.91-1.68-4.36-3.89-4.36-6.09v-3.51c0,2.2,1.46,4.41,4.37,6.09,5.78,3.34,15.12,3.34,20.87,0,2.85-1.66,4.28-3.83,4.29-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M321.64,212.87c-3.08,1.79-7.21,2.61-11.26,2.48v3.51c4.05.13,8.17-.69,11.25-2.48,2.85-1.66,4.28-3.83,4.29-6v-3.51c0,2.17-1.42,4.34-4.28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M321.58,200.77c-5.78-3.34-15.13-3.34-20.87,0-5.74,3.34-5.71,8.75.07,12.09,5.78,3.34,15.12,3.34,20.87,0,5.74-3.34,5.71-8.75-.06-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M321.58,200.77c-5.78-3.34-15.13-3.34-20.87,0-2.13,1.24-3.46,2.76-4,4.35l27.97,5.15c2.38-3.14,1.35-6.93-3.1-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M300.78,213.11c5.78,3.34,15.12,3.34,20.87,0,2.87-1.67,4.3-3.85,4.29-6.04h0s0-.08,0-.11c-.05,2.14-1.47,4.26-4.28,5.9-5.74,3.34-15.09,3.34-20.87,0-2.85-1.64-4.29-3.79-4.35-5.94-.05,2.24,1.39,4.49,4.35,6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M319.14,202c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M319.14,202.19c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M301.02,203.94l21.3,3.92c.54-2-.51-4.12-3.18-5.67-4.43-2.56-11.58-2.55-15.98,0-.9.52-1.61,1.12-2.14,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M303.27,202.86c4.4-2.55,11.55-2.56,15.98,0,1.81,1.05,2.88,2.36,3.21,3.73-.11-1.6-1.2-3.18-3.31-4.39-4.43-2.56-11.58-2.55-15.98,0-2.59,1.51-3.64,3.56-3.16,5.52-.12-1.75.96-3.52,3.26-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M315.55,205.13l1.45-.84-1.35-.78-1.5.87c-1.47-.58-2.99-.59-4.08.04-2.52,1.46,2.01,3.2.75,3.93-.41.24-.98.15-1.55-.17-.75-.43-1.42-1.32-1.52-2.11l-2.09.4c.11.69.61,1.42,1.39,2.03l-1.57.91,1.35.78,1.53-.89c1.49.68,3.21.83,4.46.1,2.57-1.49-1.9-3.26-.68-3.98.34-.2.83-.12,1.3.15.58.34,1.23,1.06,1.54,1.75l2.09-.42c-.21-.58-.77-1.23-1.53-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M325.93,202.75v3.51c-.02,2.17-1.44,4.34-4.3,6-5.74,3.34-15.09,3.34-20.87,0-2.91-1.68-4.36-3.89-4.36-6.09v-3.51c0,2.2,1.46,4.41,4.37,6.09,5.78,3.34,15.12,3.34,20.87,0,2.85-1.66,4.28-3.83,4.29-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M321.64,208.77c-3.08,1.79-7.21,2.61-11.26,2.48v3.51c4.05.13,8.17-.69,11.25-2.48,2.85-1.66,4.28-3.83,4.29-6v-3.51c0,2.17-1.42,4.34-4.28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M321.58,196.67c-5.78-3.34-15.13-3.34-20.87,0-5.74,3.34-5.71,8.75.07,12.09,5.78,3.34,15.12,3.34,20.87,0,5.74-3.34,5.71-8.75-.06-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M321.58,196.67c-5.78-3.34-15.13-3.34-20.87,0-2.13,1.24-3.46,2.76-4,4.35l27.97,5.15c2.38-3.14,1.35-6.93-3.1-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M300.78,209.01c5.78,3.34,15.12,3.34,20.87,0,2.87-1.67,4.3-3.85,4.29-6.04h0s0-.08,0-.11c-.05,2.14-1.47,4.26-4.28,5.9-5.74,3.34-15.09,3.34-20.87,0-2.85-1.64-4.29-3.79-4.35-5.94-.05,2.24,1.39,4.49,4.35,6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M319.14,197.89c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M319.14,198.08c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M301.02,199.83l21.3,3.92c.54-2-.51-4.12-3.18-5.67-4.43-2.56-11.58-2.55-15.98,0-.9.52-1.61,1.12-2.14,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M303.27,198.75c4.4-2.55,11.55-2.56,15.98,0,1.81,1.05,2.88,2.36,3.21,3.73-.11-1.6-1.2-3.18-3.31-4.39-4.43-2.56-11.58-2.55-15.98,0-2.59,1.51-3.64,3.56-3.16,5.52-.12-1.75.96-3.52,3.26-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M315.55,201.02l1.45-.84-1.35-.78-1.5.87c-1.47-.58-2.99-.59-4.08.04-2.52,1.46,2.01,3.2.75,3.93-.41.24-.98.15-1.55-.17-.75-.43-1.42-1.32-1.52-2.11l-2.09.4c.11.69.61,1.42,1.39,2.03l-1.57.91,1.35.78,1.53-.89c1.49.68,3.21.83,4.46.1,2.57-1.49-1.9-3.26-.68-3.98.34-.2.83-.12,1.3.15.58.34,1.23,1.06,1.54,1.75l2.09-.42c-.21-.58-.77-1.23-1.53-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M325.93,198.65v3.51c-.02,2.17-1.44,4.34-4.3,6-5.74,3.34-15.09,3.34-20.87,0-2.91-1.68-4.36-3.89-4.36-6.09v-3.51c0,2.2,1.46,4.41,4.37,6.09,5.78,3.34,15.12,3.34,20.87,0,2.85-1.66,4.28-3.83,4.29-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M321.64,204.66c-3.08,1.79-7.21,2.61-11.26,2.48v3.51c4.05.13,8.17-.69,11.25-2.48,2.85-1.66,4.28-3.83,4.29-6v-3.51c0,2.17-1.42,4.34-4.28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M321.58,192.56c-5.78-3.34-15.13-3.34-20.87,0-5.74,3.34-5.71,8.75.07,12.09,5.78,3.34,15.12,3.34,20.87,0,5.74-3.34,5.71-8.75-.06-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M321.58,192.56c-5.78-3.34-15.13-3.34-20.87,0-2.13,1.24-3.46,2.76-4,4.35l27.97,5.15c2.38-3.14,1.35-6.93-3.1-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M300.78,204.9c5.78,3.34,15.12,3.34,20.87,0,2.87-1.67,4.3-3.85,4.29-6.04h0s0-.08,0-.11c-.05,2.14-1.47,4.26-4.28,5.9-5.74,3.34-15.09,3.34-20.87,0-2.85-1.64-4.29-3.79-4.35-5.94-.05,2.24,1.39,4.49,4.35,6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M319.14,193.79c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M319.14,193.98c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M301.02,195.73l21.3,3.92c.54-2-.51-4.12-3.18-5.67-4.43-2.56-11.58-2.55-15.98,0-.9.52-1.61,1.12-2.14,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M303.27,194.65c4.4-2.55,11.55-2.56,15.98,0,1.81,1.05,2.88,2.36,3.21,3.73-.11-1.6-1.2-3.18-3.31-4.39-4.43-2.56-11.58-2.55-15.98,0-2.59,1.51-3.64,3.56-3.16,5.52-.12-1.75.96-3.52,3.26-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M315.55,196.92l1.45-.84-1.35-.78-1.5.87c-1.47-.58-2.99-.59-4.08.04-2.52,1.46,2.01,3.2.75,3.93-.41.24-.98.15-1.55-.17-.75-.43-1.42-1.32-1.52-2.11l-2.09.4c.11.69.61,1.42,1.39,2.03l-1.57.91,1.35.78,1.53-.89c1.49.68,3.21.83,4.46.1,2.57-1.49-1.9-3.26-.68-3.98.34-.2.83-.12,1.3.15.58.34,1.23,1.06,1.54,1.75l2.09-.42c-.21-.58-.77-1.23-1.53-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M325.93,194.54v3.51c-.02,2.17-1.44,4.34-4.3,6-5.74,3.34-15.09,3.34-20.87,0-2.91-1.68-4.36-3.89-4.36-6.09v-3.51c0,2.2,1.46,4.41,4.37,6.09,5.78,3.34,15.12,3.34,20.87,0,2.85-1.66,4.28-3.83,4.29-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M321.64,200.55c-3.08,1.79-7.21,2.61-11.26,2.48v3.51c4.05.13,8.17-.69,11.25-2.48,2.85-1.66,4.28-3.83,4.29-6v-3.51c0,2.17-1.42,4.34-4.28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M321.58,188.46c-5.78-3.34-15.13-3.34-20.87,0-5.74,3.34-5.71,8.75.07,12.09,5.78,3.34,15.12,3.34,20.87,0,5.74-3.34,5.71-8.75-.06-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M321.58,188.46c-5.78-3.34-15.13-3.34-20.87,0-2.13,1.24-3.46,2.76-4,4.35l27.97,5.15c2.38-3.14,1.35-6.93-3.1-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M300.78,200.79c5.78,3.34,15.12,3.34,20.87,0,2.87-1.67,4.3-3.85,4.29-6.04h0s0-.08,0-.11c-.05,2.14-1.47,4.26-4.28,5.9-5.74,3.34-15.09,3.34-20.87,0-2.85-1.64-4.29-3.79-4.35-5.94-.05,2.24,1.39,4.49,4.35,6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M319.14,189.68c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M319.14,189.87c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M301.02,191.62l21.3,3.92c.54-2-.51-4.12-3.18-5.67-4.43-2.56-11.58-2.55-15.98,0-.9.52-1.61,1.12-2.14,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M303.27,190.54c4.4-2.55,11.55-2.56,15.98,0,1.81,1.05,2.88,2.36,3.21,3.73-.11-1.6-1.2-3.18-3.31-4.39-4.43-2.56-11.58-2.55-15.98,0-2.59,1.51-3.64,3.56-3.16,5.52-.12-1.75.96-3.52,3.26-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M315.55,192.81l1.45-.84-1.35-.78-1.5.87c-1.47-.58-2.99-.59-4.08.04-2.52,1.46,2.01,3.2.75,3.93-.41.24-.98.15-1.55-.17-.75-.43-1.42-1.32-1.52-2.11l-2.09.4c.11.69.61,1.42,1.39,2.03l-1.57.91,1.35.78,1.53-.89c1.49.68,3.21.83,4.46.1,2.57-1.49-1.9-3.26-.68-3.98.34-.2.83-.12,1.3.15.58.34,1.23,1.06,1.54,1.75l2.09-.42c-.21-.58-.77-1.23-1.53-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M325.93,190.43v3.51c-.02,2.17-1.44,4.34-4.3,6-5.74,3.34-15.09,3.34-20.87,0-2.91-1.68-4.36-3.89-4.36-6.09v-3.51c0,2.2,1.46,4.41,4.37,6.09,5.78,3.34,15.12,3.34,20.87,0,2.85-1.66,4.28-3.83,4.29-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M321.64,196.45c-3.08,1.79-7.21,2.61-11.26,2.48v3.51c4.05.13,8.17-.69,11.25-2.48,2.85-1.66,4.28-3.83,4.29-6v-3.51c0,2.17-1.42,4.34-4.28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M321.58,184.35c-5.78-3.34-15.13-3.34-20.87,0-5.74,3.34-5.71,8.75.07,12.09,5.78,3.34,15.12,3.34,20.87,0,5.74-3.34,5.71-8.75-.06-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M321.58,184.35c-5.78-3.34-15.13-3.34-20.87,0-2.13,1.24-3.46,2.76-4,4.35l27.97,5.15c2.38-3.14,1.35-6.93-3.1-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M300.78,196.69c5.78,3.34,15.12,3.34,20.87,0,2.87-1.67,4.3-3.85,4.29-6.04h0s0-.08,0-.11c-.05,2.14-1.47,4.26-4.28,5.9-5.74,3.34-15.09,3.34-20.87,0-2.85-1.64-4.29-3.79-4.35-5.94-.05,2.24,1.39,4.49,4.35,6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M319.14,185.58c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M319.14,185.77c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M301.02,187.52l21.3,3.92c.54-2-.51-4.12-3.18-5.67-4.43-2.56-11.58-2.55-15.98,0-.9.52-1.61,1.12-2.14,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M303.27,186.43c4.4-2.55,11.55-2.56,15.98,0,1.81,1.05,2.88,2.36,3.21,3.73-.11-1.6-1.2-3.18-3.31-4.39-4.43-2.56-11.58-2.55-15.98,0-2.59,1.51-3.64,3.56-3.16,5.52-.12-1.75.96-3.52,3.26-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M315.55,188.71l1.45-.84-1.35-.78-1.5.87c-1.47-.58-2.99-.59-4.08.04-2.52,1.46,2.01,3.2.75,3.93-.41.24-.98.15-1.55-.17-.75-.43-1.42-1.32-1.52-2.11l-2.09.4c.11.69.61,1.42,1.39,2.03l-1.57.91,1.35.78,1.53-.89c1.49.68,3.21.83,4.46.1,2.57-1.49-1.9-3.26-.68-3.98.34-.2.83-.12,1.3.15.58.34,1.23,1.06,1.54,1.75l2.09-.42c-.21-.58-.77-1.23-1.53-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M325.93,186.33v3.51c-.02,2.17-1.44,4.34-4.3,6-5.74,3.34-15.09,3.34-20.87,0-2.91-1.68-4.36-3.89-4.36-6.09v-3.51c0,2.2,1.46,4.41,4.37,6.09,5.78,3.34,15.12,3.34,20.87,0,2.85-1.66,4.28-3.83,4.29-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M321.64,192.34c-3.08,1.79-7.21,2.61-11.26,2.48v3.51c4.05.13,8.17-.69,11.25-2.48,2.85-1.66,4.28-3.83,4.29-6v-3.51c0,2.17-1.42,4.34-4.28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M321.58,180.25c-5.78-3.34-15.13-3.34-20.87,0-5.74,3.34-5.71,8.75.07,12.09,5.78,3.34,15.12,3.34,20.87,0,5.74-3.34,5.71-8.75-.06-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M321.58,180.25c-5.78-3.34-15.13-3.34-20.87,0-2.13,1.24-3.46,2.76-4,4.35l27.97,5.15c2.38-3.14,1.35-6.93-3.1-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M300.78,192.58c5.78,3.34,15.12,3.34,20.87,0,2.87-1.67,4.3-3.85,4.29-6.04h0s0-.08,0-.11c-.05,2.14-1.47,4.26-4.28,5.9-5.74,3.34-15.09,3.34-20.87,0-2.85-1.64-4.29-3.79-4.35-5.94-.05,2.24,1.39,4.49,4.35,6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M319.14,181.47c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M319.14,181.66c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M301.02,183.41l21.3,3.92c.54-2-.51-4.12-3.18-5.67-4.43-2.56-11.58-2.55-15.98,0-.9.52-1.61,1.12-2.14,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M303.27,182.33c4.4-2.55,11.55-2.56,15.98,0,1.81,1.05,2.88,2.36,3.21,3.73-.11-1.6-1.2-3.18-3.31-4.39-4.43-2.56-11.58-2.55-15.98,0-2.59,1.51-3.64,3.56-3.16,5.52-.12-1.75.96-3.52,3.26-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M315.55,184.6l1.45-.84-1.35-.78-1.5.87c-1.47-.58-2.99-.59-4.08.04-2.52,1.46,2.01,3.2.75,3.93-.41.24-.98.15-1.55-.17-.75-.43-1.42-1.32-1.52-2.11l-2.09.4c.11.69.61,1.42,1.39,2.03l-1.57.91,1.35.78,1.53-.89c1.49.68,3.21.83,4.46.1,2.57-1.49-1.9-3.26-.68-3.98.34-.2.83-.12,1.3.15.58.34,1.23,1.06,1.54,1.75l2.09-.42c-.21-.58-.77-1.23-1.53-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M325.93,182.22v3.51c-.02,2.17-1.44,4.34-4.3,6-5.74,3.34-15.09,3.34-20.87,0-2.91-1.68-4.36-3.89-4.36-6.09v-3.51c0,2.2,1.46,4.41,4.37,6.09,5.78,3.34,15.12,3.34,20.87,0,2.85-1.66,4.28-3.83,4.29-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M321.64,188.24c-3.08,1.79-7.21,2.61-11.26,2.48v3.51c4.05.13,8.17-.69,11.25-2.48,2.85-1.66,4.28-3.83,4.29-6v-3.51c0,2.17-1.42,4.34-4.28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M321.58,176.14c-5.78-3.34-15.13-3.34-20.87,0-5.74,3.34-5.71,8.75.07,12.09,5.78,3.34,15.12,3.34,20.87,0,5.74-3.34,5.71-8.75-.06-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M321.58,176.14c-5.78-3.34-15.13-3.34-20.87,0-2.13,1.24-3.46,2.76-4,4.35l27.97,5.15c2.38-3.14,1.35-6.93-3.1-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M300.78,188.48c5.78,3.34,15.12,3.34,20.87,0,2.87-1.67,4.3-3.85,4.29-6.04h0s0-.08,0-.11c-.05,2.14-1.47,4.26-4.28,5.9-5.74,3.34-15.09,3.34-20.87,0-2.85-1.64-4.29-3.79-4.35-5.94-.05,2.24,1.39,4.49,4.35,6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M319.14,177.36c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M319.14,177.56c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M301.02,179.31l21.3,3.92c.54-2-.51-4.12-3.18-5.67-4.43-2.56-11.58-2.55-15.98,0-.9.52-1.61,1.12-2.14,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M303.27,178.22c4.4-2.55,11.55-2.56,15.98,0,1.81,1.05,2.88,2.36,3.21,3.73-.11-1.6-1.2-3.18-3.31-4.39-4.43-2.56-11.58-2.55-15.98,0-2.59,1.51-3.64,3.56-3.16,5.52-.12-1.75.96-3.52,3.26-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M315.55,180.5l1.45-.84-1.35-.78-1.5.87c-1.47-.58-2.99-.59-4.08.04-2.52,1.46,2.01,3.2.75,3.93-.41.24-.98.15-1.55-.17-.75-.43-1.42-1.32-1.52-2.11l-2.09.4c.11.69.61,1.42,1.39,2.03l-1.57.91,1.35.78,1.53-.89c1.49.68,3.21.83,4.46.1,2.57-1.49-1.9-3.26-.68-3.98.34-.2.83-.12,1.3.15.58.34,1.23,1.06,1.54,1.75l2.09-.42c-.21-.58-.77-1.23-1.53-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M325.93,178.12v3.51c-.02,2.17-1.44,4.34-4.3,6-5.74,3.34-15.09,3.34-20.87,0-2.91-1.68-4.36-3.89-4.36-6.09v-3.51c0,2.2,1.46,4.41,4.37,6.09,5.78,3.34,15.12,3.34,20.87,0,2.85-1.66,4.28-3.83,4.29-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M321.64,184.13c-3.08,1.79-7.21,2.61-11.26,2.48v3.51c4.05.13,8.17-.69,11.25-2.48,2.85-1.66,4.28-3.83,4.29-6v-3.51c0,2.17-1.42,4.34-4.28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M321.58,172.03c-5.78-3.34-15.13-3.34-20.87,0-5.74,3.34-5.71,8.75.07,12.09,5.78,3.34,15.12,3.34,20.87,0,5.74-3.34,5.71-8.75-.06-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M321.58,172.03c-5.78-3.34-15.13-3.34-20.87,0-2.13,1.24-3.46,2.76-4,4.35l27.97,5.15c2.38-3.14,1.35-6.93-3.1-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M300.78,184.37c5.78,3.34,15.12,3.34,20.87,0,2.87-1.67,4.3-3.85,4.29-6.04h0s0-.08,0-.11c-.05,2.14-1.47,4.26-4.28,5.9-5.74,3.34-15.09,3.34-20.87,0-2.85-1.64-4.29-3.79-4.35-5.94-.05,2.24,1.39,4.49,4.35,6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M319.14,173.26c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M319.14,173.45c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M301.02,175.2l21.3,3.92c.54-2-.51-4.12-3.18-5.67-4.43-2.56-11.58-2.55-15.98,0-.9.52-1.61,1.12-2.14,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M303.27,174.12c4.4-2.55,11.55-2.56,15.98,0,1.81,1.05,2.88,2.36,3.21,3.73-.11-1.6-1.2-3.18-3.31-4.39-4.43-2.56-11.58-2.55-15.98,0-2.59,1.51-3.64,3.56-3.16,5.52-.12-1.75.96-3.52,3.26-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M315.55,176.39l1.45-.84-1.35-.78-1.5.87c-1.47-.58-2.99-.59-4.08.04-2.52,1.46,2.01,3.2.75,3.93-.41.24-.98.15-1.55-.17-.75-.43-1.42-1.32-1.52-2.11l-2.09.4c.11.69.61,1.42,1.39,2.03l-1.57.91,1.35.78,1.53-.89c1.49.68,3.21.83,4.46.1,2.57-1.49-1.9-3.26-.68-3.98.34-.2.83-.12,1.3.15.58.34,1.23,1.06,1.54,1.75l2.09-.42c-.21-.58-.77-1.23-1.53-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M325.93,174.01v3.51c-.02,2.17-1.44,4.34-4.3,6-5.74,3.34-15.09,3.34-20.87,0-2.91-1.68-4.36-3.89-4.36-6.09v-3.51c0,2.2,1.46,4.41,4.37,6.09,5.78,3.34,15.12,3.34,20.87,0,2.85-1.66,4.28-3.83,4.29-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M321.64,180.03c-3.08,1.79-7.21,2.61-11.26,2.48v3.51c4.05.13,8.17-.69,11.25-2.48,2.85-1.66,4.28-3.83,4.29-6v-3.51c0,2.17-1.42,4.34-4.28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M321.58,167.93c-5.78-3.34-15.13-3.34-20.87,0-5.74,3.34-5.71,8.75.07,12.09,5.78,3.34,15.12,3.34,20.87,0,5.74-3.34,5.71-8.75-.06-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M321.58,167.93c-5.78-3.34-15.13-3.34-20.87,0-2.13,1.24-3.46,2.76-4,4.35l27.97,5.15c2.38-3.14,1.35-6.93-3.1-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M300.78,180.27c5.78,3.34,15.12,3.34,20.87,0,2.87-1.67,4.3-3.85,4.29-6.04h0s0-.08,0-.11c-.05,2.14-1.47,4.26-4.28,5.9-5.74,3.34-15.09,3.34-20.87,0-2.85-1.64-4.29-3.79-4.35-5.94-.05,2.24,1.39,4.49,4.35,6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M319.14,169.15c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M319.14,169.35c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M301.02,171.09l21.3,3.92c.54-2-.51-4.12-3.18-5.67-4.43-2.56-11.58-2.55-15.98,0-.9.52-1.61,1.12-2.14,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M303.27,170.01c4.4-2.55,11.55-2.56,15.98,0,1.81,1.05,2.88,2.36,3.21,3.73-.11-1.6-1.2-3.18-3.31-4.39-4.43-2.56-11.58-2.55-15.98,0-2.59,1.51-3.64,3.56-3.16,5.52-.12-1.75.96-3.52,3.26-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M315.55,172.28l1.45-.84-1.35-.78-1.5.87c-1.47-.58-2.99-.59-4.08.04-2.52,1.46,2.01,3.2.75,3.93-.41.24-.98.15-1.55-.17-.75-.43-1.42-1.32-1.52-2.11l-2.09.4c.11.69.61,1.42,1.39,2.03l-1.57.91,1.35.78,1.53-.89c1.49.68,3.21.83,4.46.1,2.57-1.49-1.9-3.26-.68-3.98.34-.2.83-.12,1.3.15.58.34,1.23,1.06,1.54,1.75l2.09-.42c-.21-.58-.77-1.23-1.53-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M352.78,214.16v3.51c-.02,2.17-1.44,4.34-4.3,6-5.74,3.34-15.08,3.34-20.87,0-2.91-1.68-4.36-3.88-4.35-6.08v-3.51c0,2.2,1.46,4.41,4.36,6.08,5.78,3.34,15.13,3.34,20.87,0,2.85-1.66,4.28-3.83,4.29-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M348.5,220.17c-3.08,1.79-7.21,2.61-11.26,2.48v3.51c4.05.13,8.17-.69,11.25-2.48,2.85-1.66,4.28-3.83,4.29-6v-3.51c0,2.17-1.42,4.34-4.28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M348.43,208.08c-5.78-3.34-15.12-3.34-20.87,0-5.74,3.34-5.71,8.75.07,12.08,5.78,3.34,15.13,3.34,20.87,0,5.74-3.34,5.71-8.75-.07-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M348.43,208.08c-5.78-3.34-15.12-3.34-20.87,0-2.92,1.7-4.34,3.93-4.28,6.16l29.5-.09c0-2.2-1.45-4.39-4.35-6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M327.63,220.45c5.78,3.34,15.13,3.34,20.87,0,2.87-1.67,4.29-3.85,4.29-6.03v-.02s0-.07,0-.11c-.06,2.13-1.48,4.25-4.28,5.88-5.74,3.34-15.08,3.34-20.87,0-2.84-1.64-4.28-3.77-4.34-5.92-.06,2.24,1.38,4.5,4.34,6.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M346,209.34c-4.42-2.55-11.58-2.55-15.98,0-4.4,2.55-4.37,6.7.05,9.25,4.43,2.56,11.58,2.56,15.98,0,4.4-2.56,4.38-6.7-.05-9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M345.99,209.49c-4.42-2.55-11.58-2.55-15.98,0-4.4,2.55-4.37,6.7.05,9.25,4.43,2.56,11.58,2.56,15.98,0,4.4-2.56,4.38-6.7-.05-9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M348.98,212.57c-.48-1.13-1.47-2.19-2.99-3.07-4.42-2.55-11.58-2.55-15.98,0-1.54.9-2.53,1.99-2.98,3.14l21.95-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M330.08,210.28c4.4-2.56,11.55-2.56,15.98,0,1.91,1.1,3,2.5,3.27,3.94.03-1.71-1.07-3.42-3.33-4.72-4.42-2.55-11.58-2.55-15.98,0-2.5,1.45-3.56,3.42-3.21,5.31.03-1.64,1.12-3.28,3.27-4.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M342.34,215.76c1.17-.86,1.42-1.85.16-2.58-2.58-1.49-5.63,1.1-6.86.38-.35-.2-.2-.48.27-.75.58-.34,1.83-.71,3.01-.89l-.74-1.21c-1,.12-2.12.44-3.07.88l-1.46-.84-1.34.78,1.51.87c-.99.85-1.01,1.74.08,2.37,2.53,1.46,5.53-1.16,6.79-.43.41.24.27.57-.3.9-.74.43-2.26.82-3.64.87l.7,1.21c1.19-.06,2.45-.35,3.51-.8l1.58.91,1.34-.78-1.54-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M352.78,210.37v3.51c-.02,2.17-1.44,4.34-4.3,6-5.74,3.34-15.08,3.34-20.87,0-2.91-1.68-4.36-3.88-4.35-6.08v-3.51c0,2.2,1.46,4.41,4.36,6.08,5.78,3.34,15.13,3.34,20.87,0,2.85-1.66,4.28-3.83,4.29-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M348.5,216.37c-3.08,1.79-7.21,2.61-11.26,2.48v3.51c4.05.13,8.17-.69,11.25-2.48,2.85-1.66,4.28-3.83,4.29-6v-3.51c0,2.17-1.42,4.34-4.28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M348.43,204.29c-5.78-3.34-15.12-3.34-20.87,0-5.74,3.34-5.71,8.75.07,12.08,5.78,3.34,15.13,3.34,20.87,0,5.74-3.34,5.71-8.75-.07-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M348.43,204.29c-5.78-3.34-15.12-3.34-20.87,0-2.92,1.7-4.34,3.93-4.28,6.16l29.5-.09c0-2.2-1.45-4.39-4.35-6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M327.63,216.66c5.78,3.34,15.13,3.34,20.87,0,2.87-1.67,4.29-3.85,4.29-6.03v-.02s0-.07,0-.11c-.06,2.13-1.48,4.25-4.28,5.88-5.74,3.34-15.08,3.34-20.87,0-2.84-1.64-4.28-3.77-4.34-5.92-.06,2.24,1.38,4.5,4.34,6.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M346,205.55c-4.42-2.55-11.58-2.55-15.98,0-4.4,2.55-4.37,6.7.05,9.25,4.43,2.56,11.58,2.56,15.98,0,4.4-2.56,4.38-6.7-.05-9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M345.99,205.7c-4.42-2.55-11.58-2.55-15.98,0-4.4,2.55-4.37,6.7.05,9.25,4.43,2.56,11.58,2.56,15.98,0,4.4-2.56,4.38-6.7-.05-9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M348.98,208.78c-.48-1.13-1.47-2.19-2.99-3.07-4.42-2.55-11.58-2.55-15.98,0-1.54.9-2.53,1.99-2.98,3.14l21.95-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M330.08,206.49c4.4-2.56,11.55-2.56,15.98,0,1.91,1.1,3,2.5,3.27,3.94.03-1.71-1.07-3.42-3.33-4.72-4.42-2.55-11.58-2.55-15.98,0-2.5,1.45-3.56,3.42-3.21,5.31.03-1.64,1.12-3.28,3.27-4.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M342.34,211.97c1.17-.86,1.42-1.85.16-2.58-2.58-1.49-5.63,1.1-6.86.38-.35-.2-.2-.48.27-.75.58-.34,1.83-.71,3.01-.89l-.74-1.21c-1,.12-2.12.44-3.07.88l-1.46-.84-1.34.78,1.51.87c-.99.85-1.01,1.74.08,2.37,2.53,1.46,5.53-1.16,6.79-.43.41.24.27.57-.3.9-.74.43-2.26.82-3.64.87l.7,1.21c1.19-.06,2.45-.35,3.51-.8l1.58.91,1.34-.78-1.54-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M352.78,206.58v3.51c-.02,2.17-1.44,4.34-4.3,6-5.74,3.34-15.08,3.34-20.87,0-2.91-1.68-4.36-3.88-4.35-6.08v-3.51c0,2.2,1.46,4.41,4.36,6.08,5.78,3.34,15.13,3.34,20.87,0,2.85-1.66,4.28-3.83,4.29-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M348.5,212.58c-3.08,1.79-7.21,2.61-11.26,2.48v3.51c4.05.13,8.17-.69,11.25-2.48,2.85-1.66,4.28-3.83,4.29-6v-3.51c0,2.17-1.42,4.34-4.28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M348.43,200.5c-5.78-3.34-15.12-3.34-20.87,0-5.74,3.34-5.71,8.75.07,12.08,5.78,3.34,15.13,3.34,20.87,0,5.74-3.34,5.71-8.75-.07-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M348.43,200.5c-5.78-3.34-15.12-3.34-20.87,0-2.92,1.7-4.34,3.93-4.28,6.16l29.5-.09c0-2.2-1.45-4.39-4.35-6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M327.63,212.87c5.78,3.34,15.13,3.34,20.87,0,2.87-1.67,4.29-3.85,4.29-6.03v-.02s0-.07,0-.11c-.06,2.13-1.48,4.25-4.28,5.88-5.74,3.34-15.08,3.34-20.87,0-2.84-1.64-4.28-3.77-4.34-5.92-.06,2.24,1.38,4.5,4.34,6.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M346,201.76c-4.42-2.55-11.58-2.55-15.98,0-4.4,2.55-4.37,6.7.05,9.25,4.43,2.56,11.58,2.56,15.98,0,4.4-2.56,4.38-6.7-.05-9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M345.99,201.91c-4.42-2.55-11.58-2.55-15.98,0-4.4,2.55-4.37,6.7.05,9.25,4.43,2.56,11.58,2.56,15.98,0,4.4-2.56,4.38-6.7-.05-9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M348.98,204.99c-.48-1.13-1.47-2.19-2.99-3.07-4.42-2.55-11.58-2.55-15.98,0-1.54.9-2.53,1.99-2.98,3.14l21.95-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M330.08,202.7c4.4-2.56,11.55-2.56,15.98,0,1.91,1.1,3,2.5,3.27,3.94.03-1.71-1.07-3.42-3.33-4.72-4.42-2.55-11.58-2.55-15.98,0-2.5,1.45-3.56,3.42-3.21,5.31.03-1.64,1.12-3.28,3.27-4.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M342.34,208.18c1.17-.86,1.42-1.85.16-2.58-2.58-1.49-5.63,1.1-6.86.38-.35-.2-.2-.48.27-.75.58-.34,1.83-.71,3.01-.89l-.74-1.21c-1,.12-2.12.44-3.07.88l-1.46-.84-1.34.78,1.51.87c-.99.85-1.01,1.74.08,2.37,2.53,1.46,5.53-1.16,6.79-.43.41.24.27.57-.3.9-.74.43-2.26.82-3.64.87l.7,1.21c1.19-.06,2.45-.35,3.51-.8l1.58.91,1.34-.78-1.54-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M352.78,202.79v3.51c-.02,2.17-1.44,4.34-4.3,6-5.74,3.34-15.08,3.34-20.87,0-2.91-1.68-4.36-3.88-4.35-6.08v-3.51c0,2.2,1.46,4.41,4.36,6.08,5.78,3.34,15.13,3.34,20.87,0,2.85-1.66,4.28-3.83,4.29-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M348.5,208.79c-3.08,1.79-7.21,2.61-11.26,2.48v3.51c4.05.13,8.17-.69,11.25-2.48,2.85-1.66,4.28-3.83,4.29-6v-3.51c0,2.17-1.42,4.34-4.28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M348.43,196.7c-5.78-3.34-15.12-3.34-20.87,0-5.74,3.34-5.71,8.75.07,12.08,5.78,3.34,15.13,3.34,20.87,0,5.74-3.34,5.71-8.75-.07-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M348.43,196.7c-5.78-3.34-15.12-3.34-20.87,0-2.92,1.7-4.34,3.93-4.28,6.16l29.5-.09c0-2.2-1.45-4.39-4.35-6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M327.63,209.08c5.78,3.34,15.13,3.34,20.87,0,2.87-1.67,4.29-3.85,4.29-6.03v-.02s0-.07,0-.11c-.06,2.13-1.48,4.25-4.28,5.88-5.74,3.34-15.08,3.34-20.87,0-2.84-1.64-4.28-3.77-4.34-5.92-.06,2.24,1.38,4.5,4.34,6.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M346,197.97c-4.42-2.55-11.58-2.55-15.98,0-4.4,2.55-4.37,6.7.05,9.25,4.43,2.56,11.58,2.56,15.98,0,4.4-2.56,4.38-6.7-.05-9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M345.99,198.12c-4.42-2.55-11.58-2.55-15.98,0-4.4,2.55-4.37,6.7.05,9.25,4.43,2.56,11.58,2.56,15.98,0,4.4-2.56,4.38-6.7-.05-9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M348.98,201.19c-.48-1.13-1.47-2.19-2.99-3.07-4.42-2.55-11.58-2.55-15.98,0-1.54.9-2.53,1.99-2.98,3.14l21.95-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M330.08,198.9c4.4-2.56,11.55-2.56,15.98,0,1.91,1.1,3,2.5,3.27,3.94.03-1.71-1.07-3.42-3.33-4.72-4.42-2.55-11.58-2.55-15.98,0-2.5,1.45-3.56,3.42-3.21,5.31.03-1.64,1.12-3.28,3.27-4.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M342.34,204.39c1.17-.86,1.42-1.85.16-2.58-2.58-1.49-5.63,1.1-6.86.38-.35-.2-.2-.48.27-.75.58-.34,1.83-.71,3.01-.89l-.74-1.21c-1,.12-2.12.44-3.07.88l-1.46-.84-1.34.78,1.51.87c-.99.85-1.01,1.74.08,2.37,2.53,1.46,5.53-1.16,6.79-.43.41.24.27.57-.3.9-.74.43-2.26.82-3.64.87l.7,1.21c1.19-.06,2.45-.35,3.51-.8l1.58.91,1.34-.78-1.54-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M352.78,199v3.51c-.02,2.17-1.44,4.34-4.3,6-5.74,3.34-15.08,3.34-20.87,0-2.91-1.68-4.36-3.88-4.35-6.08v-3.51c0,2.2,1.46,4.41,4.36,6.08,5.78,3.34,15.13,3.34,20.87,0,2.85-1.66,4.28-3.83,4.29-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M348.5,205c-3.08,1.79-7.21,2.61-11.26,2.48v3.51c4.05.13,8.17-.69,11.25-2.48,2.85-1.66,4.28-3.83,4.29-6v-3.51c0,2.17-1.42,4.34-4.28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M348.43,192.91c-5.78-3.34-15.12-3.34-20.87,0-5.74,3.34-5.71,8.75.07,12.08,5.78,3.34,15.13,3.34,20.87,0,5.74-3.34,5.71-8.75-.07-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M348.43,192.91c-5.78-3.34-15.12-3.34-20.87,0-2.92,1.7-4.34,3.93-4.28,6.16l29.5-.09c0-2.2-1.45-4.39-4.35-6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M327.63,205.29c5.78,3.34,15.13,3.34,20.87,0,2.87-1.67,4.29-3.85,4.29-6.03v-.02s0-.07,0-.11c-.06,2.13-1.48,4.25-4.28,5.88-5.74,3.34-15.08,3.34-20.87,0-2.84-1.64-4.28-3.77-4.34-5.92-.06,2.24,1.38,4.5,4.34,6.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M346,194.18c-4.42-2.55-11.58-2.55-15.98,0-4.4,2.55-4.37,6.7.05,9.25,4.43,2.56,11.58,2.56,15.98,0,4.4-2.56,4.38-6.7-.05-9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M345.99,194.33c-4.42-2.55-11.58-2.55-15.98,0-4.4,2.55-4.37,6.7.05,9.25,4.43,2.56,11.58,2.56,15.98,0,4.4-2.56,4.38-6.7-.05-9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M348.98,197.4c-.48-1.13-1.47-2.19-2.99-3.07-4.42-2.55-11.58-2.55-15.98,0-1.54.9-2.53,1.99-2.98,3.14l21.95-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M330.08,195.11c4.4-2.56,11.55-2.56,15.98,0,1.91,1.1,3,2.5,3.27,3.94.03-1.71-1.07-3.42-3.33-4.72-4.42-2.55-11.58-2.55-15.98,0-2.5,1.45-3.56,3.42-3.21,5.31.03-1.64,1.12-3.28,3.27-4.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M342.34,200.6c1.17-.86,1.42-1.85.16-2.58-2.58-1.49-5.63,1.1-6.86.38-.35-.2-.2-.48.27-.75.58-.34,1.83-.71,3.01-.89l-.74-1.21c-1,.12-2.12.44-3.07.88l-1.46-.84-1.34.78,1.51.87c-.99.85-1.01,1.74.08,2.37,2.53,1.46,5.53-1.16,6.79-.43.41.24.27.57-.3.9-.74.43-2.26.82-3.64.87l.7,1.21c1.19-.06,2.45-.35,3.51-.8l1.58.91,1.34-.78-1.54-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M352.78,195.21v3.51c-.02,2.17-1.44,4.34-4.3,6-5.74,3.34-15.08,3.34-20.87,0-2.91-1.68-4.36-3.88-4.35-6.08v-3.51c0,2.2,1.46,4.41,4.36,6.08,5.78,3.34,15.13,3.34,20.87,0,2.85-1.66,4.28-3.83,4.29-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M348.5,201.21c-3.08,1.79-7.21,2.61-11.26,2.48v3.51c4.05.13,8.17-.69,11.25-2.48,2.85-1.66,4.28-3.83,4.29-6v-3.51c0,2.17-1.42,4.34-4.28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M348.43,189.12c-5.78-3.34-15.12-3.34-20.87,0-5.74,3.34-5.71,8.75.07,12.08,5.78,3.34,15.13,3.34,20.87,0,5.74-3.34,5.71-8.75-.07-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M348.43,189.12c-5.78-3.34-15.12-3.34-20.87,0-2.92,1.7-4.34,3.93-4.28,6.16l29.5-.09c0-2.2-1.45-4.39-4.35-6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M327.63,201.5c5.78,3.34,15.13,3.34,20.87,0,2.87-1.67,4.29-3.85,4.29-6.03v-.02s0-.07,0-.11c-.06,2.13-1.48,4.25-4.28,5.88-5.74,3.34-15.08,3.34-20.87,0-2.84-1.64-4.28-3.77-4.34-5.92-.06,2.24,1.38,4.5,4.34,6.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M346,190.38c-4.42-2.55-11.58-2.55-15.98,0-4.4,2.55-4.37,6.7.05,9.25,4.43,2.56,11.58,2.56,15.98,0,4.4-2.56,4.38-6.7-.05-9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M345.99,190.54c-4.42-2.55-11.58-2.55-15.98,0-4.4,2.55-4.37,6.7.05,9.25,4.43,2.56,11.58,2.56,15.98,0,4.4-2.56,4.38-6.7-.05-9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M348.98,193.61c-.48-1.13-1.47-2.19-2.99-3.07-4.42-2.55-11.58-2.55-15.98,0-1.54.9-2.53,1.99-2.98,3.14l21.95-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M330.08,191.32c4.4-2.56,11.55-2.56,15.98,0,1.91,1.1,3,2.5,3.27,3.94.03-1.71-1.07-3.42-3.33-4.72-4.42-2.55-11.58-2.55-15.98,0-2.5,1.45-3.56,3.42-3.21,5.31.03-1.64,1.12-3.28,3.27-4.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M342.34,196.81c1.17-.86,1.42-1.85.16-2.58-2.58-1.49-5.63,1.1-6.86.38-.35-.2-.2-.48.27-.75.58-.34,1.83-.71,3.01-.89l-.74-1.21c-1,.12-2.12.44-3.07.88l-1.46-.84-1.34.78,1.51.87c-.99.85-1.01,1.74.08,2.37,2.53,1.46,5.53-1.16,6.79-.43.41.24.27.57-.3.9-.74.43-2.26.82-3.64.87l.7,1.21c1.19-.06,2.45-.35,3.51-.8l1.58.91,1.34-.78-1.54-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M352.78,191.42v3.51c-.02,2.17-1.44,4.34-4.3,6-5.74,3.34-15.08,3.34-20.87,0-2.91-1.68-4.36-3.88-4.35-6.08v-3.51c0,2.2,1.46,4.41,4.36,6.08,5.78,3.34,15.13,3.34,20.87,0,2.85-1.66,4.28-3.83,4.29-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M348.5,197.42c-3.08,1.79-7.21,2.61-11.26,2.48v3.51c4.05.13,8.17-.69,11.25-2.48,2.85-1.66,4.28-3.83,4.29-6v-3.51c0,2.17-1.42,4.34-4.28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M348.43,185.33c-5.78-3.34-15.12-3.34-20.87,0-5.74,3.34-5.71,8.75.07,12.08,5.78,3.34,15.13,3.34,20.87,0,5.74-3.34,5.71-8.75-.07-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M348.43,185.33c-5.78-3.34-15.12-3.34-20.87,0-2.92,1.7-4.34,3.93-4.28,6.16l29.5-.09c0-2.2-1.45-4.39-4.35-6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M327.63,197.71c5.78,3.34,15.13,3.34,20.87,0,2.87-1.67,4.29-3.85,4.29-6.03v-.02s0-.07,0-.11c-.06,2.13-1.48,4.25-4.28,5.88-5.74,3.34-15.08,3.34-20.87,0-2.84-1.64-4.28-3.77-4.34-5.92-.06,2.24,1.38,4.5,4.34,6.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M346,186.59c-4.42-2.55-11.58-2.55-15.98,0-4.4,2.55-4.37,6.7.05,9.25,4.43,2.56,11.58,2.56,15.98,0,4.4-2.56,4.38-6.7-.05-9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M345.99,186.75c-4.42-2.55-11.58-2.55-15.98,0-4.4,2.55-4.37,6.7.05,9.25,4.43,2.56,11.58,2.56,15.98,0,4.4-2.56,4.38-6.7-.05-9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M348.98,189.82c-.48-1.13-1.47-2.19-2.99-3.07-4.42-2.55-11.58-2.55-15.98,0-1.54.9-2.53,1.99-2.98,3.14l21.95-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M330.08,187.53c4.4-2.56,11.55-2.56,15.98,0,1.91,1.1,3,2.5,3.27,3.94.03-1.71-1.07-3.42-3.33-4.72-4.42-2.55-11.58-2.55-15.98,0-2.5,1.45-3.56,3.42-3.21,5.31.03-1.64,1.12-3.28,3.27-4.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M342.34,193.01c1.17-.86,1.42-1.85.16-2.58-2.58-1.49-5.63,1.1-6.86.38-.35-.2-.2-.48.27-.75.58-.34,1.83-.71,3.01-.89l-.74-1.21c-1,.12-2.12.44-3.07.88l-1.46-.84-1.34.78,1.51.87c-.99.85-1.01,1.74.08,2.37,2.53,1.46,5.53-1.16,6.79-.43.41.24.27.57-.3.9-.74.43-2.26.82-3.64.87l.7,1.21c1.19-.06,2.45-.35,3.51-.8l1.58.91,1.34-.78-1.54-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M352.78,187.63v3.51c-.02,2.17-1.44,4.34-4.3,6-5.74,3.34-15.08,3.34-20.87,0-2.91-1.68-4.36-3.88-4.35-6.08v-3.51c0,2.2,1.46,4.41,4.36,6.08,5.78,3.34,15.13,3.34,20.87,0,2.85-1.66,4.28-3.83,4.29-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M348.5,193.63c-3.08,1.79-7.21,2.61-11.26,2.48v3.51c4.05.13,8.17-.69,11.25-2.48,2.85-1.66,4.28-3.83,4.29-6v-3.51c0,2.17-1.42,4.34-4.28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M348.43,181.54c-5.78-3.34-15.12-3.34-20.87,0-5.74,3.34-5.71,8.75.07,12.08,5.78,3.34,15.13,3.34,20.87,0,5.74-3.34,5.71-8.75-.07-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M348.43,181.54c-5.78-3.34-15.12-3.34-20.87,0-2.92,1.7-4.34,3.93-4.28,6.16l29.5-.09c0-2.2-1.45-4.39-4.35-6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M327.63,193.91c5.78,3.34,15.13,3.34,20.87,0,2.87-1.67,4.29-3.85,4.29-6.03v-.02s0-.07,0-.11c-.06,2.13-1.48,4.25-4.28,5.88-5.74,3.34-15.08,3.34-20.87,0-2.84-1.64-4.28-3.77-4.34-5.92-.06,2.24,1.38,4.5,4.34,6.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M346,182.8c-4.42-2.55-11.58-2.55-15.98,0-4.4,2.55-4.37,6.7.05,9.25,4.43,2.56,11.58,2.56,15.98,0,4.4-2.56,4.38-6.7-.05-9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M345.99,182.96c-4.42-2.55-11.58-2.55-15.98,0-4.4,2.55-4.37,6.7.05,9.25,4.43,2.56,11.58,2.56,15.98,0,4.4-2.56,4.38-6.7-.05-9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M348.98,186.03c-.48-1.13-1.47-2.19-2.99-3.07-4.42-2.55-11.58-2.55-15.98,0-1.54.9-2.53,1.99-2.98,3.14l21.95-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M330.08,183.74c4.4-2.56,11.55-2.56,15.98,0,1.91,1.1,3,2.5,3.27,3.94.03-1.71-1.07-3.42-3.33-4.72-4.42-2.55-11.58-2.55-15.98,0-2.5,1.45-3.56,3.42-3.21,5.31.03-1.64,1.12-3.28,3.27-4.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M342.34,189.22c1.17-.86,1.42-1.85.16-2.58-2.58-1.49-5.63,1.1-6.86.38-.35-.2-.2-.48.27-.75.58-.34,1.83-.71,3.01-.89l-.74-1.21c-1,.12-2.12.44-3.07.88l-1.46-.84-1.34.78,1.51.87c-.99.85-1.01,1.74.08,2.37,2.53,1.46,5.53-1.16,6.79-.43.41.24.27.57-.3.9-.74.43-2.26.82-3.64.87l.7,1.21c1.19-.06,2.45-.35,3.51-.8l1.58.91,1.34-.78-1.54-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M352.89,181.79l-.61,3.93c-.21,1.32-1.63,2.46-4.26,3.14-5.71,1.47-14.96.24-20.66-2.74-3.06-1.61-4.48-3.4-4.24-4.94l.61-3.93c-.24,1.54,1.17,3.33,4.24,4.94,5.7,2.99,14.95,4.22,20.66,2.74,2.64-.68,4.06-1.82,4.26-3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M333.66,184.31c-2.08-.55-4.04-1.26-5.69-2.13-3.06-1.61-4.48-3.4-4.24-4.94l-.61,3.93c-.24,1.54,1.17,3.33,4.24,4.94,1.39.73,2.99,1.35,4.7,1.86l1.61-3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M348.65,176.85c-5.69-2.99-14.94-4.22-20.65-2.74-5.71,1.47-5.72,5.09-.03,8.07,5.7,2.99,14.95,4.22,20.66,2.74,5.71-1.47,5.72-5.09.02-8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M348.65,176.85c-5.69-2.99-14.94-4.22-20.65-2.74-3.75.97-5.03,2.86-3.86,4.89l28.07.61c-.68-.93-1.86-1.87-3.56-2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M348.63,184.92c-5.71,1.47-14.96.24-20.66-2.74-2.72-1.43-4.14-3-4.25-4.41-.07,1.48,1.35,3.17,4.25,4.7,5.7,2.99,14.95,4.22,20.66,2.74,2.4-.62,3.78-1.62,4.17-2.79l.1-.63c-.21,1.32-1.63,2.46-4.26,3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M346.23,177.34c-4.36-2.29-11.44-3.23-15.81-2.1-4.37,1.13-4.38,3.9-.02,6.18,4.36,2.29,11.44,3.23,15.82,2.1,4.37-1.13,4.38-3.89.01-6.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M346.23,177.47c-4.36-2.29-11.44-3.23-15.81-2.1-4.37,1.13-4.38,3.9-.02,6.18,4.36,2.29,11.44,3.23,15.82,2.1,4.37-1.13,4.38-3.89.01-6.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M346.23,177.47c-4.36-2.29-11.44-3.23-15.81-2.1-2.19.56-3.28,1.54-3.29,2.66l20.69.45c-.45-.34-.97-.68-1.6-1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M346.23,177.47c-4.36-2.29-11.44-3.23-15.81-2.1-1.74.45-2.78,1.16-3.14,2,.51-.61,1.45-1.12,2.82-1.47,4.37-1.13,11.45-.19,15.81,2.1,2.63,1.38,3.66,2.93,3.12,4.19,1.13-1.34.2-3.14-2.8-4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M342.56,181.17c1.17-.42,1.43-1.05.18-1.71-2.55-1.33-5.58,0-6.8-.65-.34-.18-.2-.35.26-.47.57-.15,1.81-.23,2.99-.2l-.72-.91c-1-.05-2.1.02-3.04.18l-1.43-.75-1.33.34,1.49.78c-.99.43-1.01,1.02.06,1.59,2.49,1.31,5.48-.05,6.72.61.4.21.26.41-.3.56-.74.19-2.24.25-3.61.1l.68.9c1.18.11,2.43.09,3.48-.07l1.56.82,1.33-.34-1.52-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M337.22,233.49v3.51c-.02,2.17-1.44,4.34-4.3,6-5.74,3.34-15.09,3.34-20.87,0-2.91-1.68-4.36-3.89-4.36-6.09v-3.51c0,2.2,1.46,4.41,4.37,6.09,5.78,3.34,15.12,3.34,20.87,0,2.85-1.66,4.28-3.83,4.29-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M332.94,239.51c-3.08,1.79-7.21,2.61-11.26,2.48v3.51c4.05.13,8.17-.69,11.25-2.48,2.85-1.66,4.28-3.83,4.29-6v-3.51c0,2.17-1.42,4.34-4.28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "M332.87,227.41c-5.78-3.34-15.13-3.34-20.87,0-5.74,3.34-5.71,8.75.07,12.09,5.78,3.34,15.12,3.34,20.87,0,5.74-3.34,5.71-8.75-.06-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M332.87,227.41c-5.78-3.34-15.13-3.34-20.87,0-2.13,1.24-3.46,2.76-4,4.35l27.97,5.15c2.38-3.14,1.35-6.93-3.1-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M312.07,239.75c5.78,3.34,15.12,3.34,20.87,0,2.87-1.67,4.3-3.85,4.29-6.04h0s0-.08,0-.11c-.05,2.14-1.47,4.26-4.28,5.9-5.74,3.34-15.09,3.34-20.87,0-2.85-1.64-4.29-3.79-4.35-5.94-.05,2.24,1.39,4.49,4.35,6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M330.43,228.63c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M330.43,228.82c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M312.32,230.57l21.3,3.92c.54-2-.51-4.12-3.18-5.67-4.43-2.56-11.58-2.55-15.98,0-.9.52-1.61,1.12-2.14,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M314.56,229.49c4.4-2.55,11.55-2.56,15.98,0,1.81,1.05,2.88,2.36,3.21,3.73-.11-1.6-1.2-3.18-3.31-4.39-4.43-2.56-11.58-2.55-15.98,0-2.59,1.51-3.64,3.56-3.16,5.52-.12-1.75.96-3.52,3.26-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M326.84,231.76l1.45-.84-1.35-.78-1.5.87c-1.47-.58-2.99-.59-4.08.04-2.52,1.46,2.01,3.2.75,3.93-.41.24-.98.15-1.55-.17-.75-.43-1.42-1.32-1.52-2.11l-2.09.4c.11.69.61,1.42,1.39,2.03l-1.57.91,1.35.78,1.53-.89c1.49.68,3.21.83,4.46.1,2.57-1.49-1.9-3.26-.68-3.98.34-.2.83-.12,1.3.15.58.34,1.23,1.06,1.54,1.75l2.09-.42c-.21-.58-.77-1.23-1.53-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M337.22,229.39v3.51c-.02,2.17-1.44,4.34-4.3,6-5.74,3.34-15.09,3.34-20.87,0-2.91-1.68-4.36-3.89-4.36-6.09v-3.51c0,2.2,1.46,4.41,4.37,6.09,5.78,3.34,15.12,3.34,20.87,0,2.85-1.66,4.28-3.83,4.29-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M332.94,235.4c-3.08,1.79-7.21,2.61-11.26,2.48v3.51c4.05.13,8.17-.69,11.25-2.48,2.85-1.66,4.28-3.83,4.29-6v-3.51c0,2.17-1.42,4.34-4.28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M332.87,223.3c-5.78-3.34-15.13-3.34-20.87,0-5.74,3.34-5.71,8.75.07,12.09,5.78,3.34,15.12,3.34,20.87,0,5.74-3.34,5.71-8.75-.06-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M332.87,223.3c-5.78-3.34-15.13-3.34-20.87,0-2.13,1.24-3.46,2.76-4,4.35l27.97,5.15c2.38-3.14,1.35-6.93-3.1-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M312.07,235.64c5.78,3.34,15.12,3.34,20.87,0,2.87-1.67,4.3-3.85,4.29-6.04h0s0-.08,0-.11c-.05,2.14-1.47,4.26-4.28,5.9-5.74,3.34-15.09,3.34-20.87,0-2.85-1.64-4.29-3.79-4.35-5.94-.05,2.24,1.39,4.49,4.35,6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M330.43,224.53c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M330.43,224.72c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M312.32,226.47l21.3,3.92c.54-2-.51-4.12-3.18-5.67-4.43-2.56-11.58-2.55-15.98,0-.9.52-1.61,1.12-2.14,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M314.56,225.39c4.4-2.55,11.55-2.56,15.98,0,1.81,1.05,2.88,2.36,3.21,3.73-.11-1.6-1.2-3.18-3.31-4.39-4.43-2.56-11.58-2.55-15.98,0-2.59,1.51-3.64,3.56-3.16,5.52-.12-1.75.96-3.52,3.26-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M326.84,227.66l1.45-.84-1.35-.78-1.5.87c-1.47-.58-2.99-.59-4.08.04-2.52,1.46,2.01,3.2.75,3.93-.41.24-.98.15-1.55-.17-.75-.43-1.42-1.32-1.52-2.11l-2.09.4c.11.69.61,1.42,1.39,2.03l-1.57.91,1.35.78,1.53-.89c1.49.68,3.21.83,4.46.1,2.57-1.49-1.9-3.26-.68-3.98.34-.2.83-.12,1.3.15.58.34,1.23,1.06,1.54,1.75l2.09-.42c-.21-.58-.77-1.23-1.53-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M337.22,225.28v3.51c-.02,2.17-1.44,4.34-4.3,6-5.74,3.34-15.09,3.34-20.87,0-2.91-1.68-4.36-3.89-4.36-6.09v-3.51c0,2.2,1.46,4.41,4.37,6.09,5.78,3.34,15.12,3.34,20.87,0,2.85-1.66,4.28-3.83,4.29-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M332.94,231.3c-3.08,1.79-7.21,2.61-11.26,2.48v3.51c4.05.13,8.17-.69,11.25-2.48,2.85-1.66,4.28-3.83,4.29-6v-3.51c0,2.17-1.42,4.34-4.28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M332.87,219.2c-5.78-3.34-15.13-3.34-20.87,0-5.74,3.34-5.71,8.75.07,12.09,5.78,3.34,15.12,3.34,20.87,0,5.74-3.34,5.71-8.75-.06-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M332.87,219.2c-5.78-3.34-15.13-3.34-20.87,0-2.13,1.24-3.46,2.76-4,4.35l27.97,5.15c2.38-3.14,1.35-6.93-3.1-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M312.07,231.54c5.78,3.34,15.12,3.34,20.87,0,2.87-1.67,4.3-3.85,4.29-6.04h0s0-.08,0-.11c-.05,2.14-1.47,4.26-4.28,5.9-5.74,3.34-15.09,3.34-20.87,0-2.85-1.64-4.29-3.79-4.35-5.94-.05,2.24,1.39,4.49,4.35,6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M330.43,220.42c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M330.43,220.61c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M312.32,222.36l21.3,3.92c.54-2-.51-4.12-3.18-5.67-4.43-2.56-11.58-2.55-15.98,0-.9.52-1.61,1.12-2.14,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M314.56,221.28c4.4-2.55,11.55-2.56,15.98,0,1.81,1.05,2.88,2.36,3.21,3.73-.11-1.6-1.2-3.18-3.31-4.39-4.43-2.56-11.58-2.55-15.98,0-2.59,1.51-3.64,3.56-3.16,5.52-.12-1.75.96-3.52,3.26-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M326.84,223.55l1.45-.84-1.35-.78-1.5.87c-1.47-.58-2.99-.59-4.08.04-2.52,1.46,2.01,3.2.75,3.93-.41.24-.98.15-1.55-.17-.75-.43-1.42-1.32-1.52-2.11l-2.09.4c.11.69.61,1.42,1.39,2.03l-1.57.91,1.35.78,1.53-.89c1.49.68,3.21.83,4.46.1,2.57-1.49-1.9-3.26-.68-3.98.34-.2.83-.12,1.3.15.58.34,1.23,1.06,1.54,1.75l2.09-.42c-.21-.58-.77-1.23-1.53-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M337.22,221.17v3.51c-.02,2.17-1.44,4.34-4.3,6-5.74,3.34-15.09,3.34-20.87,0-2.91-1.68-4.36-3.89-4.36-6.09v-3.51c0,2.2,1.46,4.41,4.37,6.09,5.78,3.34,15.12,3.34,20.87,0,2.85-1.66,4.28-3.83,4.29-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M332.94,227.19c-3.08,1.79-7.21,2.61-11.26,2.48v3.51c4.05.13,8.17-.69,11.25-2.48,2.85-1.66,4.28-3.83,4.29-6v-3.51c0,2.17-1.42,4.34-4.28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M332.87,215.09c-5.78-3.34-15.13-3.34-20.87,0-5.74,3.34-5.71,8.75.07,12.09,5.78,3.34,15.12,3.34,20.87,0,5.74-3.34,5.71-8.75-.06-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M332.87,215.09c-5.78-3.34-15.13-3.34-20.87,0-2.13,1.24-3.46,2.76-4,4.35l27.97,5.15c2.38-3.14,1.35-6.93-3.1-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M312.07,227.43c5.78,3.34,15.12,3.34,20.87,0,2.87-1.67,4.3-3.85,4.29-6.04h0s0-.08,0-.11c-.05,2.14-1.47,4.26-4.28,5.9-5.74,3.34-15.09,3.34-20.87,0-2.85-1.64-4.29-3.79-4.35-5.94-.05,2.24,1.39,4.49,4.35,6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M330.43,216.32c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M330.43,216.51c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M312.32,218.26l21.3,3.92c.54-2-.51-4.12-3.18-5.67-4.43-2.56-11.58-2.55-15.98,0-.9.52-1.61,1.12-2.14,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M314.56,217.17c4.4-2.55,11.55-2.56,15.98,0,1.81,1.05,2.88,2.36,3.21,3.73-.11-1.6-1.2-3.18-3.31-4.39-4.43-2.56-11.58-2.55-15.98,0-2.59,1.51-3.64,3.56-3.16,5.52-.12-1.75.96-3.52,3.26-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M326.84,219.45l1.45-.84-1.35-.78-1.5.87c-1.47-.58-2.99-.59-4.08.04-2.52,1.46,2.01,3.2.75,3.93-.41.24-.98.15-1.55-.17-.75-.43-1.42-1.32-1.52-2.11l-2.09.4c.11.69.61,1.42,1.39,2.03l-1.57.91,1.35.78,1.53-.89c1.49.68,3.21.83,4.46.1,2.57-1.49-1.9-3.26-.68-3.98.34-.2.83-.12,1.3.15.58.34,1.23,1.06,1.54,1.75l2.09-.42c-.21-.58-.77-1.23-1.53-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M337.22,217.07v3.51c-.02,2.17-1.44,4.34-4.3,6-5.74,3.34-15.09,3.34-20.87,0-2.91-1.68-4.36-3.89-4.36-6.09v-3.51c0,2.2,1.46,4.41,4.37,6.09,5.78,3.34,15.12,3.34,20.87,0,2.85-1.66,4.28-3.83,4.29-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M332.94,223.08c-3.08,1.79-7.21,2.61-11.26,2.48v3.51c4.05.13,8.17-.69,11.25-2.48,2.85-1.66,4.28-3.83,4.29-6v-3.51c0,2.17-1.42,4.34-4.28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M332.87,210.99c-5.78-3.34-15.13-3.34-20.87,0-5.74,3.34-5.71,8.75.07,12.09,5.78,3.34,15.12,3.34,20.87,0,5.74-3.34,5.71-8.75-.06-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M332.87,210.99c-5.78-3.34-15.13-3.34-20.87,0-2.13,1.24-3.46,2.76-4,4.35l27.97,5.15c2.38-3.14,1.35-6.93-3.1-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M312.07,223.32c5.78,3.34,15.12,3.34,20.87,0,2.87-1.67,4.3-3.85,4.29-6.04h0s0-.08,0-.11c-.05,2.14-1.47,4.26-4.28,5.9-5.74,3.34-15.09,3.34-20.87,0-2.85-1.64-4.29-3.79-4.35-5.94-.05,2.24,1.39,4.49,4.35,6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M330.43,212.21c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M330.43,212.4c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M312.32,214.15l21.3,3.92c.54-2-.51-4.12-3.18-5.67-4.43-2.56-11.58-2.55-15.98,0-.9.52-1.61,1.12-2.14,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M314.56,213.07c4.4-2.55,11.55-2.56,15.98,0,1.81,1.05,2.88,2.36,3.21,3.73-.11-1.6-1.2-3.18-3.31-4.39-4.43-2.56-11.58-2.55-15.98,0-2.59,1.51-3.64,3.56-3.16,5.52-.12-1.75.96-3.52,3.26-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M326.84,215.34l1.45-.84-1.35-.78-1.5.87c-1.47-.58-2.99-.59-4.08.04-2.52,1.46,2.01,3.2.75,3.93-.41.24-.98.15-1.55-.17-.75-.43-1.42-1.32-1.52-2.11l-2.09.4c.11.69.61,1.42,1.39,2.03l-1.57.91,1.35.78,1.53-.89c1.49.68,3.21.83,4.46.1,2.57-1.49-1.9-3.26-.68-3.98.34-.2.83-.12,1.3.15.58.34,1.23,1.06,1.54,1.75l2.09-.42c-.21-.58-.77-1.23-1.53-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M337.22,212.96v3.51c-.02,2.17-1.44,4.34-4.3,6-5.74,3.34-15.09,3.34-20.87,0-2.91-1.68-4.36-3.89-4.36-6.09v-3.51c0,2.2,1.46,4.41,4.37,6.09,5.78,3.34,15.12,3.34,20.87,0,2.85-1.66,4.28-3.83,4.29-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M332.94,218.98c-3.08,1.79-7.21,2.61-11.26,2.48v3.51c4.05.13,8.17-.69,11.25-2.48,2.85-1.66,4.28-3.83,4.29-6v-3.51c0,2.17-1.42,4.34-4.28,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M332.87,206.88c-5.78-3.34-15.13-3.34-20.87,0-5.74,3.34-5.71,8.75.07,12.09,5.78,3.34,15.12,3.34,20.87,0,5.74-3.34,5.71-8.75-.06-12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M332.87,206.88c-5.78-3.34-15.13-3.34-20.87,0-2.13,1.24-3.46,2.76-4,4.35l27.97,5.15c2.38-3.14,1.35-6.93-3.1-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M312.07,219.22c5.78,3.34,15.12,3.34,20.87,0,2.87-1.67,4.3-3.85,4.29-6.04h0s0-.08,0-.11c-.05,2.14-1.47,4.26-4.28,5.9-5.74,3.34-15.09,3.34-20.87,0-2.85-1.64-4.29-3.79-4.35-5.94-.05,2.24,1.39,4.49,4.35,6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M330.43,208.1c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M330.43,208.3c-4.43-2.56-11.58-2.55-15.98,0-4.4,2.56-4.38,6.7.05,9.26,4.42,2.55,11.58,2.55,15.98,0,4.4-2.55,4.38-6.7-.05-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M312.32,210.05l21.3,3.92c.54-2-.51-4.12-3.18-5.67-4.43-2.56-11.58-2.55-15.98,0-.9.52-1.61,1.12-2.14,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M314.56,208.96c4.4-2.55,11.55-2.56,15.98,0,1.81,1.05,2.88,2.36,3.21,3.73-.11-1.6-1.2-3.18-3.31-4.39-4.43-2.56-11.58-2.55-15.98,0-2.59,1.51-3.64,3.56-3.16,5.52-.12-1.75.96-3.52,3.26-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M326.84,211.24l1.45-.84-1.35-.78-1.5.87c-1.47-.58-2.99-.59-4.08.04-2.52,1.46,2.01,3.2.75,3.93-.41.24-.98.15-1.55-.17-.75-.43-1.42-1.32-1.52-2.11l-2.09.4c.11.69.61,1.42,1.39,2.03l-1.57.91,1.35.78,1.53-.89c1.49.68,3.21.83,4.46.1,2.57-1.49-1.9-3.26-.68-3.98.34-.2.83-.12,1.3.15.58.34,1.23,1.06,1.54,1.75l2.09-.42c-.21-.58-.77-1.23-1.53-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M356.64,166.23l-.3,2.23c-.35,2.59-1.65,5.07-3.9,7.04-5.57,4.87-14.89,4.77-20.81-.22-3.52-2.97-5.05-7-4.53-10.81l.3-2.23c-.52,3.81,1.01,7.84,4.53,10.81,5.92,4.99,15.24,5.09,20.81.22,2.25-1.97,3.55-4.45,3.9-7.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M337.79,176.15c-2.12-.62-4.14-1.65-5.86-3.1-3.52-2.97-5.05-7-4.53-10.81l-.3,2.23c-.52,3.81,1.01,7.84,4.53,10.81,1.94,1.64,4.25,2.74,6.67,3.32l-.51-2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M352.1,155.42c5.92,4.99,6.2,12.99.63,17.85-5.57,4.87-14.89,4.77-20.81-.22-5.92-4.99-6.2-12.98-.63-17.85,5.57-4.87,14.88-4.77,20.8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M352.1,155.42c-5.92-4.99-15.23-5.09-20.8-.22-5.36,4.69-5.29,12.26,0,17.27l22.01-15.89c-.37-.4-.77-.78-1.21-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M352.74,173.58c2.02-1.77,3.26-3.94,3.75-6.24l.15-1.1c-.35,2.59-1.65,5.07-3.9,7.04-5.57,4.87-14.89,4.77-20.81-.22-2.96-2.49-4.5-5.73-4.62-8.96.03,3.33,1.57,6.7,4.62,9.27,5.92,4.99,15.24,5.09,20.81.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M349.8,157.34c-4.53-3.82-11.66-3.9-15.92-.17-4.27,3.73-4.05,9.85.48,13.67,4.53,3.82,11.67,3.9,15.93.17,4.26-3.73,4.05-9.84-.49-13.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M349.74,157.48c-4.53-3.82-11.66-3.9-15.92-.17-4.27,3.73-4.05,9.85.48,13.67,4.53,3.82,11.67,3.9,15.93.17,4.26-3.73,4.05-9.84-.49-13.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M333.82,157.31c-3.55,3.1-3.99,7.85-1.43,11.56l16.59-11.98c-4.54-3.23-11.13-3.11-15.16.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M333.62,157.93c4.26-3.73,11.39-3.65,15.92.17,3.04,2.57,4.13,6.16,3.23,9.38,1.23-3.36.2-7.26-3.03-10-4.53-3.82-11.66-3.9-15.92-.17-1.4,1.23-2.31,2.71-2.75,4.29.49-1.35,1.33-2.61,2.55-3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M346.39,166.7c1.13-1.26,1.33-2.72.04-3.81-2.64-2.23-5.56,1.56-6.82.49-.35-.3-.23-.71.23-1.11.56-.49,1.79-1.02,2.96-1.28l-.79-1.8c-1,.17-2.1.63-3.01,1.27l-1.5-1.26-1.3,1.13,1.55,1.3c-.95,1.25-.92,2.55.19,3.49,2.59,2.19,5.45-1.65,6.75-.55.42.35.29.84-.25,1.32-.72.63-2.22,1.19-3.59,1.25l.75,1.8c1.18-.08,2.43-.49,3.46-1.14l1.62,1.37,1.3-1.13-1.58-1.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "112.84 131.29 94.68 142.14 94.86 108.69 88.81 112.31 101.04 82.76 119.08 94.22 113.03 97.83 112.84 131.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "94.68 142.14 91.65 140.25 91.8 110.52 94.86 108.69 94.68 142.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-204",
    points: "88.81 112.31 85.8 110.42 98.63 81.25 101.04 82.76 88.81 112.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "226.12 370.81 392.61 274.57 203.22 165.2 36.75 261.43 226.12 370.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "226.12 370.81 226.12 376.06 392.61 279.82 392.61 274.57 226.12 370.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-285",
    points: "36.75 261.43 36.75 266.68 226.12 376.06 226.12 370.81 36.75 261.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-192",
    points: "268.26 250.76 350.77 298.76 320.79 316.09 238.35 268.13 268.26 250.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-191",
    points: "304.82 229.46 387.47 277.55 357.5 294.87 274.91 246.83 304.82 229.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M214.94,44.5v121.66c0,1.88-3.32,3.4-7.41,3.4s-7.42-1.52-7.42-3.4V44.5h14.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M200.11,44.5c0,1.88,3.32,3.4,7.42,3.4s7.41-1.52,7.41-3.4-3.32-3.4-7.41-3.4-7.42,1.52-7.42,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M202.05,44.5c0,1.16,2.45,2.1,5.48,2.1s5.48-.94,5.48-2.1-2.45-2.1-5.48-2.1-5.48.94-5.48,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M207.53,98.31c-3.48,0-6.43-1.05-7.41-2.5v-35.19c0,1.88,3.32,3.4,7.41,3.4s7.42-1.52,7.42-3.4v35.19c-.99,1.45-3.93,2.5-7.42,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M190.34,58.73v121.66c0,1.88-3.32,3.4-7.42,3.4s-7.42-1.52-7.42-3.4V58.73h14.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M175.51,58.73c0,1.88,3.32,3.4,7.42,3.4s7.42-1.52,7.42-3.4-3.32-3.4-7.42-3.4-7.42,1.52-7.42,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M177.44,58.73c0,1.16,2.45,2.1,5.48,2.1s5.48-.94,5.48-2.1-2.45-2.1-5.48-2.1-5.48.94-5.48,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M182.92,112.55c-3.48,0-6.43-1.05-7.41-2.5v-35.19c0,1.88,3.32,3.4,7.41,3.4s7.42-1.52,7.42-3.4v35.19c-.99,1.45-3.93,2.5-7.42,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M165.73,72.97v121.66c0,1.88-3.32,3.4-7.42,3.4s-7.42-1.52-7.42-3.4v-121.66h14.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M150.9,72.97c0,1.88,3.32,3.4,7.42,3.4s7.42-1.52,7.42-3.4-3.32-3.4-7.42-3.4-7.42,1.52-7.42,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M152.83,72.97c0,1.16,2.45,2.1,5.48,2.1s5.48-.94,5.48-2.1-2.45-2.1-5.48-2.1-5.48.94-5.48,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M158.31,126.78c-3.48,0-6.43-1.05-7.42-2.5v-35.19c0,1.88,3.32,3.4,7.42,3.4s7.42-1.52,7.42-3.4v35.19c-.99,1.45-3.93,2.5-7.42,2.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-285",
    points: "190.86 249.7 103.31 198.56 103.31 244.84 190.86 295.76 190.86 249.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-194",
    points: "221.85 129.36 103.31 198.56 190.85 249.72 309.59 180.4 221.85 129.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-267",
    points: "309.59 180.39 190.85 249.72 190.86 295.76 309.59 226.68 309.59 180.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-285",
    points: "156.85 211.37 103.31 180.12 103.31 199.1 156.85 230.15 156.85 211.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "172.57 139.83 103.3 180.13 156.84 211.38 226.28 170.98 172.57 139.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-262",
    points: "226.28 170.98 156.84 211.38 156.85 230.15 226.28 189.95 226.28 170.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-179",
    points: "156.83 191.73 103.29 160.48 103.29 170.36 156.83 201.42 156.83 191.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "172.55 120.18 103.28 160.49 156.82 191.74 226.26 151.34 172.55 120.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-266",
    points: "226.26 151.33 156.82 191.74 156.83 201.42 226.26 161.22 226.26 151.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-265",
    points: "156.83 201.42 107.25 172.66 107.25 179.97 156.83 208.73 156.83 201.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-264",
    points: "221.11 164.2 156.83 201.42 156.83 208.73 221.11 171.3 221.11 164.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "171.63 122.31 110.51 157.87 157.75 185.45 219.03 149.8 171.63 122.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-263",
    points: "110.51 157.87 103.28 160.49 156.82 191.74 157.75 185.45 110.51 157.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "157.75 185.45 156.82 191.74 226.26 151.33 219.03 149.8 157.75 185.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "219.03 149.8 226.26 151.33 172.55 120.18 171.63 122.31 219.03 149.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "103.28 160.49 110.51 157.87 171.63 122.31 172.55 120.18 103.28 160.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "274.96 244.08 302.47 228.09 304.83 229.46 274.96 246.84 274.96 244.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "302.47 228.09 302.47 204.2 274.96 220.08 274.96 244.08 302.47 228.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-285",
    points: "304.83 202.84 304.83 229.46 302.47 228.09 302.47 204.2 304.83 202.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "238.35 265.37 265.86 249.38 268.22 250.75 238.35 268.13 238.35 265.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "265.86 249.38 265.86 225.5 238.35 241.37 238.35 265.37 265.86 249.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-285",
    points: "268.22 224.13 268.22 250.75 265.86 249.38 265.86 225.5 268.22 224.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "121.87 260.24 121.87 277.52 135.35 269.74 135.35 252.46 121.87 260.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-260",
    points: "121.87 260.24 121.87 277.52 80.63 253.71 80.63 236.43 121.87 260.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "117.59 261.16 117.59 266.54 104.76 259.13 104.76 253.75 117.59 261.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "117.59 268.75 117.59 272.43 108.8 267.36 108.8 263.68 117.59 268.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-258",
    points: "135.35 252.46 121.87 260.24 80.63 236.43 94.12 228.65 135.35 252.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "100.09 272.93 100.09 290.21 113.57 282.43 113.57 265.14 100.09 272.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-249",
    points: "100.09 272.93 100.09 290.21 58.85 266.39 58.85 249.11 100.09 272.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "95.81 273.85 95.81 279.23 82.98 271.82 82.98 266.44 95.81 273.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "95.81 281.44 95.81 285.12 87.03 280.05 87.03 276.37 95.81 281.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-255",
    points: "113.57 265.14 100.09 272.93 58.85 249.11 72.34 241.33 113.57 265.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "121.16 227.42 121.16 220.77 111.03 214.91 111.03 221.53 121.16 227.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "111.03 214.91 112.32 215.65 112.32 220.81 111.03 221.53 111.03 214.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "112.32 220.81 121.16 225.9 121.16 227.42 111.03 221.53 112.32 220.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-254",
    points: "136.37 236.29 136.37 229.63 126.24 223.77 126.24 230.39 136.37 236.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "126.24 223.77 127.53 224.51 127.53 229.67 126.24 230.39 126.24 223.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "127.53 229.67 136.37 234.77 136.37 236.29 126.24 230.39 127.53 229.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-257",
    points: "151.57 245.15 151.57 238.5 141.45 232.64 141.45 239.26 151.57 245.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "141.45 232.64 142.74 233.37 142.74 238.54 141.45 239.26 141.45 232.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "142.74 238.54 151.57 243.63 151.57 245.15 141.45 239.26 142.74 238.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-256",
    points: "166.78 254.02 166.78 247.36 156.66 241.5 156.66 248.12 166.78 254.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "156.66 241.5 157.95 242.24 157.95 247.4 156.66 248.12 156.66 241.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "157.95 247.4 166.78 252.5 166.78 254.02 156.66 248.12 157.95 247.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-250",
    points: "181.99 262.88 181.99 256.23 171.87 250.37 171.87 256.98 181.99 262.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "171.87 250.37 173.16 251.1 173.16 256.27 171.87 256.98 171.87 250.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "173.16 256.27 181.99 261.36 181.99 262.88 171.87 256.98 173.16 256.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "253.3 311.27 269.19 301.9 232.99 280.81 217.11 290.18 253.3 311.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "243.46 299.76 220.2 286.52 221.46 285.52 243.46 298.63 243.46 299.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "219.49 287.52 221.75 286.07 219.49 284.77 219.49 287.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M225.79,294.79s.02-.01.03-.02c.03-.02.05-.04.07-.07,0,0,0,0,.01-.01.03-.03.05-.05.08-.08,0,0,.01-.02.02-.03.02-.02.04-.04.06-.07,0,0,.02-.02.02-.03.02-.03.04-.05.06-.08,0,0,0-.01.01-.02.02-.04.05-.07.07-.11.02-.04.04-.08.06-.12,0,0,0-.01,0-.02.02-.03.03-.07.04-.1,0-.01,0-.02.01-.03,0-.02.01-.04.02-.06.01-.03.02-.07.03-.1,0-.02.01-.04.02-.07,0-.03.02-.06.02-.09,0-.03.01-.05.02-.08,0-.03.01-.05.02-.08,0-.03.01-.06.02-.09,0-.02,0-.05.01-.07,0-.03,0-.06.01-.1,0-.02,0-.04,0-.07,0-.04,0-.08,0-.12,0-.02,0-.03,0-.05,0-.06,0-.12,0-.18,0-.06,0-.11,0-.17,0-.02,0-.04,0-.06,0-.04,0-.08,0-.12,0-.02,0-.04,0-.06,0-.04,0-.09-.01-.13,0-.02,0-.03,0-.05,0-.06-.02-.12-.03-.18,0,0,0-.02,0-.02,0-.05-.02-.11-.03-.16,0-.02,0-.04-.01-.06,0-.04-.02-.08-.03-.12,0-.02-.01-.05-.02-.07,0-.04-.02-.08-.03-.12,0-.02-.01-.05-.02-.07-.01-.04-.02-.09-.04-.13,0-.02-.01-.04-.02-.06-.02-.06-.04-.12-.06-.19,0,0,0,0,0-.01-.02-.06-.04-.11-.06-.17,0-.02-.01-.04-.02-.06-.02-.04-.03-.09-.05-.13,0-.02-.02-.04-.02-.06-.02-.04-.04-.09-.06-.13,0-.02-.01-.03-.02-.05-.03-.06-.05-.12-.08-.18,0-.01-.01-.03-.02-.04-.02-.05-.04-.09-.07-.14-.02-.03-.03-.06-.05-.1-.02-.03-.03-.06-.05-.09-.04-.08-.09-.17-.14-.25-.02-.03-.03-.06-.05-.08-.02-.03-.04-.07-.06-.1-.02-.03-.04-.06-.06-.09-.02-.03-.04-.07-.06-.1-.01-.02-.03-.04-.04-.06-.06-.09-.12-.18-.18-.26,0,0,0,0,0,0-.04-.06-.09-.12-.14-.18-.04-.04-.07-.09-.11-.13,0,0-.01-.02-.02-.03-.04-.05-.09-.1-.13-.15-.01-.01-.03-.03-.04-.04-.03-.04-.06-.07-.1-.1-.02-.02-.04-.04-.06-.06-.03-.03-.06-.06-.08-.09-.02-.02-.04-.04-.06-.06-.03-.03-.05-.05-.08-.08-.02-.02-.04-.04-.07-.06-.03-.02-.05-.05-.08-.07-.02-.02-.04-.04-.07-.06-.03-.02-.06-.05-.08-.07-.02-.02-.04-.04-.07-.05-.03-.02-.06-.05-.09-.07-.02-.02-.04-.03-.06-.05-.03-.02-.07-.05-.1-.07-.02-.01-.03-.02-.05-.04-.05-.03-.1-.07-.15-.1,0,0,0,0,0,0-.05-.03-.1-.06-.16-.1-.05-.03-.09-.05-.14-.08-.02,0-.04-.02-.05-.03-.04-.02-.07-.03-.11-.05-.02,0-.03-.02-.05-.02-.05-.02-.1-.04-.15-.06-.05-.02-.1-.04-.15-.05-.02,0-.03,0-.05-.02-.03-.01-.07-.02-.1-.03-.02,0-.04-.01-.06-.02-.03,0-.06-.02-.09-.02-.02,0-.04,0-.06-.01-.03,0-.06-.01-.08-.02-.02,0-.04,0-.07-.01-.03,0-.05,0-.08,0-.02,0-.05,0-.07,0-.02,0-.04,0-.07,0-.03,0-.05,0-.08,0-.04,0-.08,0-.11,0,0,0,0,0-.01,0-.04,0-.07,0-.11,0-.01,0-.02,0-.03,0-.04,0-.08.01-.12.02-.01,0-.02,0-.03,0-.03,0-.06.01-.09.02-.01,0-.03,0-.04.01-.02,0-.05.02-.07.02-.03.01-.06.02-.09.03-.01,0-.03.01-.04.02-.04.02-.08.04-.12.06,0,0,3.07-1.78,3.07-1.78.04-.02.08-.04.12-.06.01,0,.03-.01.04-.02.45-.19.98-.15,1.44,0,.46.15.9.41,1.28.71.01,0,.02.02.03.03.02.02.04.04.07.05,1.38,1.14,2.37,2.94,2.5,4.73.04.62-.02,1.33-.36,1.86,0,0,0,0,0,0,0,0,0,.01-.01.02-.02.03-.04.05-.06.08,0,0-.02.02-.02.03-.02.02-.04.05-.06.07,0,0-.01.02-.02.03-.03.03-.05.06-.08.08,0,0,0,0-.01.01-.02.02-.05.04-.07.07,0,0-.02.01-.03.02-.02.02-.04.03-.07.05,0,0-.02.01-.03.02-.03.02-.06.04-.1.06l-3.07,1.78s.06-.04.1-.06c0,0,.02-.01.03-.02.02-.02.04-.03.07-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M223.33,287.3c1.78,1.03,3.21,3.51,3.21,5.55,0,2.04-1.45,2.86-3.23,1.84-1.78-1.02-3.21-3.51-3.21-5.55,0-2.04,1.45-2.86,3.23-1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M223.22,288.74c1.1.63,1.99,2.12,2.09,3.4,0,.08,0,.16,0,.23,0,1.34-.95,1.88-2.11,1.2-1.16-.67-2.1-2.3-2.1-3.64,0-.08,0-.15,0-.22.1-1.17,1.01-1.61,2.1-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M223.22,289.4c.8.46,1.45,1.54,1.52,2.47,0,.06,0,.11,0,.17,0,.97-.69,1.36-1.54.88-.85-.49-1.53-1.67-1.53-2.64,0-.06,0-.11,0-.16.07-.85.73-1.17,1.53-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M221.69,290.11c.06-.71.52-1.05,1.13-.88-.47-.01-.81.32-.87.92,0,.05,0,.11,0,.16,0,.97.68,2.16,1.53,2.64.14.08.27.13.4.17-.2,0-.43-.07-.67-.21-.85-.49-1.53-1.67-1.53-2.64,0-.06,0-.11,0-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M222.64,291.34s-.09-.03-.12-.01c-.07.04-.07.16,0,.28.03.06.08.1.12.13.04.03.09.03.12.01.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M223.31,290.71c-.22-.12-.39-.02-.39.22,0,.25.17.55.39.68.22.12.39.02.39-.22,0-.25-.17-.55-.39-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M223.31,292.05c-.09-.06-.17-.01-.17.1,0,.11.08.24.17.3.09.06.17.01.17-.1,0-.11-.08-.24-.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M223.98,292.12s-.09-.03-.12-.01c-.07.04-.07.16,0,.28.03.06.08.1.12.13.04.03.09.03.12.01.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M222.64,289.8s-.09-.03-.12-.01c-.07.04-.07.16,0,.28.03.06.08.1.12.13.04.03.09.03.12.01.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M223.31,290.26c.09.05.17.01.17-.1,0-.11-.08-.24-.17-.3-.09-.05-.17-.01-.17.1,0,.11.08.24.17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M223.98,290.97s.09.03.12.01c.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13-.04-.03-.09-.03-.12-.01-.07.04-.07.16,0,.28.03.06.08.1.12.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M222.53,290.71c0-.11-.08-.24-.17-.3-.09-.06-.17-.01-.17.1,0,.11.08.24.17.3.1.06.17.01.17-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M224.26,291.51c-.09-.05-.17-.01-.17.1,0,.11.08.24.17.3.1.06.17.01.17-.1,0-.11-.08-.24-.17-.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "245.02 297.66 256.65 291.07 229.62 275.38 217.99 281.97 245.02 297.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M243.29,297.73s0,0,0,0c0,0,0,0-.02,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0,0,0-.02,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.02,0-.02,0,0,0-.02,0-.03,0,0,0,0,0,0,0,0,0-.01,0-.02,0h-.01s-.01,0-.02,0c0,0,0,0-.01,0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.02,0-.03,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.02,0-.02,0,0,0,0,0,0,0,0,0-.02,0-.03.01,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.02,0-.03.01,0,0,0,0,0,0,0,0-.02.01-.03.02,0,0,0,0,0,0,0,0-.02.01-.03.02l-6.33-3.68s.02-.01.03-.02c0,0,0,0,0,0,0,0,0,0,0,0,0,0,.02,0,.02-.01,0,0,0,0,0,0,0,0,.02,0,.03-.01,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,.02,0,.03-.01,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.02,0,.02,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,.02,0,.03,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,.01,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,.02,0s0,0,.01,0h.02s0,0,0,0c0,0,0,0,0,0,0,0,.01,0,.02,0h0s.02,0,.03,0h0s.01,0,.02,0c0,0,0,0,0,0h.02s0,0,0,0c0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,.01,0,0,0,0,0,.01,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,.02,0,.02.01h0s6.33,3.68,6.33,3.68c0,0-.02,0-.02-.01,0,0,0,0,0,0,0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-173",
    points: "242.44 297.84 236.11 294.15 235.34 294.6 241.67 298.28 242.44 297.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M234.09,296.73h0s0-.02,0-.02c0,0,0,0,0-.01s0,0,0-.01c0,0,0-.02,0-.03,0,0,0,0,0,0h0s0-.02,0-.03c0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0-.02,0-.02,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0-.01,0-.02,0-.03h0s0,0,0-.01c0,0,0-.02,0-.03,0,0,0,0,0-.01s0,0,0-.01c0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0-.02,0-.02,0,0,0,0,0-.01,0,0,0,0,0,0,0-.01,0-.02,0-.03,0,0,0,0,0,0,0-.01,0-.02,0-.03h0s0-.01,0-.01c0,0,0-.02,0-.03,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0-.02,0-.02,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0-.02,0-.02,0,0,0,0,0,0,0-.01,0-.02.01-.03h0s0,0,0-.01c0,0,0-.02,0-.03,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0-.02,0-.03,0,0,0,0,0,0,0,0,0,0,0,0,0-.01,0-.02.01-.03,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0-.02.01-.04.02-.05,0,0,0,0,0,0,0,0,0,0,0,0,0-.02.01-.03.02-.05,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0-.02.01-.02,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0,0,0,0,0-.02.02-.03.03-.05,0,0,0,0,0,0,0-.02.02-.03.03-.04,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01.01-.02,0,0,0-.01.01-.02,0,0,0-.01.01-.02,0,0,0-.01.01-.02,0,0,0-.01.01-.02,0,0,0-.01.01-.02,0,0,0-.01.01-.02,0,0,0,0,0-.01,0,0,0,0,0,0,.01-.02.02-.03.03-.05,0,0,0,0,0-.01.01-.02.02-.03.04-.05h0s0,0,0,0c0,0,.01-.02.02-.03,0,0,0,0,.01-.01,0,0,.01-.02.02-.02,0,0,0,0,0,0,0,0,0,0,.01-.01,0,0,0,0,.01-.01,0,0,.01-.01.02-.02,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,.02-.02.02-.03,0,0,0,0,0,0,0,0,.02-.02.02-.03,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01-.01.02-.02,0,0,0,0,.01-.01,0,0,0,0,.01-.01,0,0,0,0,0,0,0,0,0,0,.01-.01,0,0,.01-.01.02-.02,0,0,0,0,.01-.01,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01-.01,0,0,.01-.01.02-.02,0,0,0,0,.01-.01,0,0,0,0,0,0,0,0,0,0,.01-.01,0,0,0,0,.01-.01,0,0,.01-.01.02-.02,0,0,0,0,.01-.01,0,0,0,0,0,0,0,0,.01,0,.02-.01,0,0,0,0,.01,0,0,0,.02-.01.02-.02,0,0,0,0,0,0h0s.02-.02.03-.02c0,0,0,0,0,0,0,0,.01,0,.02-.01,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,.01,0,.02-.01,0,0,0,0,.01,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,.01,0,.02-.01,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,.02-.01.03-.02h0s0,0,0,0c0,0,.02-.01.03-.02,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,.01,0l6.33,3.68s-.02,0-.03.02c0,0,0,0,0,0,0,0-.02.01-.03.02,0,0,0,0,0,0,0,0-.02.01-.03.02,0,0,0,0,0,0,0,0-.01,0-.02.01,0,0,0,0-.01,0,0,0-.01,0-.02.01,0,0,0,0-.01,0,0,0-.01,0-.02.01,0,0,0,0-.01,0,0,0-.01,0-.02.01,0,0,0,0-.01,0,0,0-.01.01-.02.02,0,0,0,0,0,0,0,0-.02.02-.03.02,0,0,0,0,0,0,0,0-.02.01-.02.02,0,0,0,0-.01,0,0,0-.01.01-.02.02,0,0,0,0-.01.01,0,0-.01.01-.02.02,0,0,0,0-.01.01,0,0-.01.01-.02.02,0,0,0,0-.01.01,0,0-.01.01-.02.02,0,0,0,0-.01.01,0,0-.01.01-.02.02,0,0,0,0-.01.01,0,0-.01.01-.02.02,0,0,0,0-.01.01,0,0-.01.01-.02.02,0,0,0,0-.01.01,0,0-.01.01-.02.02,0,0,0,0,0,0,0,0-.02.02-.03.03,0,0,0,0,0,0,0,.01-.02.02-.03.03,0,0,0,0,0,.01,0,0-.01.01-.02.02,0,0,0,0-.01.01,0,0,0,.01-.01.02,0,0-.01.01-.02.02,0,0,0,0,0,.01,0,0-.01.02-.02.03,0,0,0,0,0,0-.01.02-.02.03-.04.05,0,0,0,0,0,.01-.01.02-.02.03-.03.05,0,0,0,.01-.01.02,0,0,0,.01-.01.02,0,0,0,.01-.01.02,0,0,0,.01-.01.02,0,0,0,.01-.01.02,0,0,0,.01-.01.02,0,0,0,.01-.01.02,0,0,0,.01-.01.02,0,0,0,0,0,.01,0,.01-.02.03-.03.04,0,0,0,0,0,0,0,.02-.02.03-.03.05,0,0,0,.01,0,.02,0,0,0,.01,0,.02,0,0,0,.01,0,.02,0,0,0,.01,0,.02,0,0,0,.01-.01.02,0,0,0,0,0,.01,0,0,0,.02-.01.02,0,0,0,0,0,.01,0,0,0,0,0,0,0,.02-.02.03-.02.05,0,0,0,0,0,.01,0,.02-.02.03-.02.05,0,0,0,.02-.01.03,0,0,0,0,0,0,0,.01,0,.02-.01.04,0,0,0,0,0,0,0,0,0,.02,0,.03,0,0,0,0,0,.01,0,0,0,.02,0,.02,0,0,0,0,0,.01,0,0,0,.02,0,.03,0,0,0,0,0,0,0,.01,0,.02-.01.04,0,0,0,0,0,0,0,0,0,.02,0,.03,0,0,0,0,0,.01,0,0,0,.02,0,.02,0,0,0,0,0,.01,0,0,0,.02,0,.02,0,0,0,0,0,.01,0,0,0,.02,0,.03,0,0,0,0,0,.01,0,.01,0,.02,0,.04,0,0,0,0,0,0,0,.01,0,.02,0,.03,0,0,0,0,0,.01,0,0,0,.02,0,.02,0,0,0,0,0,.01,0,0,0,.02,0,.02,0,0,0,0,0,.01,0,0,0,.02,0,.03,0,0,0,0,0,0,0,.01,0,.02,0,.04,0,0,0,0,0,0,0,0,0,.02,0,.03,0,0,0,0,0,.01,0,0,0,.02,0,.02,0,0,0,0,0,.01,0,0,0,.02,0,.03,0,0,0,0,0,0,0,.01,0,.02,0,.03,0,0,0,0,0,0,0,0,0,.02,0,.03,0,0,0,0,0,.01,0,0,0,.02,0,.02,0,0,0,0,0,.01,0,.01,0,.02,0,.03s0,.02,0,.04h0s0,.02,0,.03c0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,.01,0,.02,0,.03,0,0,0,0,0,0,0,0,0,.02,0,.03,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,.01,0,.02,0,.03,0,0,0,0,0,0,0,0,0,.02,0,.03,0,0,0,0,0,0,0,0,0,.02,0,.02,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,.02,0,.03,0,0,0,0,0,0,0,.01,0,.02.01.03,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,.02.01.02,0,0,0,0,0,0,0,0,0,0,0,.02,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,.01.01.02,0,0,0,0,0,0,0,0,0,.01.01.02,0,0,0,0,0,0,0,0,0,0,.01.01,0,0,0,0,0,0,0,0,0,0,.01.01,0,0,0,0,0,0,0,0,.01.01.02.02,0,0,0,0,0,0,0,0,0,0,.01.01,0,0,0,0,0,0,0,0,0,0,.01.01,0,0,0,0,0,0,0,0,.01,0,.02.01,0,0,0,0,0,0,0,0,0,0,.02.01,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,.01,0,.02.01h0l-6.33-3.68s-.01,0-.02-.01c0,0,0,0,0,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0-.01,0-.01-.01,0,0,0,0,0,0,0,0-.01,0-.02-.01,0,0,0,0,0,0,0,0,0,0-.01-.01,0,0,0,0,0,0,0,0,0,0-.01-.01,0,0,0,0,0,0l-.02-.02s0,0,0,0c0,0,0,0-.01-.01,0,0,0,0,0,0,0,0,0,0-.01-.01,0,0,0,0,0,0,0,0,0-.01-.01-.02,0,0,0,0,0,0,0,0,0-.01-.01-.02,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.02-.01-.02,0,0,0,0,0,0,0,0,0-.01,0-.02h0s0-.02-.01-.03c0,0,0,0,0,0,0,0,0-.02,0-.03,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0-.02,0-.02,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.02,0-.03,0,0,0,0,0,0,0-.01,0-.02,0-.03h0s0-.01,0-.02c0,0,0,0,0-.01,0,0,0-.02,0-.03,0,0,0,0,0,0h0s0-.02,0-.03c0,0,0,0,0,0,0,0,0-.01,0-.02h0s0-.01,0-.01c0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0-.01,0-.02,0-.03h0s0-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M241.67,298.28c-.69.4-1.25,1.37-1.25,2.17,0,.79.57,1.12,1.26.72l.77-.44c.69-.4,1.25-1.37,1.25-2.17,0-.79-.57-1.12-1.26-.72l-.77.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "217.97 286.64 217.99 281.97 245.02 297.66 245.02 302.32 243.46 301.42 243.46 298.63 219.49 284.77 219.49 287.52 217.97 286.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "256.95 276.1 244.37 283.41 217.62 267.89 230.15 260.6 256.95 276.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "244.37 283.41 244.37 297.4 256.95 290.08 256.95 276.1 244.37 283.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "217.62 267.89 244.37 283.41 244.37 297.4 217.62 281.88 217.62 267.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M251.61,309.69s.02-.01.03-.02c.03-.02.05-.04.07-.07,0,0,0,0,.01-.01.03-.03.05-.05.08-.08,0,0,.01-.02.02-.02.02-.02.04-.04.06-.07,0-.01.02-.02.02-.03.02-.03.04-.05.06-.08,0,0,0-.01.01-.02.02-.04.05-.07.07-.11.02-.04.04-.08.06-.12,0,0,0-.01,0-.02.02-.03.03-.07.04-.1,0,0,0-.02.01-.03,0-.02.02-.04.02-.06.01-.03.02-.07.03-.1,0-.02.01-.04.02-.07,0-.03.02-.06.02-.09,0-.03.01-.05.02-.08,0-.03.01-.05.02-.08,0-.03.01-.06.02-.09,0-.02,0-.05.01-.07,0-.03,0-.06.01-.1,0-.02,0-.04,0-.07,0-.04,0-.08,0-.12,0-.02,0-.03,0-.05,0-.06,0-.12,0-.18,0-.06,0-.11,0-.17,0-.02,0-.04,0-.06,0-.04,0-.08,0-.12,0-.02,0-.04,0-.06,0-.04,0-.09-.01-.13,0-.02,0-.03,0-.05,0-.06-.02-.12-.03-.18,0,0,0-.02,0-.02,0-.05-.02-.11-.03-.16,0-.02,0-.04-.01-.06,0-.04-.02-.08-.03-.12,0-.02-.01-.05-.02-.07,0-.04-.02-.08-.03-.12,0-.02-.01-.05-.02-.07-.01-.04-.02-.09-.04-.13,0-.02-.01-.04-.02-.06-.02-.06-.04-.12-.06-.19,0,0,0,0,0-.01-.02-.06-.04-.11-.06-.17,0-.02-.01-.04-.02-.06-.02-.04-.03-.09-.05-.13,0-.02-.02-.04-.02-.06-.02-.04-.04-.09-.06-.13,0-.02-.01-.03-.02-.05-.03-.06-.05-.12-.08-.18,0-.01-.01-.03-.02-.04-.02-.05-.04-.09-.07-.14-.02-.03-.03-.06-.05-.1-.02-.03-.03-.06-.05-.09-.05-.08-.09-.17-.14-.25-.02-.03-.03-.06-.05-.08-.02-.03-.04-.07-.06-.1-.02-.03-.04-.06-.06-.09-.02-.03-.04-.07-.06-.1-.01-.02-.03-.04-.04-.06-.06-.09-.12-.17-.18-.26,0,0,0,0,0,0-.04-.06-.09-.12-.14-.18-.04-.05-.07-.09-.11-.13,0,0-.01-.02-.02-.03-.04-.05-.09-.1-.13-.15-.01-.01-.03-.03-.04-.04-.03-.04-.06-.07-.1-.1-.02-.02-.04-.04-.06-.06-.03-.03-.06-.06-.08-.09-.02-.02-.04-.04-.06-.06-.03-.03-.05-.05-.08-.08-.02-.02-.04-.04-.07-.06-.03-.03-.06-.05-.08-.07-.02-.02-.04-.04-.07-.06-.03-.02-.06-.05-.08-.07-.02-.02-.04-.04-.07-.05-.03-.02-.06-.05-.09-.07-.02-.02-.04-.03-.06-.05-.03-.02-.07-.05-.1-.07-.02-.01-.03-.02-.05-.04-.05-.03-.1-.07-.15-.1,0,0,0,0,0,0-.05-.03-.1-.06-.16-.09-.05-.03-.09-.05-.14-.08-.02,0-.04-.02-.05-.03-.04-.02-.07-.03-.11-.05-.02,0-.03-.01-.05-.02-.05-.02-.1-.04-.15-.06-.05-.02-.1-.04-.15-.05-.02,0-.03,0-.05-.01-.03-.01-.07-.02-.1-.03-.02,0-.04-.01-.06-.02-.03,0-.06-.02-.09-.02-.02,0-.04,0-.06-.01-.03,0-.06-.01-.08-.02-.02,0-.04,0-.07-.01-.03,0-.05,0-.08,0-.02,0-.05,0-.07,0-.02,0-.04,0-.07,0-.03,0-.05,0-.08,0-.04,0-.07,0-.11,0,0,0,0,0-.01,0-.04,0-.07,0-.11,0-.01,0-.02,0-.03,0-.04,0-.08.01-.12.02,0,0-.02,0-.03,0-.03,0-.06.01-.09.02-.01,0-.03,0-.04.01-.02,0-.05.01-.07.02-.03.01-.06.02-.09.03-.01,0-.03.01-.04.02-.04.02-.08.04-.12.06,0,0,2.38-1.39,2.38-1.39.04-.02.08-.04.12-.06.01,0,.03-.01.04-.02.45-.19.98-.15,1.44,0,.46.15.9.41,1.28.71.01,0,.02.02.03.03.02.02.04.04.07.05,1.38,1.14,2.37,2.94,2.5,4.73.05.62-.02,1.33-.36,1.86,0,0,0,0,0,0,0,0,0,.01-.01.02-.02.03-.04.05-.06.08,0,.01-.02.02-.02.03-.02.02-.04.05-.06.07,0,0-.01.02-.02.02-.03.03-.05.06-.08.08,0,0,0,0-.01.01-.02.02-.05.05-.07.07,0,0-.02.01-.03.02-.02.02-.04.03-.07.05,0,0-.02.01-.03.02-.03.02-.06.04-.1.06l-2.38,1.39s.06-.04.1-.06c0,0,.02-.01.03-.02.02-.02.04-.03.07-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M249.15,302.21c1.78,1.03,3.21,3.51,3.21,5.55,0,2.04-1.45,2.86-3.23,1.84-1.78-1.03-3.21-3.51-3.21-5.55,0-2.04,1.45-2.86,3.23-1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M249.04,303.64c1.1.63,1.99,2.12,2.09,3.4,0,.08,0,.16,0,.23,0,1.34-.95,1.88-2.11,1.2-1.16-.67-2.1-2.3-2.1-3.64,0-.08,0-.15,0-.22.1-1.17,1.01-1.61,2.1-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M249.04,304.3c.8.46,1.45,1.54,1.52,2.47,0,.06,0,.11,0,.17,0,.97-.69,1.36-1.54.88-.85-.49-1.53-1.67-1.53-2.64,0-.06,0-.11,0-.16.08-.85.73-1.17,1.53-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M247.51,305.02c.06-.71.52-1.05,1.13-.88-.47-.01-.81.32-.87.92,0,.05,0,.11,0,.16,0,.97.68,2.16,1.53,2.64.14.08.27.14.4.17-.2,0-.43-.07-.66-.21-.85-.49-1.53-1.67-1.53-2.64,0-.06,0-.11,0-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M248.46,306.25s-.09-.03-.12-.01c-.07.04-.07.16,0,.28.03.06.08.1.12.13.04.03.09.03.12.01.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M249.14,305.61c-.22-.12-.39-.02-.39.22,0,.25.17.55.39.68.22.12.39.02.39-.22,0-.25-.17-.55-.39-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M249.13,306.96c-.1-.05-.17-.01-.17.1,0,.11.08.24.17.3.1.06.17.01.17-.1,0-.11-.08-.24-.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M249.81,307.03s-.09-.03-.12-.01c-.07.04-.07.16,0,.28.03.06.08.1.12.13.04.03.09.03.12.01.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M248.47,304.71s-.09-.03-.12-.01c-.07.04-.07.16,0,.28.03.06.08.1.12.13.04.03.09.03.12.01.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M249.14,305.17c.09.05.17.01.17-.1,0-.11-.08-.24-.17-.3-.1-.05-.17-.01-.17.1,0,.11.08.24.17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M249.81,305.88s.09.03.12.01c.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13-.04-.03-.09-.03-.12-.01-.07.04-.07.16,0,.28.03.06.08.1.12.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M248.36,305.61c0-.11-.08-.24-.17-.3-.09-.05-.17-.01-.17.1,0,.11.08.24.17.3.09.05.17.01.17-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M250.09,306.41c-.09-.05-.17-.01-.17.1,0,.11.08.24.17.3.09.05.17.01.17-.1,0-.11-.08-.24-.17-.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "254.44 307.77 266.11 301.17 266.13 294.12 254.46 300.72 254.44 307.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "254.46 300.72 266.13 294.12 264.54 287.26 252.87 293.86 254.46 300.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "252.87 293.86 264.54 287.26 256.72 282.74 245.05 289.34 252.87 293.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M252.87,293.86l1.59,6.86,11.67-6.6-1.59-6.86-11.67,6.6ZM253.4,294.09l10.84-6.13,1.37,5.92-10.84,6.13-1.37-5.92Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-114"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-181",
    points: "264.05 296.62 264.05 301.15 256.52 305.5 256.52 300.97 264.05 296.62"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "255.01 306.51 255.01 308.1 266.62 301.42 266.62 299.84 255.01 306.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "255.01 306.51 255.01 308.1 254.44 307.78 254.44 306.19 255.01 306.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "266.62 299.84 255.01 306.51 254.44 306.19 266.05 299.51 266.62 299.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "254.46 304.57 256.32 303.49 256.32 304.61 254.46 305.68 254.46 304.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "264.27 298.9 266.13 297.83 266.13 298.95 264.27 300.02 264.27 298.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M245.05,289.34l7.83,4.52,1.59,6.86-.02,7.06-1.67-.97c-.43-2-1.83-4.1-3.49-5.06-1.66-.96-3.06-.49-3.5,1.01l-.75-.43v-4.66l.02-8.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M248.15,291.71c-.08-.05-.15,0-.15.09v4.09c-.01.09.06.21.14.26l5.19,3c.1.06.18-.02.14-.15l-.92-4.63c-.02-.08-.08-.16-.14-.2l-4.26-2.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-284",
    points: "255.29 306.91 255.29 307.64 256.71 306.83 256.71 306.1 255.29 306.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-284",
    points: "264.98 301.36 264.98 302.09 266.39 301.28 266.39 300.55 264.98 301.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "228.54 290 228.54 292.64 233.45 295.43 233.45 292.84 228.54 290"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "233.45 295.43 234.38 294.92 234.38 293.38 233.45 292.84 233.45 295.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "253.4 294.09 265.61 293.89 264.23 287.96 253.4 294.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "230.12 286.14 228.74 285.35 228.74 276.19 230.12 276.98 230.12 286.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "224.04 281.08 225.7 282.04 225.7 274.44 227.08 275.23 227.08 282.84 227.08 284.38 225.7 283.59 225.7 283.59 222.66 281.84 222.66 280.29 222.66 272.68 224.04 273.47 224.04 281.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "221 271.72 221 280.87 219.63 280.08 219.63 270.93 221 271.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "230.25 325.35 246.14 315.98 209.95 294.89 194.07 304.26 230.25 325.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "220.42 313.84 197.16 300.6 198.41 299.6 220.42 312.72 220.42 313.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "196.44 301.6 198.7 300.15 196.44 298.85 196.44 301.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M202.74,308.87s.02-.01.03-.02c.03-.02.05-.04.07-.07,0,0,0,0,.01-.01.03-.03.05-.05.08-.08,0,0,.01-.02.02-.03.02-.02.04-.04.06-.07,0,0,.02-.02.02-.03.02-.03.04-.05.06-.08,0,0,0-.01.01-.02.02-.04.05-.07.07-.11.02-.04.04-.08.06-.12,0,0,0-.01,0-.02.02-.03.03-.07.04-.1,0-.01,0-.02.01-.03,0-.02.02-.04.02-.06.01-.03.02-.07.03-.1,0-.02.01-.04.02-.07,0-.03.02-.06.02-.09,0-.03.01-.05.02-.08,0-.03.01-.05.02-.08,0-.03.01-.06.02-.09,0-.02,0-.05.01-.07,0-.03,0-.06.01-.1,0-.02,0-.04,0-.07,0-.04,0-.08,0-.12,0-.02,0-.03,0-.05,0-.06,0-.12,0-.18,0-.06,0-.11,0-.17,0-.02,0-.04,0-.06,0-.04,0-.08,0-.12,0-.02,0-.04,0-.06,0-.04,0-.09-.01-.13,0-.02,0-.03,0-.05,0-.06-.02-.12-.03-.18,0,0,0-.02,0-.02,0-.05-.02-.11-.03-.16,0-.02,0-.04-.01-.06,0-.04-.02-.08-.03-.12,0-.02-.01-.05-.02-.07,0-.04-.02-.08-.03-.12,0-.02-.01-.05-.02-.07-.01-.04-.02-.08-.04-.13,0-.02-.01-.04-.02-.06-.02-.06-.04-.12-.06-.19,0,0,0,0,0-.01-.02-.06-.04-.11-.06-.17,0-.02-.01-.04-.02-.06-.02-.04-.03-.09-.05-.13,0-.02-.02-.04-.02-.06-.02-.04-.04-.09-.06-.13,0-.02-.01-.03-.02-.05-.03-.06-.05-.12-.08-.18,0-.02-.01-.03-.02-.04-.02-.05-.04-.09-.07-.14-.02-.03-.03-.06-.05-.1-.02-.03-.03-.06-.05-.09-.04-.08-.09-.17-.14-.25-.02-.03-.03-.06-.05-.08-.02-.03-.04-.07-.06-.1-.02-.03-.04-.06-.06-.09-.02-.03-.04-.07-.06-.1-.01-.02-.03-.04-.04-.06-.06-.09-.12-.18-.18-.26,0,0,0,0,0,0-.04-.06-.09-.12-.14-.18-.04-.05-.07-.09-.11-.13,0,0-.01-.02-.02-.03-.04-.05-.09-.1-.13-.15-.01-.01-.03-.03-.04-.04-.03-.04-.06-.07-.1-.1-.02-.02-.04-.04-.06-.06-.03-.03-.06-.06-.08-.09-.02-.02-.04-.04-.06-.06-.03-.03-.05-.05-.08-.08-.02-.02-.04-.04-.07-.06-.03-.02-.05-.05-.08-.07-.02-.02-.04-.04-.07-.06-.03-.02-.06-.05-.08-.07-.02-.02-.04-.04-.06-.05-.03-.02-.06-.05-.09-.07-.02-.02-.04-.03-.06-.05-.03-.02-.07-.05-.1-.07-.02-.01-.03-.02-.05-.04-.05-.03-.1-.07-.15-.1,0,0,0,0,0,0-.05-.03-.1-.06-.16-.09-.05-.03-.09-.05-.14-.08-.02,0-.03-.02-.05-.03-.04-.02-.07-.04-.11-.05-.02,0-.03-.01-.05-.02-.05-.02-.1-.04-.15-.06-.05-.02-.1-.04-.15-.05-.02,0-.03,0-.05-.02-.03-.01-.07-.02-.1-.03-.02,0-.04-.01-.06-.02-.03,0-.06-.02-.09-.02-.02,0-.04,0-.06-.01-.03,0-.06-.01-.08-.02-.02,0-.04,0-.07-.01-.03,0-.05,0-.08,0-.02,0-.05,0-.07,0-.02,0-.05,0-.07,0-.03,0-.06,0-.08,0-.04,0-.07,0-.11,0,0,0,0,0-.01,0-.04,0-.07,0-.11,0-.01,0-.02,0-.03,0-.04,0-.08.01-.12.02,0,0-.02,0-.03,0-.03,0-.06.01-.09.02-.01,0-.03,0-.04.01-.02,0-.05.02-.07.02-.03.01-.06.02-.08.03-.01,0-.03.01-.04.02-.04.02-.08.04-.12.06,0,0,3.07-1.78,3.07-1.78.04-.02.08-.04.12-.06.01,0,.03-.01.04-.02.45-.19.98-.15,1.44,0,.46.15.9.41,1.28.71.01,0,.02.02.03.03.02.02.04.04.07.05,1.38,1.14,2.37,2.94,2.5,4.73.05.62-.02,1.33-.36,1.86,0,0,0,0,0,0,0,0,0,.01-.01.02-.02.03-.04.05-.06.08,0,.01-.02.02-.02.03-.02.02-.04.05-.06.07,0,0-.01.02-.02.03-.03.03-.05.06-.08.08,0,0,0,0-.01.01-.02.02-.05.04-.07.07,0,0-.02.02-.03.02-.02.02-.04.03-.07.05,0,0-.02.01-.03.02-.03.02-.06.04-.1.06l-3.07,1.78s.06-.04.1-.06c0,0,.02-.01.03-.02.02-.02.04-.03.07-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M200.28,301.38c1.78,1.03,3.21,3.51,3.21,5.55,0,2.04-1.45,2.86-3.23,1.84-1.78-1.03-3.21-3.51-3.21-5.55,0-2.04,1.45-2.86,3.23-1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M200.17,302.82c1.1.63,1.99,2.12,2.09,3.4,0,.08,0,.16,0,.23,0,1.34-.95,1.88-2.11,1.2-1.16-.67-2.1-2.3-2.1-3.64,0-.08,0-.15,0-.22.1-1.17,1.01-1.61,2.1-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M200.17,303.48c.8.46,1.45,1.54,1.52,2.47,0,.06,0,.11,0,.17,0,.97-.69,1.36-1.54.88s-1.53-1.67-1.53-2.64c0-.06,0-.11,0-.16.08-.85.73-1.17,1.53-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M198.64,304.19c.06-.71.52-1.05,1.13-.88-.47-.01-.81.32-.87.92,0,.05,0,.11,0,.16,0,.97.68,2.16,1.53,2.64.14.08.27.13.4.17-.2,0-.43-.07-.66-.21-.85-.49-1.53-1.67-1.53-2.64,0-.06,0-.11,0-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M199.59,305.42s-.09-.03-.12-.01c-.07.04-.07.16,0,.28.03.06.08.1.12.13.04.03.09.03.12.01.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M200.27,304.79c-.22-.12-.39-.02-.39.22,0,.25.17.55.39.67.22.12.39.02.39-.22,0-.25-.17-.55-.39-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M200.26,306.13c-.1-.05-.17-.01-.17.1,0,.11.08.24.17.3.1.06.17.01.17-.1,0-.11-.08-.24-.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M200.93,306.2s-.09-.03-.12-.01c-.07.04-.07.16,0,.28.03.06.08.1.12.13.04.03.09.03.12.01.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M199.6,303.88s-.09-.03-.12-.01c-.07.04-.07.16,0,.28.03.06.08.1.12.13.04.03.09.03.12.01.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M200.27,304.34c.1.05.17.01.17-.1,0-.11-.08-.24-.17-.3-.09-.06-.17-.01-.17.1,0,.11.08.24.17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M200.94,305.05s.09.03.12.01c.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13-.04-.03-.09-.03-.12-.01-.07.04-.07.16,0,.28.03.06.08.1.12.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M199.49,304.79c0-.11-.08-.24-.17-.3-.09-.06-.17-.01-.17.1,0,.11.08.24.17.3.09.06.17.01.17-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M201.21,305.59c-.09-.05-.17-.01-.17.1,0,.11.08.24.17.3.1.05.17.01.17-.1,0-.11-.08-.24-.17-.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "221.98 311.74 233.61 305.15 206.57 289.46 194.94 296.05 221.98 311.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M220.24,311.81s0,0,0,0c0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0,0,0-.02,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.02,0-.02,0,0,0-.02,0-.03,0,0,0,0,0,0,0,0,0-.01,0-.02,0h-.01s-.01,0-.02,0h-.01s-.01,0-.02,0c0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.02,0,0,0,0,0-.01,0,0,0,0,0-.02,0,0,0,0,0-.01,0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.02,0-.03,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.02,0-.02,0,0,0,0,0,0,0,0,0-.02,0-.03.01,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.02,0-.03.01,0,0,0,0,0,0,0,0-.02.01-.03.02,0,0,0,0,0,0,0,0-.02.01-.03.02l-6.33-3.68s.02-.01.03-.02c0,0,0,0,0,0s0,0,0,0c0,0,.02,0,.02-.01h0s.02,0,.03-.01c0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,.02,0,.03-.01t0,0s0,0,0,0c0,0,.02,0,.02,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,.02,0,.03,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,.01,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,.01,0h.02s0,0,0,0c0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,.02,0,.03,0h0s.02,0,.02,0c0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.02,0,0,0,0,0,.01,0,0,0,0,0,.02,0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,.02,0,.02.01h0l6.33,3.68s-.02,0-.02-.01c0,0,0,0,0,0,0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-173",
    points: "219.39 311.92 213.06 308.24 212.3 308.68 218.63 312.36 219.39 311.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M211.05,310.81s0,0,0-.01c0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0-.02,0-.03,0,0,0,0,0,0h0s0-.02,0-.03c0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0-.02,0-.02,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0-.01,0-.02,0-.03,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0-.02,0-.03,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0-.02,0-.02,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0-.02,0-.03h0s0-.02,0-.04c0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0-.02,0-.02,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0-.02,0-.02,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0-.02,0-.02,0,0,0,0,0,0,0-.01,0-.02.01-.03,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.02,0-.03,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0-.02.01-.03,0,0,0,0,0,0,0,0,0,0,0,0,0-.01,0-.02.01-.03,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0-.02.01-.04.02-.05,0,0,0,0,0,0,0,0,0,0,0,0,0-.02.01-.03.02-.05,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0-.02.01-.02,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0,0,0,0,0-.02.02-.03.03-.05,0,0,0,0,0,0,0-.01.02-.03.03-.04,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01.01-.02,0,0,0-.01.01-.02,0,0,0-.01.01-.02,0,0,0-.01.01-.02,0,0,0-.01.01-.02,0,0,0-.01.01-.02,0,0,0-.01.01-.02,0,0,0,0,0-.01,0,0,0,0,0,0,.01-.02.02-.03.03-.05,0,0,0,0,0-.01.01-.02.02-.03.04-.05h0s0,0,0,0c0,0,.01-.02.02-.03,0,0,0,0,0-.01,0,0,.01-.01.02-.02,0,0,0,0,0,0,0,0,0,0,.01-.01,0,0,0,0,0-.01,0,0,.01-.01.02-.02,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,.02-.02.02-.03h0s.02-.02.02-.03c0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01-.01.02-.02,0,0,0,0,0-.01,0,0,0,0,.01-.01,0,0,0,0,0,0,0,0,0,0,.01-.01,0,0,.01-.01.02-.02,0,0,0,0,.01-.01,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01-.01,0,0,.01-.01.02-.02,0,0,0,0,.01-.01,0,0,0,0,0,0,0,0,0,0,.01-.01,0,0,0,0,.01-.01,0,0,.01-.01.02-.02,0,0,0,0,.01-.01,0,0,0,0,0,0,0,0,.01,0,.02-.01,0,0,0,0,.01,0,0,0,.02-.01.02-.02,0,0,0,0,0,0h0s.02-.02.03-.02c0,0,0,0,0,0,0,0,.01,0,.02-.01,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,.01,0,.02-.01,0,0,0,0,.01,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,.01,0,.02-.01,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,.02-.01.03-.02h0s0,0,0,0c0,0,.02-.01.03-.02,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,.01,0l6.33,3.68s-.02,0-.03.02c0,0,0,0,0,0,0,0-.02.01-.03.02,0,0,0,0,0,0,0,0-.02.01-.03.02,0,0,0,0,0,0,0,0-.01,0-.02.01,0,0,0,0-.01,0,0,0-.01,0-.02.01,0,0,0,0-.01,0,0,0-.01,0-.02.01,0,0,0,0-.01,0,0,0-.01,0-.02.01,0,0,0,0-.01,0,0,0-.01.01-.02.02,0,0,0,0,0,0,0,0-.02.02-.03.02,0,0,0,0,0,0,0,0-.01.01-.02.02,0,0,0,0-.01,0,0,0-.01.01-.02.02,0,0,0,0-.01.01,0,0-.01,0-.02.02,0,0,0,0-.01.01,0,0-.01.01-.02.02,0,0,0,0-.01.01,0,0-.01.01-.02.02,0,0,0,0-.01.01,0,0-.01.01-.02.02,0,0,0,0-.01.01,0,0-.01.01-.02.02,0,0,0,0-.01.01,0,0-.01.01-.02.02,0,0,0,0-.01.01,0,0-.01.01-.02.02,0,0,0,0,0,0,0,0-.02.02-.02.03,0,0,0,0,0,0,0,0-.02.02-.03.03,0,0,0,0,0,.01,0,0-.01.01-.02.02,0,0,0,0,0,.01,0,0,0,.01-.01.02,0,0-.01.01-.02.02,0,0,0,0-.01.01,0,0-.01.02-.02.03,0,0,0,0,0,0-.01.02-.02.03-.04.05,0,0,0,0,0,.01-.01.02-.02.03-.03.05,0,0,0,0-.01.02,0,0,0,.01-.01.02,0,0,0,.01-.01.02,0,0,0,.01-.01.02,0,0,0,.01-.01.02,0,0,0,.01-.01.02,0,0,0,.01-.01.02,0,0,0,.01-.01.02,0,0,0,0,0,.01,0,.01-.02.03-.03.04,0,0,0,0,0,0,0,.02-.02.03-.03.05,0,0,0,.01,0,.02,0,0,0,.01,0,.02,0,0,0,.01,0,.02,0,0,0,.01,0,.02,0,0,0,.01-.01.02,0,0,0,0,0,.01,0,0,0,.02-.01.02,0,0,0,0,0,.01,0,0,0,0,0,0,0,.02-.02.03-.02.05,0,0,0,0,0,.01,0,.02-.02.03-.02.05,0,0,0,.02-.01.03,0,0,0,0,0,0,0,.01,0,.02-.01.04,0,0,0,0,0,0,0,0,0,.02-.01.03,0,0,0,0,0,.01,0,0,0,.02,0,.02,0,0,0,0,0,.01,0,0,0,.02,0,.03,0,0,0,0,0,0,0,.01,0,.02-.01.04,0,0,0,0,0,0,0,0,0,.02,0,.03,0,0,0,0,0,.01,0,0,0,.02,0,.02,0,0,0,0,0,.01,0,0,0,.02,0,.02,0,0,0,0,0,.01,0,0,0,.02,0,.02,0,0,0,0,0,.01,0,.01,0,.02,0,.04,0,0,0,0,0,0,0,.01,0,.02,0,.03,0,0,0,0,0,.01,0,0,0,.02,0,.02,0,0,0,0,0,.01,0,0,0,.02,0,.02,0,0,0,0,0,.01,0,0,0,.02,0,.03,0,0,0,0,0,0,0,.01,0,.02,0,.04,0,0,0,0,0,0,0,0,0,.02,0,.03,0,0,0,0,0,.01,0,0,0,.02,0,.02,0,0,0,0,0,.01,0,0,0,.02,0,.03,0,0,0,0,0,0,0,.01,0,.02,0,.03h0s0,.03,0,.03c0,0,0,0,0,.01,0,0,0,.02,0,.02h0s0,.03,0,.04c0,.01,0,.02,0,.04,0,0,0,0,0,0,0,0,0,.02,0,.03,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,0,0,.01,0,.02,0,.03,0,0,0,0,0,0,0,0,0,.02,0,.03,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,.01,0,.02,0,.03,0,0,0,0,0,0,0,0,0,.02,0,.03,0,0,0,0,0,0,0,0,0,.02,0,.02,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,.02,0,.02,0,0,0,0,0,0,0,.01,0,.02.01.03,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,.02.01.02,0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,.01.01.02,0,0,0,0,0,0,0,0,0,.01.01.02,0,0,0,0,0,0,0,0,0,0,.01.01,0,0,0,0,0,0,0,0,0,0,.01.01,0,0,0,0,0,0,0,0,.01.01.02.02,0,0,0,0,0,0,0,0,0,0,.01.01,0,0,0,0,0,0,0,0,0,0,.01.01,0,0,0,0,0,0,0,0,.01,0,.02.01,0,0,0,0,0,0,0,0,0,0,.01.01,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,.01,0,.02.01h0l-6.33-3.68s-.01,0-.02-.01c0,0,0,0,0,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0,0,0-.02-.01,0,0,0,0,0,0,0,0-.01,0-.02-.01,0,0,0,0,0,0,0,0,0,0-.01-.01,0,0,0,0,0,0,0,0,0,0-.01-.01,0,0,0,0,0,0,0,0-.01-.01-.02-.02,0,0,0,0,0,0,0,0,0,0-.01-.01,0,0,0,0,0,0,0,0,0,0-.01-.01,0,0,0,0,0,0,0,0,0-.01-.01-.02,0,0,0,0,0,0,0,0,0-.01-.01-.02,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.02-.01-.02,0,0,0,0,0,0,0,0,0-.01,0-.02h0s0-.02-.01-.03c0,0,0,0,0,0,0,0,0-.02-.01-.02,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0-.02,0-.02,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.02,0-.03,0,0,0,0,0,0,0-.01,0-.02,0-.03h0s0-.01,0-.02c0,0,0,0,0-.01,0,0,0-.02,0-.03,0,0,0,0,0,0h0s0-.02,0-.03c0,0,0,0,0,0,0,0,0-.01,0-.02h0s0-.01,0-.01c0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0-.01,0-.02,0,0,0,0,0-.01h0s0-.02,0-.03c0,0,0,0,0,0,0-.01,0-.02,0-.03h0s0-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M218.63,312.36c-.69.4-1.25,1.37-1.25,2.17,0,.79.57,1.12,1.26.72l.77-.44c.69-.4,1.25-1.37,1.25-2.17,0-.79-.57-1.12-1.26-.72l-.77.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "194.93 300.72 194.94 296.05 221.98 311.74 221.98 316.4 220.42 315.5 220.42 312.72 196.44 298.85 196.44 301.6 194.93 300.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "233.9 290.18 221.33 297.49 194.57 281.97 207.11 274.68 233.9 290.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "221.33 297.49 221.33 311.48 233.9 304.16 233.9 290.18 221.33 297.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "194.57 281.97 221.33 297.49 221.33 311.48 194.57 295.96 194.57 281.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M228.57,323.77s.02-.02.03-.02c.02-.02.05-.04.07-.07,0,0,0,0,.01-.01.03-.03.05-.06.08-.08,0,0,.01-.02.02-.02.02-.02.04-.05.06-.07,0-.01.02-.02.02-.03.02-.03.04-.05.06-.08,0,0,0-.01.02-.02.02-.04.05-.07.07-.11.02-.04.04-.08.06-.12,0,0,0-.01,0-.02.02-.03.03-.07.04-.1,0,0,0-.02.01-.03,0-.02.01-.04.02-.06.01-.03.02-.07.03-.1,0-.02.01-.04.02-.07,0-.03.02-.06.02-.09,0-.03.01-.05.02-.08,0-.03.01-.05.02-.08,0-.03.01-.06.01-.09,0-.02,0-.05.01-.07,0-.03,0-.06.01-.1,0-.02,0-.04,0-.07,0-.04,0-.08,0-.12,0-.02,0-.03,0-.05,0-.06,0-.12,0-.18,0-.06,0-.11,0-.17,0-.02,0-.04,0-.06,0-.04,0-.08,0-.12,0-.02,0-.04,0-.06,0-.04,0-.09-.01-.13,0-.02,0-.03,0-.05,0-.06-.02-.12-.03-.18,0,0,0-.02,0-.02,0-.05-.02-.11-.03-.16,0-.02,0-.04-.01-.06,0-.04-.02-.08-.03-.12,0-.02-.01-.05-.02-.07,0-.04-.02-.08-.03-.12,0-.02-.01-.05-.02-.07-.01-.04-.02-.09-.04-.13,0-.02-.01-.04-.02-.06-.02-.06-.04-.12-.06-.19,0,0,0,0,0-.01-.02-.06-.04-.11-.06-.17,0-.02-.01-.04-.02-.06-.02-.04-.03-.09-.05-.13,0-.02-.02-.04-.02-.06-.02-.04-.04-.09-.06-.13,0-.02-.01-.03-.02-.05-.03-.06-.05-.12-.08-.18,0-.01-.01-.03-.02-.04-.02-.05-.04-.09-.07-.14-.02-.03-.03-.06-.05-.1-.02-.03-.03-.06-.05-.09-.04-.08-.09-.17-.14-.25-.02-.03-.03-.06-.05-.08-.02-.03-.04-.07-.06-.1-.02-.03-.04-.06-.06-.09-.02-.03-.04-.07-.06-.1-.01-.02-.03-.04-.04-.06-.06-.09-.12-.18-.18-.26,0,0,0,0,0,0-.04-.06-.09-.12-.13-.18-.04-.05-.07-.09-.11-.13,0,0-.01-.02-.02-.03-.04-.05-.09-.1-.13-.15-.01-.01-.03-.03-.04-.04-.03-.04-.06-.07-.1-.1-.02-.02-.04-.04-.06-.06-.03-.03-.06-.06-.08-.09-.02-.02-.04-.04-.06-.06-.03-.03-.05-.05-.08-.08-.02-.02-.04-.04-.07-.06-.03-.02-.05-.05-.08-.07-.02-.02-.04-.04-.07-.06-.03-.02-.06-.05-.08-.07-.02-.02-.04-.04-.06-.05-.03-.02-.06-.05-.09-.07-.02-.02-.04-.03-.06-.05-.03-.02-.07-.05-.1-.07-.02-.01-.03-.02-.05-.04-.05-.03-.1-.07-.15-.1,0,0,0,0,0,0-.05-.03-.1-.06-.16-.09-.05-.03-.09-.05-.14-.08-.02,0-.04-.02-.05-.03-.04-.02-.07-.04-.1-.05-.02,0-.03-.01-.05-.02-.05-.02-.1-.04-.15-.06-.05-.02-.1-.04-.15-.05-.02,0-.03-.01-.05-.01-.03-.01-.06-.02-.1-.03-.02,0-.04-.01-.06-.02-.03,0-.06-.02-.09-.02-.02,0-.04,0-.06-.01-.03,0-.06-.01-.08-.02-.02,0-.04,0-.07-.01-.03,0-.05,0-.08,0-.02,0-.05,0-.07,0-.02,0-.04,0-.07,0-.03,0-.05,0-.08,0-.04,0-.07,0-.11,0,0,0,0,0-.01,0-.04,0-.07,0-.11,0-.01,0-.02,0-.03,0-.04,0-.08.01-.12.02-.01,0-.02,0-.03,0-.03,0-.06.01-.09.02-.01,0-.03,0-.04.01-.02,0-.05.01-.07.02-.03.01-.06.02-.09.03-.01,0-.03.01-.04.02-.04.02-.08.04-.12.06,0,0,2.38-1.39,2.38-1.39.04-.02.08-.04.12-.06.01,0,.03-.01.04-.02.45-.19.98-.15,1.44,0,.46.15.9.41,1.28.71.01,0,.02.02.03.03.02.02.04.04.07.05,1.38,1.14,2.37,2.94,2.5,4.73.05.62-.02,1.33-.36,1.86,0,0,0,0,0,0,0,0,0,.01-.01.02-.02.03-.04.05-.06.08,0,.01-.02.02-.02.03-.02.02-.04.05-.06.07,0,0-.01.02-.02.02-.03.03-.05.06-.08.08,0,0,0,0-.01.01-.02.02-.05.04-.07.07,0,0-.02.02-.03.02-.02.02-.04.03-.07.05,0,0-.02.01-.03.02-.03.02-.06.04-.1.06l-2.38,1.39s.06-.04.1-.06c0,0,.02-.01.03-.02.02-.02.04-.03.07-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M226.11,316.29c1.78,1.03,3.21,3.51,3.21,5.55,0,2.04-1.45,2.86-3.23,1.84-1.78-1.03-3.21-3.51-3.21-5.55,0-2.04,1.45-2.86,3.23-1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M226,317.72c1.1.63,1.99,2.12,2.09,3.4,0,.08,0,.16,0,.23,0,1.34-.95,1.88-2.11,1.2-1.16-.67-2.1-2.3-2.1-3.64,0-.08,0-.15,0-.22.1-1.17,1.01-1.61,2.1-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M226,318.38c.8.46,1.45,1.54,1.52,2.47,0,.06,0,.11,0,.17,0,.97-.69,1.36-1.54.88-.85-.49-1.53-1.67-1.53-2.64,0-.06,0-.11,0-.16.08-.85.73-1.17,1.53-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M224.47,319.1c.06-.71.52-1.05,1.13-.88-.47-.01-.81.33-.87.92,0,.05,0,.11,0,.16,0,.97.68,2.16,1.53,2.64.14.08.27.13.4.17-.2,0-.43-.07-.67-.21-.85-.49-1.53-1.67-1.53-2.64,0-.06,0-.11,0-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M225.42,320.33s-.09-.03-.12-.01c-.07.04-.07.16,0,.28.03.06.08.1.12.13.04.03.09.03.12.01.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M226.09,319.69c-.22-.12-.39-.02-.39.22,0,.25.17.55.39.68.22.12.39.02.39-.22,0-.25-.17-.55-.39-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M226.09,321.04c-.1-.05-.17-.01-.17.1,0,.11.08.24.17.3.1.06.17.01.17-.1,0-.11-.08-.24-.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M226.76,321.11s-.09-.03-.12-.01c-.07.04-.07.16,0,.28.03.06.08.1.12.13.04.03.09.03.12.01.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M225.42,318.79s-.09-.03-.12-.01c-.07.04-.07.16,0,.28.03.06.08.1.12.13.04.03.09.03.12.01.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M226.09,319.25c.1.05.17.01.17-.1,0-.11-.08-.24-.17-.3-.1-.06-.17-.01-.17.1,0,.11.08.24.17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M226.76,319.96s.09.03.12.01c.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13-.04-.03-.09-.03-.12-.01-.07.04-.07.16,0,.28.03.06.08.1.12.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M225.31,319.69c0-.11-.08-.24-.17-.3-.1-.05-.17-.01-.17.1,0,.11.08.24.17.3.09.05.17.01.17-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M227.04,320.49c-.09-.05-.17-.01-.17.1,0,.11.08.24.17.3.09.05.17.01.17-.1,0-.11-.08-.24-.17-.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "231.39 321.85 243.07 315.25 243.09 308.2 231.41 314.8 231.39 321.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "231.41 314.8 243.09 308.2 241.5 301.34 229.83 307.94 231.41 314.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "229.83 307.94 241.5 301.34 233.67 296.82 222 303.42 229.83 307.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M229.83,307.94l1.59,6.86,11.67-6.6-1.59-6.86-11.67,6.6ZM230.35,308.17l10.84-6.13,1.37,5.92-10.84,6.13-1.37-5.92Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-114"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-181",
    points: "241 310.7 241 315.23 233.48 319.58 233.48 315.05 241 310.7"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "231.96 320.59 231.96 322.18 243.57 315.5 243.57 313.92 231.96 320.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "231.96 320.59 231.96 322.18 231.39 321.86 231.39 320.27 231.96 320.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "243.57 313.92 231.96 320.59 231.39 320.27 243 313.59 243.57 313.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "231.41 318.65 233.28 317.57 233.28 318.7 231.41 319.76 231.41 318.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "241.22 312.98 243.09 311.91 243.09 313.03 241.22 314.1 241.22 312.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M222,303.42l7.83,4.52,1.59,6.86-.02,7.06-1.67-.97c-.43-2-1.83-4.1-3.49-5.06-1.66-.96-3.06-.49-3.5,1.01l-.75-.43v-4.66l.02-8.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M225.1,305.79c-.08-.05-.15,0-.15.09v4.09c-.01.09.05.21.14.26l5.19,3c.1.06.18-.02.14-.15l-.92-4.63c-.02-.08-.08-.16-.14-.2l-4.26-2.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-284",
    points: "232.25 320.99 232.25 321.72 233.66 320.91 233.66 320.18 232.25 320.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-284",
    points: "241.94 315.44 241.94 316.17 243.35 315.36 243.35 314.63 241.94 315.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "205.49 304.08 205.49 306.72 210.41 309.51 210.41 306.93 205.49 304.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "210.41 309.51 211.33 309 211.33 307.46 210.41 306.93 210.41 309.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "230.35 308.17 242.56 307.97 241.19 302.04 230.35 308.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "207.07 300.22 205.69 299.43 205.69 290.27 207.07 291.06 207.07 300.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "201 295.16 202.66 296.12 202.66 288.52 204.03 289.31 204.03 296.92 204.03 298.46 202.66 297.67 202.66 297.67 199.62 295.92 199.62 294.37 199.62 286.76 201 287.55 201 295.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "197.96 285.8 197.96 294.95 196.58 294.16 196.58 285.01 197.96 285.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-251",
    points: "279.93 176.87 293.7 168.78 293.7 171.15 279.93 179.17 279.93 176.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "207.75 135.16 279.93 176.88 279.93 179.17 207.75 137.53 207.75 135.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "221.65 127.13 207.81 135.19 279.93 176.88 293.71 168.79 221.65 127.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "207.81 135.19 207.81 137.56 279.93 179.17 279.93 176.88 207.81 135.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-253",
    points: "360.69 256.14 194.21 352.38 226.13 370.82 392.61 274.58 360.69 256.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "194.21 352.38 226.13 370.82 226.12 376.06 194.21 357.63 194.21 352.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-248",
    points: "172.04 289.41 172.04 306.69 185.52 298.91 185.52 281.62 172.04 289.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "172.04 289.41 172.04 306.69 130.8 282.88 130.8 265.59 172.04 289.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "167.76 290.33 167.76 295.71 154.92 288.3 154.92 282.92 167.76 290.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "167.76 297.92 167.76 301.6 158.97 296.53 158.97 292.85 167.76 297.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-247",
    points: "185.52 281.62 172.04 289.41 130.8 265.59 144.28 257.81 185.52 281.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-244",
    points: "150.26 302.09 150.26 319.38 163.74 311.59 163.74 294.31 150.26 302.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-245",
    points: "150.26 302.09 150.26 319.38 109.02 295.56 109.02 278.28 150.26 302.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "145.98 303.02 145.98 308.4 133.14 300.99 133.14 295.61 145.98 303.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "145.98 310.61 145.98 314.29 137.19 309.22 137.19 305.54 145.98 310.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-243",
    points: "163.74 294.31 150.26 302.09 109.02 278.28 122.51 270.5 163.74 294.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "319.14 265.65 334.82 256.4 297.49 234.71 281.8 243.97 319.14 265.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "284.32 239.85 290.02 240.64 287.27 236.86 283.88 237.6 284.32 239.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M290.37,246.42s.02-.02.03-.02c.02-.02.05-.04.07-.06,0,0,0,0,.01-.01.03-.03.05-.05.08-.08,0,0,.01-.02.02-.02.02-.02.04-.04.06-.07,0,0,.02-.02.02-.03.02-.03.04-.05.05-.08,0,0,0-.01.01-.02.02-.04.05-.07.07-.11.02-.04.04-.08.06-.12,0,0,0-.01,0-.02.02-.03.03-.07.04-.1,0,0,0-.02.01-.03,0-.02.02-.04.02-.06.01-.03.02-.07.03-.1,0-.02.01-.04.02-.07,0-.03.02-.06.02-.09,0-.02.01-.05.02-.08,0-.03.01-.05.02-.08,0-.03,0-.06.01-.09,0-.02,0-.05.01-.07,0-.03,0-.06.01-.1,0-.02,0-.04,0-.07,0-.04,0-.08,0-.12,0-.02,0-.03,0-.05,0-.06,0-.11,0-.17s0-.11,0-.17c0-.02,0-.04,0-.06,0-.04,0-.08,0-.12,0-.02,0-.04,0-.06,0-.04,0-.08-.01-.13,0-.02,0-.03,0-.05,0-.06-.02-.12-.02-.18,0,0,0-.02,0-.02,0-.05-.02-.11-.03-.16,0-.02,0-.04-.01-.06,0-.04-.02-.08-.03-.12,0-.02-.01-.05-.02-.07,0-.04-.02-.08-.03-.12,0-.02-.01-.05-.02-.07-.01-.04-.02-.08-.04-.13,0-.02-.01-.04-.02-.06-.02-.06-.04-.12-.06-.18,0,0,0,0,0-.01-.02-.06-.04-.11-.06-.17,0-.02-.01-.04-.02-.05-.02-.04-.03-.08-.05-.13,0-.02-.02-.04-.02-.06-.02-.04-.04-.09-.06-.13,0-.02-.01-.03-.02-.05-.03-.06-.05-.12-.08-.18,0-.01-.01-.03-.02-.04-.02-.05-.04-.09-.07-.14-.02-.03-.03-.06-.05-.09-.02-.03-.03-.06-.05-.09-.04-.08-.09-.16-.14-.24-.02-.03-.03-.05-.05-.08-.02-.03-.04-.07-.06-.1-.02-.03-.04-.06-.05-.09-.02-.03-.04-.06-.06-.1-.01-.02-.03-.04-.04-.06-.06-.09-.12-.17-.18-.26,0,0,0,0,0,0-.04-.06-.09-.12-.13-.17-.03-.04-.07-.09-.11-.13,0,0-.01-.02-.02-.03-.04-.05-.09-.1-.13-.15-.01-.01-.03-.03-.04-.04-.03-.03-.06-.07-.09-.1-.02-.02-.04-.04-.06-.06-.03-.03-.05-.06-.08-.09-.02-.02-.04-.04-.06-.06-.03-.03-.05-.05-.08-.08-.02-.02-.04-.04-.06-.06-.03-.02-.05-.05-.08-.07-.02-.02-.04-.04-.07-.06-.03-.02-.06-.05-.08-.07-.02-.02-.04-.04-.06-.05-.03-.02-.06-.05-.09-.07-.02-.02-.04-.03-.06-.05-.03-.02-.07-.05-.1-.07-.02-.01-.03-.02-.05-.04-.05-.03-.1-.07-.15-.1,0,0,0,0,0,0-.05-.03-.1-.06-.15-.09-.05-.03-.09-.05-.14-.08-.02,0-.03-.02-.05-.03-.03-.02-.07-.03-.1-.05-.02,0-.03-.01-.05-.02-.05-.02-.1-.04-.15-.06-.05-.02-.1-.04-.14-.05-.02,0-.03-.01-.05-.02-.03-.01-.06-.02-.1-.03-.02,0-.04-.01-.06-.02-.03,0-.06-.02-.09-.02-.02,0-.04,0-.06-.01-.03,0-.05-.01-.08-.02-.02,0-.04,0-.06-.01-.03,0-.05,0-.07,0-.02,0-.05,0-.07,0-.02,0-.04,0-.07,0-.03,0-.05,0-.08,0-.04,0-.07,0-.11,0,0,0,0,0-.01,0-.04,0-.07,0-.11,0-.01,0-.02,0-.03,0-.04,0-.08.01-.11.02-.01,0-.02,0-.03,0-.03,0-.06.01-.09.02-.01,0-.03,0-.04.01-.02,0-.05.02-.07.02-.03.01-.06.02-.08.03-.01,0-.03.01-.04.02-.04.02-.08.04-.12.06,0,0,3.02-1.76,3.02-1.76.04-.02.08-.04.12-.06.01,0,.03-.01.04-.02.44-.19.97-.15,1.42,0,.45.15.89.4,1.26.7.01,0,.02.02.03.03.02.02.04.03.06.05,1.36,1.12,2.34,2.89,2.47,4.67.04.61-.02,1.31-.36,1.83,0,0,0,0,0,0,0,0,0,.01-.01.02-.02.03-.04.05-.05.08,0,0-.02.02-.02.03-.02.02-.04.05-.05.07,0,0-.01.02-.02.03-.03.03-.05.06-.08.08,0,0,0,0-.01.01-.02.02-.05.04-.07.07,0,0-.02.01-.03.02-.02.02-.04.03-.07.05,0,0-.02.01-.03.02-.03.02-.06.04-.09.06l-3.02,1.76s.06-.04.09-.06c0,0,.02-.01.03-.02.02-.02.04-.03.06-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M287.95,239.05c1.75,1.01,3.17,3.46,3.16,5.47,0,2.01-1.43,2.82-3.18,1.81-1.75-1.01-3.16-3.46-3.16-5.47,0-2.01,1.43-2.82,3.18-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M287.84,240.46c1.08.62,1.97,2.08,2.06,3.35,0,.08,0,.15,0,.23,0,1.32-.94,1.85-2.08,1.19-1.15-.66-2.07-2.27-2.07-3.58,0-.08,0-.15,0-.22.1-1.15.99-1.59,2.07-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M287.84,241.11c.79.45,1.43,1.52,1.5,2.44,0,.06,0,.11,0,.17,0,.96-.68,1.34-1.51.86-.83-.48-1.51-1.65-1.5-2.61,0-.06,0-.11,0-.16.07-.84.72-1.16,1.51-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M286.33,241.81c.06-.7.52-1.03,1.12-.87-.47-.01-.8.32-.85.91,0,.05,0,.1,0,.16,0,.96.67,2.12,1.5,2.61.14.08.27.13.39.17-.2,0-.42-.07-.66-.21-.83-.48-1.51-1.65-1.5-2.61,0-.05,0-.11,0-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M287.27,243.03s-.09-.03-.12-.01c-.07.04-.07.16,0,.28.03.06.08.1.12.13.04.02.09.03.12.01.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M287.93,242.4c-.21-.12-.39-.02-.39.22,0,.24.17.54.38.67.21.12.39.02.39-.22,0-.24-.17-.54-.38-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M287.93,243.73c-.09-.05-.17-.01-.17.1,0,.11.08.24.17.29.09.05.17.01.17-.1,0-.11-.08-.24-.17-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M288.59,243.79s-.09-.03-.12-.01c-.07.04-.07.16,0,.28.03.06.08.1.12.13.04.03.09.03.12.01.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M287.27,241.51s-.09-.03-.12-.01c-.07.04-.07.16,0,.28.03.06.08.1.12.13.04.03.09.03.12.01.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M287.93,241.96c.09.05.17.01.17-.1,0-.11-.07-.24-.17-.29-.09-.05-.17-.01-.17.1,0,.11.08.24.17.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M288.59,242.66s.09.03.12.01c.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13-.04-.03-.09-.03-.12-.01-.07.04-.07.16,0,.28.03.06.08.1.12.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M287.16,242.4c0-.11-.08-.24-.17-.29-.09-.05-.17-.01-.17.1,0,.11.08.24.17.29.09.05.17.01.17-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M288.87,243.19c-.09-.05-.17-.01-.17.1,0,.11.08.24.17.29.09.05.17.01.17-.1,0-.11-.08-.24-.17-.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-242",
    points: "291.11 240.64 292.26 245.04 293.9 246 293.9 242.25 291.11 240.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "293.9 246 296.79 243.92 293.9 242.25 293.9 246"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M310,257.79s.02-.01.03-.02c.02-.02.05-.04.07-.06,0,0,0,0,.01-.01.03-.03.05-.05.08-.08,0,0,.01-.02.02-.02.02-.02.04-.04.05-.07,0,0,.02-.02.02-.03.02-.03.04-.05.05-.08,0,0,0-.01.01-.02.02-.04.05-.07.07-.11.02-.04.04-.08.06-.12,0,0,0-.01,0-.02.02-.03.03-.07.04-.1,0,0,0-.02.01-.03,0-.02.01-.04.02-.06.01-.03.02-.07.03-.1,0-.02.01-.04.02-.07,0-.03.02-.06.02-.09,0-.03.01-.05.02-.08,0-.03.01-.05.02-.08,0-.03.01-.06.01-.09,0-.02,0-.05.01-.07,0-.03,0-.06.01-.1,0-.02,0-.04,0-.07,0-.04,0-.08,0-.12,0-.02,0-.03,0-.05,0-.06,0-.11,0-.17,0-.06,0-.11,0-.17,0-.02,0-.04,0-.06,0-.04,0-.08,0-.12,0-.02,0-.04,0-.06,0-.04,0-.08-.01-.13,0-.02,0-.03,0-.05,0-.06-.02-.12-.02-.18,0,0,0-.02,0-.02,0-.05-.02-.1-.03-.16,0-.02,0-.04-.01-.06,0-.04-.02-.08-.03-.12,0-.02-.01-.05-.02-.07,0-.04-.02-.08-.03-.12,0-.02-.01-.05-.02-.07-.01-.04-.02-.08-.04-.13,0-.02-.01-.04-.02-.06-.02-.06-.04-.12-.06-.18,0,0,0,0,0-.01-.02-.06-.04-.11-.06-.17,0-.02-.01-.04-.02-.05-.02-.04-.03-.08-.05-.13,0-.02-.02-.04-.02-.06-.02-.04-.04-.09-.06-.13,0-.02-.01-.03-.02-.05-.03-.06-.05-.12-.08-.18,0-.01-.01-.03-.02-.04-.02-.05-.04-.09-.07-.14-.02-.03-.03-.06-.05-.1-.02-.03-.03-.06-.05-.09-.04-.08-.09-.16-.14-.24-.02-.03-.03-.05-.05-.08-.02-.03-.04-.07-.06-.1-.02-.03-.04-.06-.06-.09-.02-.03-.04-.06-.06-.1-.01-.02-.03-.04-.04-.06-.06-.09-.12-.17-.18-.26,0,0,0,0,0,0-.04-.06-.09-.12-.13-.17-.04-.04-.07-.09-.11-.13,0,0-.01-.02-.02-.03-.04-.05-.09-.1-.13-.15-.01-.01-.03-.03-.04-.04-.03-.04-.06-.07-.09-.1-.02-.02-.04-.04-.05-.06-.03-.03-.05-.06-.08-.09-.02-.02-.04-.04-.06-.06-.03-.03-.05-.05-.08-.08-.02-.02-.04-.04-.06-.06-.03-.02-.05-.05-.08-.07-.02-.02-.04-.04-.06-.06-.03-.02-.06-.05-.08-.07-.02-.02-.04-.04-.06-.05-.03-.02-.06-.05-.09-.07-.02-.02-.04-.03-.06-.05-.03-.02-.07-.05-.1-.07-.02-.01-.03-.02-.05-.04-.05-.03-.1-.07-.15-.1,0,0,0,0,0,0-.05-.03-.1-.06-.15-.09-.05-.03-.09-.05-.14-.08-.02,0-.03-.02-.05-.03-.03-.02-.07-.03-.1-.05-.02,0-.03-.01-.05-.02-.05-.02-.1-.04-.15-.06-.05-.02-.1-.04-.14-.05-.02,0-.03,0-.05-.01-.03-.01-.06-.02-.1-.03-.02,0-.04-.01-.06-.02-.03,0-.06-.02-.09-.02-.02,0-.04,0-.06-.01-.03,0-.05-.01-.08-.02-.02,0-.04,0-.06-.01-.02,0-.05,0-.07,0-.02,0-.05,0-.07,0-.02,0-.04,0-.07,0-.03,0-.05,0-.08,0-.04,0-.07,0-.11,0,0,0,0,0-.01,0-.04,0-.07,0-.11,0-.01,0-.02,0-.03,0-.04,0-.08.01-.11.02,0,0-.02,0-.03,0-.03,0-.06.01-.09.02-.01,0-.03,0-.04.01-.02,0-.05.01-.07.02-.03.01-.06.02-.08.03-.01,0-.03.01-.04.02-.04.02-.08.04-.12.06,0,0,3.02-1.76,3.02-1.76.04-.02.08-.04.12-.06.01,0,.03-.01.04-.02.44-.19.97-.15,1.42,0,.45.15.89.4,1.26.7.01,0,.02.02.03.03.02.02.04.03.06.05,1.36,1.12,2.34,2.89,2.47,4.66.04.61-.02,1.31-.36,1.83,0,0,0,0,0,0,0,0,0,.01-.01.02-.02.03-.04.05-.05.08,0,.01-.02.02-.02.03-.02.02-.04.05-.05.07,0,0-.01.02-.02.02-.03.03-.05.06-.08.08,0,0,0,0-.01.01-.02.02-.05.04-.07.06,0,0-.02.02-.03.02-.02.02-.04.03-.07.05,0,0-.02.01-.03.02-.03.02-.06.04-.09.06l-3.02,1.76s.06-.04.09-.06c0,0,.02-.01.03-.02.02-.02.04-.03.07-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M307.58,250.41c1.75,1.01,3.16,3.46,3.16,5.47,0,2.01-1.43,2.82-3.18,1.81-1.75-1.01-3.16-3.46-3.16-5.47,0-2.01,1.43-2.82,3.18-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M307.47,251.82c1.08.62,1.97,2.08,2.06,3.35,0,.08,0,.15,0,.23,0,1.32-.94,1.85-2.08,1.19-1.15-.66-2.07-2.27-2.07-3.58,0-.08,0-.15,0-.22.1-1.15.99-1.59,2.07-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M307.47,252.47c.79.45,1.43,1.52,1.5,2.44,0,.06,0,.11,0,.17,0,.96-.68,1.34-1.51.86-.83-.48-1.51-1.65-1.5-2.61,0-.05,0-.11,0-.16.07-.84.72-1.16,1.51-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M305.96,253.18c.06-.7.52-1.03,1.12-.87-.47-.01-.8.32-.85.91,0,.05,0,.1,0,.16,0,.96.67,2.12,1.5,2.61.14.08.27.13.39.17-.2,0-.42-.07-.66-.21-.83-.48-1.51-1.65-1.5-2.61,0-.06,0-.11,0-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M306.89,254.39s-.09-.03-.12-.01c-.07.04-.07.16,0,.28.03.06.08.1.12.13.04.02.09.03.12.01.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M307.56,253.77c-.21-.12-.39-.02-.39.22,0,.24.17.54.38.67.21.12.39.02.39-.22,0-.24-.17-.54-.38-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M307.55,255.09c-.09-.05-.17-.01-.17.1,0,.11.08.24.17.29.09.05.17.01.17-.1,0-.11-.08-.24-.17-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M308.22,255.16s-.09-.03-.12-.01c-.07.04-.07.16,0,.28.03.06.08.1.12.13.04.03.09.03.12.01.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M306.9,252.87s-.09-.03-.12-.01c-.07.04-.07.16,0,.28.03.06.08.1.12.13.04.03.09.03.12.01.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M307.56,253.33c.09.05.17.01.17-.1,0-.11-.08-.24-.17-.29-.09-.05-.17-.01-.17.1,0,.11.08.24.17.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M308.22,254.02s.09.03.12.01c.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13-.04-.03-.09-.03-.12-.01-.07.04-.07.16,0,.28.03.06.08.1.12.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M306.79,253.77c0-.11-.08-.24-.17-.29-.09-.05-.17-.01-.17.1,0,.11.08.24.17.29.09.05.17.01.17-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M308.49,254.55c-.09-.05-.17-.01-.17.1,0,.11.08.24.17.29.09.05.17.01.17-.1,0-.11-.08-.24-.17-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M316.85,261.71s.02-.01.03-.02c.02-.02.05-.04.07-.07,0,0,0,0,.01-.01.03-.03.05-.05.08-.08,0,0,.01-.02.02-.02.02-.02.04-.04.05-.07,0,0,.02-.02.02-.03.02-.03.04-.05.05-.08,0,0,0-.01.01-.02.02-.04.05-.07.07-.11.02-.04.04-.08.06-.12,0,0,0-.01,0-.02.01-.03.03-.07.04-.1,0-.01,0-.02.01-.03,0-.02.01-.04.02-.06.01-.03.02-.07.03-.1,0-.02.01-.04.02-.07,0-.03.02-.06.02-.09,0-.03.01-.05.02-.08,0-.02.01-.05.02-.08,0-.03.01-.06.02-.09,0-.02,0-.05.01-.07,0-.03,0-.06.01-.1,0-.02,0-.04,0-.07,0-.04,0-.08,0-.12,0-.02,0-.03,0-.05,0-.06,0-.12,0-.17,0-.06,0-.11,0-.17,0-.02,0-.04,0-.06,0-.04,0-.08,0-.12,0-.02,0-.04,0-.06,0-.04,0-.09-.01-.13,0-.02,0-.03,0-.05,0-.06-.02-.12-.02-.18,0,0,0-.02,0-.02,0-.05-.02-.1-.03-.16,0-.02,0-.04-.01-.06,0-.04-.02-.08-.03-.12,0-.02-.01-.05-.02-.07,0-.04-.02-.08-.03-.12,0-.02-.01-.05-.02-.07-.01-.04-.02-.08-.04-.13,0-.02-.01-.04-.02-.06-.02-.06-.04-.12-.06-.18,0,0,0,0,0-.01-.02-.06-.04-.11-.06-.17,0-.02-.01-.04-.02-.05-.02-.04-.03-.08-.05-.13,0-.02-.02-.04-.02-.06-.02-.04-.04-.09-.06-.13,0-.02-.01-.03-.02-.05-.03-.06-.05-.12-.08-.18,0-.01-.01-.03-.02-.04-.02-.05-.04-.09-.07-.14-.02-.03-.03-.06-.05-.09-.02-.03-.03-.06-.05-.09-.04-.08-.09-.16-.14-.24-.02-.03-.03-.05-.05-.08-.02-.03-.04-.07-.06-.1-.02-.03-.04-.06-.06-.09-.02-.03-.04-.06-.06-.1-.01-.02-.03-.04-.04-.06-.06-.09-.12-.17-.18-.26,0,0,0,0,0,0-.04-.06-.09-.12-.13-.17-.03-.04-.07-.09-.11-.13,0,0-.01-.02-.02-.03-.04-.05-.09-.1-.13-.15-.01-.01-.03-.03-.04-.04-.03-.03-.06-.07-.09-.1-.02-.02-.04-.04-.06-.06-.03-.03-.06-.06-.08-.08-.02-.02-.04-.04-.06-.06-.03-.03-.05-.05-.08-.08-.02-.02-.04-.04-.06-.06-.03-.02-.05-.05-.08-.07-.02-.02-.04-.04-.07-.06-.03-.02-.06-.05-.08-.07-.02-.02-.04-.04-.06-.05-.03-.02-.06-.05-.09-.07-.02-.02-.04-.03-.06-.05-.03-.02-.07-.05-.1-.07-.02-.01-.03-.02-.05-.04-.05-.03-.1-.07-.15-.1,0,0,0,0,0,0-.05-.03-.1-.06-.15-.09-.05-.03-.09-.05-.14-.08-.02,0-.03-.02-.05-.03-.03-.02-.07-.03-.1-.05-.02,0-.03-.01-.05-.02-.05-.02-.1-.04-.15-.06-.05-.02-.1-.04-.14-.05-.02,0-.03-.01-.05-.01-.03-.01-.06-.02-.1-.03-.02,0-.04-.01-.06-.02-.03,0-.06-.02-.09-.02-.02,0-.04,0-.06-.01-.03,0-.05-.01-.08-.02-.02,0-.04,0-.06-.01-.03,0-.05,0-.08,0-.02,0-.05,0-.07,0-.02,0-.04,0-.07,0-.03,0-.05,0-.08,0-.04,0-.07,0-.11,0,0,0,0,0-.01,0-.04,0-.07,0-.11,0-.01,0-.02,0-.03,0-.04,0-.08.01-.11.02,0,0-.02,0-.03,0-.03,0-.06.01-.09.02-.01,0-.03,0-.04.01-.02,0-.05.01-.07.02-.03.01-.06.02-.08.03-.01,0-.03.01-.04.02-.04.02-.08.04-.12.06,0,0,3.02-1.76,3.02-1.76.04-.02.08-.04.12-.06.01,0,.03-.01.04-.02.44-.19.97-.15,1.42,0,.45.15.89.4,1.26.7.01,0,.02.02.03.03.02.02.04.03.06.05,1.36,1.13,2.34,2.89,2.47,4.66.04.61-.02,1.31-.36,1.83,0,0,0,0,0,0,0,0,0,.01-.01.02-.02.03-.04.05-.05.08,0,.01-.01.02-.02.03-.02.02-.04.04-.05.07,0,0-.01.02-.02.02-.03.03-.05.06-.08.08,0,0,0,0-.01.01-.02.02-.05.04-.07.06,0,0-.02.02-.03.02-.02.02-.04.03-.06.05,0,0-.02.01-.03.02-.03.02-.06.04-.09.06l-3.02,1.76s.06-.04.09-.06c0,0,.02-.01.03-.02.02-.02.04-.03.07-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M314.43,254.33c1.75,1.01,3.17,3.46,3.16,5.47,0,2.01-1.43,2.82-3.18,1.81-1.75-1.01-3.16-3.46-3.16-5.47,0-2.01,1.43-2.82,3.18-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M314.32,255.75c1.08.62,1.97,2.08,2.06,3.35,0,.08,0,.15,0,.23,0,1.32-.94,1.85-2.08,1.19-1.15-.66-2.07-2.27-2.07-3.58,0-.08,0-.15,0-.22.1-1.15.99-1.59,2.07-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M314.32,256.4c.79.45,1.43,1.52,1.5,2.44,0,.06,0,.11,0,.17,0,.96-.68,1.34-1.51.86-.83-.48-1.51-1.65-1.5-2.61,0-.05,0-.11,0-.16.07-.84.72-1.16,1.51-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M312.81,257.1c.06-.7.52-1.03,1.12-.87-.47-.01-.8.32-.85.91,0,.05,0,.1,0,.16,0,.96.67,2.12,1.5,2.61.13.08.27.13.39.17-.2,0-.42-.07-.66-.21-.83-.48-1.51-1.65-1.5-2.61,0-.06,0-.11,0-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M313.75,258.31s-.09-.03-.12-.01c-.07.04-.07.16,0,.28.03.06.08.1.12.13.04.02.09.03.12.01.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M314.41,257.69c-.21-.12-.39-.02-.39.22,0,.24.17.54.38.67.21.12.39.02.39-.22,0-.24-.17-.54-.38-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M314.41,259.01c-.09-.05-.17-.01-.17.1,0,.11.07.24.17.29.09.05.17.01.17-.1,0-.11-.08-.24-.17-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M315.07,259.08s-.09-.03-.12-.01c-.07.04-.07.16,0,.28.03.06.08.1.12.13.04.03.09.03.12.01.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M313.75,256.79s-.09-.03-.12-.01c-.07.04-.07.16,0,.28.03.06.08.1.12.13.04.03.09.03.12.01.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M314.41,257.25c.09.05.17.01.17-.1s-.07-.24-.17-.29c-.09-.05-.17-.01-.17.1,0,.11.08.24.17.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M315.07,257.95s.09.03.12.01c.07-.04.07-.16,0-.28-.03-.06-.08-.1-.12-.13-.04-.03-.09-.03-.12-.01-.07.04-.07.16,0,.28.03.06.08.1.12.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M313.64,257.69c0-.11-.08-.24-.17-.29-.09-.05-.17-.01-.17.1,0,.11.08.24.17.29.09.05.17.01.17-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M315.35,258.48c-.09-.05-.17-.01-.17.1,0,.11.08.24.17.29.09.05.17.01.17-.1,0-.11-.07-.24-.17-.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "323.99 257.95 323.99 260.43 332.5 255.51 332.5 253.03 323.99 257.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "292.68 231.86 304.16 225.36 304.14 233.56 292.66 240.05 292.68 231.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "284.97 227.41 296.45 220.91 304.16 225.36 292.68 231.86 284.97 227.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-241",
    points: "331.4 254.32 325.53 257.64 325.53 260.46 322.72 262.05 322.73 257.45 334.21 250.95 334.19 255.56 331.39 257.14 331.4 254.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "292.66 240.05 304.14 233.56 334.21 250.95 322.73 257.45 292.66 240.05"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "293.32 239.68 303.9 233.69 333.18 250.7 322.6 256.69 293.32 239.68"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M333.53,240.1c-1.08-.51-2.34-.21-3.36.32,0,0,0,0,0,0-.04.02-.08.04-.13.07,0,0-.02,0-.02.01-.04.02-.08.05-.13.07l-27.29-15.87s.08-.05.13-.07c0,0,.02,0,.02-.01,0,0,.01,0,.02-.01.04-.02.07-.04.11-.06,0,0,0,0,0,0,.97-.5,2.16-.8,3.21-.39.01,0,.03.01.04.02.02,0,.04.02.06.03.01,0,.03.01.04.02.02.01.05.02.07.03.01,0,.02.01.03.02.03.02.07.04.1.06,0,0,27.28,15.87,27.29,15.87-.07-.04-.13-.07-.2-.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "329.89 240.57 302.6 224.7 299.29 226.61 326.57 242.48 329.89 240.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M293.91,235.8c0-.69.11-1.39.28-2.05,0-.04.02-.07.03-.11,0-.02.01-.04.02-.06,0-.02,0-.04.02-.06,0-.01,0-.03.01-.04,0-.02.01-.04.02-.06,0-.03.02-.07.03-.1,0-.02.01-.04.02-.06,0,0,0-.02,0-.02,0-.03.02-.07.03-.1,0-.01,0-.02.01-.04.02-.05.03-.1.05-.15.78-2.32,2.27-4.57,4.29-5.99.02-.01.03-.02.05-.03,0,0,.02-.01.03-.02.02-.01.04-.03.06-.04.01,0,.03-.02.04-.03.04-.03.08-.06.13-.08,0,0,0,0,0,0,.04-.03.08-.05.12-.08.01,0,.03-.02.04-.02.02-.01.04-.02.06-.03.02-.01.04-.02.05-.03l27.29,15.87s-.07.04-.11.07c-.01,0-.03.02-.04.02-.04.02-.08.05-.12.08,0,0,0,0,0,0-.04.03-.08.05-.13.08-.01,0-.03.02-.04.03-.03.02-.06.04-.09.06-.02.01-.03.02-.05.03-.03.02-.05.04-.08.06-.02.01-.03.02-.05.04-.03.02-.05.04-.08.06-.02.01-.03.03-.05.04-.03.02-.05.04-.08.06-.01.01-.03.02-.04.03-.03.02-.06.05-.09.07-.01,0-.02.02-.04.03-.04.03-.08.07-.13.1,0,0-.02.01-.03.02-.03.03-.07.06-.1.09-.02.01-.03.03-.05.04-.03.02-.05.05-.08.07-.02.02-.03.03-.05.05-.02.02-.05.04-.07.07-.02.02-.04.03-.05.05-.02.02-.05.04-.07.07-.02.02-.03.03-.05.05-.02.02-.05.04-.07.07-.02.02-.03.03-.05.05-.02.02-.05.05-.07.07-.02.02-.03.03-.05.05-.02.02-.04.05-.07.07-.02.02-.03.04-.05.05-.02.03-.05.05-.07.08-.01.02-.03.03-.04.05-.03.03-.05.06-.08.09-.01.01-.02.03-.04.04-.04.04-.07.08-.11.12,0,0,0,0,0,0-.04.04-.07.09-.11.13-.01.02-.03.03-.04.05-.02.03-.05.06-.07.09-.01.02-.03.04-.04.06-.02.03-.04.05-.06.08-.02.03-.05.06-.07.09-.01.02-.03.04-.04.06-.03.04-.06.07-.08.11,0,.01-.02.03-.03.04-.05.07-.1.14-.15.22-.01.02-.02.03-.03.04-.05.07-.1.14-.15.22-.01.02-.03.04-.04.07-.02.03-.04.06-.06.08-.02.02-.03.05-.05.07-.02.03-.04.06-.05.09-.02.02-.03.05-.05.07-.02.03-.04.06-.05.09-.01.02-.03.05-.04.07-.02.03-.03.06-.05.09-.01.02-.02.04-.03.06-.04.06-.07.13-.11.19,0,0,0,.02-.01.03-.04.07-.08.14-.12.21-.01.02-.02.05-.04.07-.01.03-.03.05-.04.08-.01.03-.03.05-.04.08-.01.03-.03.05-.04.08-.02.03-.03.06-.05.09,0,.02-.02.04-.03.06-.02.03-.03.07-.05.1,0,.02-.02.04-.03.05,0,.01-.01.03-.02.04-.03.07-.06.14-.09.21,0,.02-.01.03-.02.04-.03.07-.07.15-.1.23-.02.04-.03.07-.04.11,0,.01,0,.02-.01.03-.02.05-.04.1-.06.15,0,.01,0,.03-.02.04-.02.04-.03.08-.04.11,0,.02-.01.03-.02.05-.01.04-.03.07-.04.1,0,.02-.01.04-.02.05-.01.04-.03.08-.04.12,0,.01,0,.03-.01.04-.02.05-.03.1-.05.16,0,.01,0,.02-.01.03-.01.04-.03.08-.04.12,0,.02-.01.04-.02.06,0,.03-.02.07-.03.1,0,.02-.01.04-.02.06,0,.03-.02.07-.03.1,0,.02-.01.04-.02.06,0,.04-.02.07-.03.11,0,.02,0,.03-.01.05-.01.05-.03.1-.04.16,0,0,0,0,0,.01-.01.05-.02.1-.03.14,0,.02,0,.03-.01.05,0,.04-.01.07-.02.11,0,.02,0,.04-.01.06,0,.03-.01.07-.02.1,0,.02,0,.04,0,.05,0,.04-.01.08-.02.11,0,.01,0,.03,0,.04,0,.05-.02.1-.02.15,0,.01,0,.02,0,.03,0,.04-.01.08-.02.12,0,.02,0,.03,0,.05,0,.04,0,.07-.01.1,0,.02,0,.03,0,.05,0,.04,0,.08-.01.11,0,.01,0,.03,0,.04,0,.05,0,.1-.01.15,0,.01,0,.02,0,.03,0,.04,0,.08,0,.12,0,.02,0,.03,0,.05,0,.04,0,.07,0,.1,0,.01,0,.03,0,.04,0,.05,0,.1,0,.14,0,.05,0,.1,0,.15,0,.01,0,.02,0,.03,0,.04,0,.07,0,.11,0,.02,0,.03,0,.05,0,.03,0,.06,0,.09,0,.02,0,.03,0,.05.07.95.4,2,1.12,2.65,0,0,.02.01.02.02.02.02.04.03.05.05,0,0,.01.01.02.02.02.02.05.04.08.06,0,0,0,0,.01,0,.02.02.04.03.06.05,0,0,.02.01.03.02.02.01.04.03.06.04,0,0,.02.01.02.02.03.02.05.03.08.05l-27.29-15.87s-.05-.03-.08-.05c0,0-.02-.01-.02-.02-.02-.01-.04-.02-.06-.04,0,0-.02-.01-.03-.02-.02-.02-.04-.03-.06-.05,0,0,0,0-.01,0-.78-.59-1.16-1.63-1.26-2.57-.03-.28-.04-.57-.04-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M326.57,242.48c-2.97,1.72-5.4,5.92-5.39,9.34,0,3.42,2.45,4.81,5.43,3.09l3.31-1.91c2.97-1.72,5.4-5.92,5.39-9.34,0-3.42-2.45-4.81-5.43-3.09l-3.31,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M303.99,247.03s0,0,0,0c0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.02,0-.02,0,0,0-.02,0-.03,0h0s-.01,0-.02,0h-.01s-.01,0-.02,0c0,0,0,0-.01,0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.02,0-.03,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.02,0-.02,0,0,0,0,0,0,0,0,0-.02,0-.03.01,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.02,0-.03.01h0s-.02.01-.03.02c0,0,0,0,0,0,0,0-.02.01-.03.02l-6.24-3.63s.02-.01.03-.02c0,0,0,0,0,0,0,0,0,0,0,0,0,0,.02,0,.02-.01h0s.02,0,.03-.01c0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,.02,0,.03-.01h0s0,0,0,0c0,0,.02,0,.02,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,.02,0,.03,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,.01,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,.02,0h0s.02,0,.03,0h0s.02,0,.02,0c0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,.01,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,.02,0,.02.01h0s6.24,3.63,6.24,3.63c0,0-.01,0-.02-.01,0,0,0,0,0,0,0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-173",
    points: "303.16 247.14 296.92 243.51 296.16 243.95 302.4 247.58 303.16 247.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M294.93,246.05s0,0,0,0h0s0-.02,0-.02h0s0-.03,0-.04c0,0,0,0,0,0h0s0-.02,0-.03c0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0-.02,0-.02,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0-.02,0-.02,0,0,0,0,0,0,0-.01,0-.02,0-.03,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0-.02,0-.03,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0-.02,0-.02,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0-.02,0-.03,0,0,0,0,0,0,0-.01,0-.02,0-.03,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0-.02,0-.02,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0-.02,0-.02,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0-.01,0-.02.01-.03,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.02,0-.03,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0-.02,0-.03,0,0,0,0,0,0,0,0,0,0,0,0,0-.01,0-.02.01-.03,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0-.02.01-.03.02-.05,0,0,0,0,0,0,0,0,0,0,0,0,0-.02.01-.03.02-.05,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0-.02.01-.02,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0,0,0,0,0-.02.02-.03.03-.05,0,0,0,0,0,0,0-.01.02-.03.03-.04,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01.01-.02,0,0,0-.01.01-.02,0,0,0-.01.01-.02,0,0,0-.01.01-.02,0,0,0-.01.01-.02,0,0,0-.01.01-.02,0,0,0-.01.01-.02,0,0,0,0,0-.01,0,0,0,0,0,0,.01-.02.02-.03.03-.05,0,0,0,0,0-.01.01-.02.02-.03.04-.05,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01-.02.02-.03,0,0,0,0,0-.01,0,0,.01-.01.02-.02,0,0,0,0,0,0,0,0,0,0,.01-.01,0,0,0,0,.01-.01,0,0,.01-.01.02-.02,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,.02-.02.02-.03h0s.02-.02.02-.03c0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01-.01.02-.02,0,0,0,0,0-.01,0,0,0,0,.01-.01,0,0,0,0,0,0,0,0,0,0,.01-.01,0,0,.01-.01.02-.02,0,0,0,0,.01-.01,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01-.01,0,0,.01-.01.02-.02,0,0,0,0,.01-.01,0,0,0,0,0,0,0,0,0,0,.01-.01,0,0,0,0,.01-.01,0,0,.01-.01.02-.02,0,0,0,0,.01-.01,0,0,0,0,0,0,0,0,.01,0,.02-.01,0,0,0,0,.01,0,0,0,.02-.01.02-.02,0,0,0,0,0,0h0s.02-.02.03-.02c0,0,0,0,0,0,0,0,.01,0,.02-.01,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,.01,0,.02-.01,0,0,0,0,.01,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,.01,0,.02-.01,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,.02-.01.03-.02h0s0,0,0,0c0,0,.02-.01.03-.02,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,.01,0l6.24,3.63s-.02,0-.02.02c0,0,0,0,0,0,0,0-.02.01-.03.02,0,0,0,0,0,0,0,0-.02.01-.03.02,0,0,0,0,0,0,0,0-.01,0-.02.01,0,0,0,0-.01,0,0,0-.01,0-.02.01,0,0,0,0-.01,0,0,0-.01,0-.02.01,0,0,0,0-.01,0,0,0-.01,0-.02.01,0,0,0,0-.01,0,0,0-.01.01-.02.02,0,0,0,0,0,0,0,0-.02.02-.03.02,0,0,0,0,0,0,0,0-.02.01-.02.02,0,0,0,0-.01,0,0,0-.01.01-.02.02,0,0,0,0-.01.01,0,0-.01.01-.02.02,0,0,0,0-.01.01,0,0-.01.01-.02.02,0,0,0,0-.01.01,0,0-.01.01-.02.02,0,0,0,0-.01.01,0,0-.01.01-.02.02,0,0,0,0-.01.01,0,0,0,.01-.02.02,0,0,0,0-.01.01,0,0-.01.01-.02.02,0,0,0,0-.01.01,0,0-.01.01-.02.02,0,0,0,0,0,0,0,0-.02.02-.02.03h0s-.02.02-.03.03c0,0,0,0,0,.01,0,0-.01.01-.02.02,0,0,0,0-.01.01,0,0,0,.01-.01.02,0,0-.01.01-.02.02,0,0,0,0,0,.01,0,0-.01.02-.02.03,0,0,0,0,0,0-.01.02-.02.03-.04.05,0,0,0,0,0,0-.01.02-.02.03-.03.05,0,0,0,0,0,.01,0,0,0,.01-.01.02,0,0,0,.01-.01.02,0,0,0,.01-.01.02,0,0,0,.01-.01.02,0,0,0,.01-.01.02,0,0,0,.01-.01.02,0,0,0,.01-.01.02,0,0,0,0,0,.01,0,.01-.02.03-.03.04,0,0,0,0,0,0,0,.02-.02.03-.03.05,0,0,0,.01,0,.02,0,0,0,.01,0,.02,0,0,0,.01,0,.02,0,0,0,.01,0,.02,0,0,0,.01-.01.02,0,0,0,0,0,.01,0,0,0,.02-.01.02,0,0,0,0,0,.01,0,0,0,0,0,0,0,.02-.01.03-.02.05,0,0,0,0,0,.01,0,.02-.02.03-.02.05,0,0,0,.02-.01.02,0,0,0,0,0,0,0,.01,0,.02-.01.03,0,0,0,0,0,0,0,0,0,.02,0,.03,0,0,0,0,0,.01,0,0,0,.02,0,.02,0,0,0,0,0,.01,0,0,0,.02,0,.03,0,0,0,0,0,0,0,.01,0,.02-.01.04,0,0,0,0,0,0,0,0,0,.02,0,.03,0,0,0,0,0,.01,0,0,0,.02,0,.02,0,0,0,0,0,.01,0,0,0,.02,0,.02,0,0,0,0,0,.01,0,0,0,.02,0,.03,0,0,0,0,0,.01,0,.01,0,.02,0,.04,0,0,0,0,0,0,0,.01,0,.02,0,.03,0,0,0,0,0,.01,0,0,0,.02,0,.02,0,0,0,0,0,.01,0,0,0,.02,0,.02,0,0,0,0,0,.01,0,0,0,.02,0,.03,0,0,0,0,0,0,0,.01,0,.02,0,.03,0,0,0,0,0,0,0,0,0,.02,0,.03,0,0,0,0,0,.01,0,0,0,.02,0,.02,0,0,0,0,0,.01,0,0,0,.02,0,.03,0,0,0,0,0,0,0,.01,0,.02,0,.03,0,0,0,0,0,0,0,0,0,.02,0,.03,0,0,0,0,0,.01,0,0,0,.02,0,.02h0s0,.03,0,.04,0,.02,0,.03h0s0,.02,0,.03c0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,0,0,.01,0,.02,0,.03,0,0,0,0,0,0,0,0,0,.02,0,.03,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,.01,0,.02,0,.03,0,0,0,0,0,0,0,0,0,.02,0,.03,0,0,0,0,0,0,0,0,0,.02,0,.02,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,.02,0,.02,0,0,0,0,0,0,0,.01,0,.02.01.03,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,.02.01.02,0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,.01.01.02,0,0,0,0,0,0,0,0,0,.01.01.02,0,0,0,0,0,0,0,0,0,0,.01.01,0,0,0,0,0,0,0,0,0,0,.01.01,0,0,0,0,0,0,0,0,.01.01.02.02,0,0,0,0,0,0,0,0,0,0,.01.01,0,0,0,0,0,0,0,0,0,0,.01.01,0,0,0,0,0,0,0,0,.01,0,.02.01,0,0,0,0,0,0,0,0,0,0,.01.01,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,.01,0,.02.01h0l-6.24-3.63s-.01,0-.02-.01c0,0,0,0,0,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0,0,0-.01-.01,0,0,0,0,0,0,0,0-.01,0-.02-.01,0,0,0,0,0,0,0,0,0,0-.01-.01,0,0,0,0,0,0,0,0,0,0-.01-.01,0,0,0,0,0,0,0,0-.01-.01-.02-.02,0,0,0,0,0,0,0,0,0,0-.01-.01,0,0,0,0,0,0,0,0,0,0-.01-.01,0,0,0,0,0,0,0,0,0-.01-.01-.02,0,0,0,0,0,0,0,0,0-.01-.01-.02,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.02-.01-.02,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.02-.01-.03,0,0,0,0,0,0,0,0,0-.02,0-.02,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0-.02,0-.02,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.02,0-.03,0,0,0,0,0,0,0-.01,0-.02,0-.03h0s0-.01,0-.02c0,0,0,0,0-.01,0,0,0-.02,0-.03,0,0,0,0,0,0h0s0-.02,0-.03c0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0-.01,0-.02,0,0,0,0,0-.01h0s0-.02,0-.03h0s0-.03,0-.04h0v-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M302.4,247.58c-.68.39-1.23,1.35-1.23,2.14,0,.78.56,1.1,1.24.71l.76-.44c.68-.39,1.23-1.35,1.23-2.13,0-.78-.56-1.1-1.24-.71l-.76.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M323.52,259.99c-.26.15-.47.5-.5.81,0,.02,0,.04,0,.06,0,.32.22.44.5.29.28-.16.5-.54.5-.86,0-.02,0-.04,0-.05-.02-.28-.24-.38-.5-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M324.74,259.3c-.26.15-.47.5-.5.81,0,.02,0,.04,0,.06,0,.32.22.44.5.29.28-.16.5-.55.5-.86,0-.02,0-.04,0-.05-.02-.28-.24-.38-.5-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M332.24,255.13c-.26.15-.47.5-.5.81,0,.02,0,.04,0,.06,0,.32.22.44.5.29.28-.16.5-.54.5-.86,0-.02,0-.04,0-.05-.02-.28-.24-.38-.5-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M333.46,254.45c-.26.15-.47.5-.5.81,0,.02,0,.04,0,.06,0,.32.22.44.5.29.28-.16.5-.54.5-.86,0-.02,0-.04,0-.05-.02-.28-.24-.38-.5-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M283.37,232.34l1.6-4.93,7.71,4.45-.02,8.2v1.48l-3.24-1.87c-.45-.49-.95-.9-1.47-1.2-1.81-1.04-3.32-.41-3.63,1.39l-.96-.56.02-6.95Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-219",
    points: "322.73 257.45 322.72 262.05 320.93 261.02 320.93 257.88 292.66 241.53 292.66 240.05 322.73 257.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M295.4,239.36s-.02-.01-.02-.02c-.02-.01-.04-.02-.06-.04,0,0-.02-.01-.03-.02-.02-.02-.04-.03-.06-.05,0,0,0,0-.01,0-.03-.02-.05-.04-.08-.06,0,0-.01-.01-.02-.02-.02-.02-.04-.03-.05-.05,0,0-.02-.01-.02-.02-.02-.02-.04-.03-.05-.05,0,0-.01-.01-.02-.02-.02-.02-.05-.05-.07-.07,0,0,0-.01-.01-.02-.02-.02-.04-.04-.05-.06,0,0-.01-.02-.02-.02-.02-.02-.03-.04-.05-.06,0,0-.01-.01-.02-.02-.02-.03-.04-.05-.06-.08,0,0,0,0,0,0-.02-.02-.04-.05-.05-.07,0,0-.01-.02-.02-.03-.01-.02-.03-.04-.04-.06,0,0-.01-.02-.02-.03,0,0,0,0-.01-.02,0-.01-.02-.03-.03-.04,0-.01-.01-.02-.02-.04-.01-.02-.03-.05-.04-.07,0,0-.01-.02-.02-.03-.02-.03-.04-.07-.05-.1,0,0,0-.01,0-.02-.01-.03-.03-.05-.04-.08,0,0,0,0,0,0-.02-.04-.04-.09-.06-.13,0-.01,0-.02-.01-.04-.01-.04-.03-.07-.04-.11,0,0,0-.02,0-.02,0,0,0-.01,0-.02-.01-.03-.02-.06-.03-.08,0-.02-.01-.03-.02-.05-.01-.03-.02-.07-.03-.1,0,0,0-.02,0-.03,0,0,0,0,0,0-.01-.04-.02-.07-.03-.11,0,0,0-.01,0-.02-.01-.04-.02-.09-.03-.13h0s-.01-.06-.02-.08c0-.02,0-.03,0-.05,0-.04-.01-.07-.02-.11,0,0,0-.01,0-.02h0s-.01-.09-.02-.13c0-.01,0-.03,0-.04,0-.03,0-.05-.01-.08,0,0,0,0,0-.01,0-.02,0-.03,0-.05,0-.03,0-.06,0-.09,0-.02,0-.04,0-.06,0-.02,0-.03,0-.05,0-.01,0-.02,0-.04,0-.02,0-.03,0-.05,0-.03,0-.06,0-.09,0-.02,0-.03,0-.05,0,0,0-.01,0-.02,0-.03,0-.06,0-.09,0-.01,0-.02,0-.03,0-.05,0-.09,0-.14v-.02s0-.1,0-.14c0-.01,0-.03,0-.04,0-.02,0-.04,0-.05,0-.02,0-.03,0-.05,0-.02,0-.03,0-.05,0-.04,0-.08,0-.12,0-.01,0-.02,0-.03,0,0,0,0,0,0,0-.05,0-.09.01-.14,0-.01,0-.03,0-.04,0-.03,0-.05,0-.08,0-.01,0-.02,0-.03,0-.02,0-.03,0-.05,0-.03,0-.07.01-.1,0-.02,0-.03,0-.05,0,0,0-.02,0-.03,0-.03,0-.06.01-.1,0-.01,0-.02,0-.03,0-.05.01-.09.02-.14,0,0,0,0,0-.01,0-.01,0-.03,0-.04,0-.04.01-.08.02-.11,0-.02,0-.04,0-.05,0-.02,0-.03,0-.05,0-.02,0-.03,0-.05,0-.02,0-.04.01-.06,0-.04.01-.07.02-.11,0-.02,0-.03.01-.05,0,0,0-.01,0-.02,0-.04.02-.08.03-.13,0,0,0,0,0-.01.01-.05.02-.1.03-.14,0,0,0,0,0-.01,0-.02,0-.03.01-.05,0-.04.02-.07.03-.11,0-.02.01-.04.02-.06,0-.02.01-.04.02-.06,0-.01,0-.03.01-.04,0-.02.01-.04.02-.06,0-.03.02-.07.03-.1,0-.02.01-.04.02-.06,0,0,0-.02,0-.02,0-.03.02-.07.03-.1,0-.01,0-.02.01-.04.01-.04.03-.08.04-.12l27.32,15.78s0,.01,0,.02c0,.01,0,.03-.01.04-.02.05-.03.1-.05.16,0,.01,0,.02-.01.03-.01.04-.03.08-.04.12,0,.02-.01.04-.02.06-.01.03-.02.07-.03.1,0,.02-.01.04-.02.06,0,.03-.02.07-.03.1,0,.02-.01.04-.02.06,0,.04-.02.07-.03.11,0,.02,0,.03-.01.05-.01.05-.03.1-.04.16,0,0,0,0,0,.01-.01.05-.02.1-.03.14,0,.02,0,.03-.01.05,0,.04-.01.07-.02.11,0,.02,0,.04-.01.06,0,.03-.01.07-.02.1,0,.02,0,.04,0,.05,0,.04-.01.08-.02.11,0,.01,0,.03,0,.04,0,.05-.02.1-.02.15,0,.01,0,.02,0,.03,0,.04-.01.08-.02.12,0,.02,0,.03,0,.05,0,.04,0,.07-.01.1,0,.02,0,.03,0,.05,0,.04,0,.08-.01.11,0,.01,0,.03,0,.04,0,.05,0,.1-.01.15,0,.01,0,.02,0,.03,0,.04,0,.08,0,.12,0,.02,0,.03,0,.05,0,.04,0,.07,0,.1,0,.01,0,.03,0,.04,0,.05,0,.1,0,.14,0,.05,0,.1,0,.15,0,.01,0,.02,0,.03,0,.04,0,.07,0,.11,0,.02,0,.03,0,.05,0,.03,0,.06,0,.09,0,.02,0,.03,0,.05,0,.03,0,.06,0,.09,0,.02,0,.04,0,.06,0,.03,0,.06,0,.09,0,.02,0,.03,0,.05,0,.03,0,.06.01.09,0,.01,0,.03,0,.04,0,.05.01.09.02.13,0,0,0,.02,0,.03,0,.04.01.07.02.11,0,.02,0,.03,0,.05,0,.03.01.06.02.08.01.05.02.09.03.13,0,0,0,.01,0,.02,0,.04.02.08.03.11,0,.01,0,.02,0,.03.01.03.02.07.03.1,0,.02.01.03.02.05,0,.03.02.06.03.08,0,.02.01.03.02.05.01.04.03.07.04.11,0,.01,0,.02.01.04.02.05.04.09.06.13.01.03.03.06.04.08,0,0,0,.01,0,.02.02.03.03.07.05.1,0,0,.01.02.02.03.01.02.03.05.04.07,0,.01.01.02.02.04.01.02.02.04.04.06,0,0,.01.02.02.03.01.02.03.04.04.06,0,0,.01.02.02.03.02.02.04.05.05.07,0,0,0,0,0,0,.02.03.04.05.06.08,0,0,.01.01.02.02.02.02.03.04.05.05,0,0,.01.02.02.02.02.02.03.04.05.06,0,0,0,.01.01.02.02.02.05.05.07.07,0,0,.01.01.02.02.02.02.04.03.05.05,0,0,.02.01.02.02.02.02.04.03.05.05,0,0,.01.01.02.02.02.02.05.04.07.06,0,0,0,0,.01,0,.02.02.04.03.06.05,0,0,.02.01.02.02.02.01.04.03.06.04,0,0,.02.01.02.02.03.02.05.03.08.05h0l-27.29-15.87s-.05-.03-.08-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M285.23,228.62c-.05-.03-.1-.02-.12.03l-.82,3.07c-.03.08.03.22.12.27l4.49,2.59c.07.04.13,0,.13-.07v-3.54c.01-.08-.05-.18-.12-.22l-3.69-2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M287.54,226.38c.38,0,.69.19.69.32v1.04c0,.13-.31.24-.69.24s-.69-.11-.69-.24v-1.04c0-.13.31-.32.69-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M287.54,227.71c.38,0,.69-.11.69-.24v.28c0,.13-.31.24-.69.24s-.69-.11-.69-.24v-.28c0,.13.31.24.69.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M288.23,226.69c-.02.13-.32.23-.69.23s-.67-.1-.69-.23c.02-.13.32-.31.69-.31s.67.17.69.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M296.73,220.96c.38,0,.69.19.69.32v1.04c0,.13-.31.24-.69.24s-.69-.11-.69-.24v-1.04c0-.13.31-.32.69-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M296.73,222.29c.38,0,.69-.11.69-.24v.28c0,.13-.31.24-.69.24s-.69-.11-.69-.24v-.28c0,.13.31.24.69.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M297.42,221.27c-.02.13-.32.23-.69.23s-.67-.1-.69-.23c.02-.13.32-.31.69-.31s.67.18.69.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "186.13 219.51 207.94 232.2 191.06 234.28 169.2 221.56 186.13 219.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "169.2 221.56 169.2 229.31 191.06 242.03 191.06 234.28 169.2 221.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-236",
    points: "191.06 234.28 191.06 242.03 207.94 232.2 191.06 234.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "216.51 201.78 238.31 214.47 221.43 216.55 199.57 203.83 216.51 201.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-231",
    points: "199.57 203.83 199.57 211.57 221.43 224.29 221.43 216.55 199.57 203.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "221.43 216.55 221.43 224.29 238.31 214.47 221.43 216.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "246.9 184.04 268.7 196.73 251.82 198.81 229.96 186.09 246.9 184.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "229.96 186.09 229.96 193.84 251.82 206.56 251.82 198.81 229.96 186.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-230",
    points: "251.82 198.81 251.82 206.56 268.7 196.73 251.82 198.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-286",
    points: "302.47 211.8 302.47 204.2 274.96 220.08 274.96 227.79 302.47 211.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "288.66 167.67 286.41 166.37 275.99 172.42 278.25 173.73 288.66 167.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "284.15 165.07 281.9 163.76 271.48 169.82 273.74 171.12 284.15 165.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "279.64 162.46 277.39 161.16 266.97 167.22 269.23 168.52 279.64 162.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "275.13 159.86 272.88 158.56 262.46 164.62 264.72 165.92 275.13 159.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "270.62 157.26 268.37 155.95 257.95 162.01 260.21 163.32 270.62 157.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "266.11 154.65 263.86 153.35 253.44 159.41 255.7 160.71 266.11 154.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "261.6 152.05 259.35 150.75 248.93 156.81 251.19 158.11 261.6 152.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "257.09 149.45 254.84 148.14 244.42 154.2 246.68 155.51 257.09 149.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "252.58 146.84 250.33 145.54 239.91 151.6 242.17 152.9 252.58 146.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "248.07 144.24 245.82 142.94 235.41 149 237.66 150.3 248.07 144.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "243.56 141.64 241.31 140.34 230.9 146.39 233.15 147.7 243.56 141.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "239.05 139.04 236.8 137.73 226.39 143.79 228.64 145.09 239.05 139.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "234.54 136.43 232.29 135.13 221.88 141.19 224.13 142.49 234.54 136.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "230.03 133.83 227.78 132.53 217.37 138.59 219.62 139.89 230.03 133.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "225.52 131.23 223.27 129.92 212.86 135.98 215.11 137.28 225.52 131.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M156.44,101.9c-3.13-4.47-7.09-7.13-11.38-8.04h.06s-.08,0-.12-.01l-.09-.02c-1.8-.37-6.03-.98-7.63-1.33-2.64-.57-5.41-.48-8.18.26-5.62,1.51-11.25,5.69-15.86,12.41-9.54,13.89-11.22,33.91-4.92,47.1.38.8.79,1.57,1.24,2.33.04.06.07.12.2.34.24.4.5.78.76,1.17.04.06.08.12.12.17.05.07.1.14.19.27.04.05.08.11.15.21.06.09.13.16.19.25l-.03.05-2.97,4.18c-1.5-.47-3.05-.41-4.44.4-.5.29-.95.66-1.34,1.07h0s-.02.03-.02.03c-.41.43-.75.92-1.03,1.46l-26.98,38.17h0c-.28.3-.53.65-.74,1.04h0s0,0,0,0l-.03.04h0s.02-.03.02-.03c-1.18,2.18-1.12,5.4.41,8.4,2.15,4.22,6.39,6.37,9.46,4.81.47-.24.87-.55,1.23-.92h0s.03-.04.03-.04h0s0,0,0,0c.37-.39.69-.85.94-1.36l27.02-39.27c.42-.46.8-1.01,1.11-1.62l.08-.12v-.02c1.01-2.08,1.3-4.87-.21-7.46h0s2.61-3.84,2.61-3.84l.02-.03c1.78,1.17,3.68,1.96,5.64,2.39,1.67.36,5.87.98,7.54,1.34-.21-.05-.42-.1-.62-.15,2.83.73,5.81.69,8.8-.11,5.62-1.51,11.25-5.69,15.86-12.42,10.56-15.39,11.86-38.25,2.9-51.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M145.06,93.86c-.29-.06-.58-.12-.87-.16-.06,0-.12-.02-.19-.03-.26-.04-.52-.07-.78-.09-.05,0-.1-.01-.16-.02-.29-.03-.59-.04-.89-.05-.07,0-.14,0-.21,0-.27,0-.53,0-.8,0-.04,0-.08,0-.13,0-.3.01-.6.03-.9.06-.07,0-.14.01-.22.02-.28.03-.57.06-.85.1h-.08c-.3.06-.61.11-.91.18-.07.01-.15.03-.22.05-.31.07-.61.14-.92.22-5.62,1.51-11.25,5.69-15.86,12.41-9.54,13.89-11.52,33.88-5.21,47.07.38.8.79,1.57,1.24,2.33.04.06.07.12.2.34.24.4.5.78.76,1.17.04.06.08.12.12.17.05.07.1.14.19.27.04.05.08.11.15.21.77,1.05,1.59,2,2.45,2.84.28.27.57.53.85.79l.07.06c.28.24.56.47.84.68.04.03.07.06.11.09.28.21.56.41.84.6.04.03.09.06.13.09.28.19.57.36.86.53.04.03.09.05.13.08.29.17.59.32.88.47.04.02.08.04.12.06.31.15.61.29.92.42l.08.03c.33.13.65.25.98.36h0c.33.11.67.21,1,.3l.07.02c2.83.73,5.81.69,8.8-.11,5.62-1.51,11.25-5.69,15.86-12.42,10.56-15.39,11.86-38.25,2.9-51.07-3.13-4.47-7.09-7.13-11.38-8.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M120.65,151.55c.26.44.53.86.82,1.27.13.19.27.38.41.56.04.06.09.11.13.17.1.13.19.25.29.37.05.06.1.12.16.19.09.11.18.22.27.33.05.06.11.12.17.19.09.1.18.21.28.31.06.06.11.12.17.18.09.1.19.2.28.29.06.06.11.11.17.17.1.09.19.19.29.28.06.05.11.1.17.15.1.09.2.18.3.27.06.05.11.09.17.14h0c-.92-.76-2.92-3.09-4.08-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M148.14,105.61c-.33-.47-.67-.91-1.02-1.33h0c-.48-.58-.98-1.12-1.49-1.61l-.08-.07c-.23-.22-.47-.43-.71-.63-.09-.08-.18-.14-.28-.22-.18-.15-.37-.3-.56-.43h0c-.81-.57-1.65-1.07-2.51-1.46-.09-.04-.17-.08-.26-.12.1,0,.2.01.3.02h0s0,0,0,0h0s-.07,0-.07,0c-1.46-.06-2.96.11-4.45.51-1.11.3-2.22.73-3.33,1.28h0c-3.51,1.75-6.9,4.77-9.81,9-4.92,7.16-7.41,16.29-7.33,24.79,0,.47.02.94.04,1.41.02.47.05.93.09,1.4.07.93.18,1.84.31,2.74.21,1.35.48,2.67.83,3.94.23.85.5,1.68.8,2.48.38,1.02.82,2,1.31,2.94.23.45.48.89.73,1.31,1.16,1.77,3.16,4.1,4.08,4.87h0c.1.09.2.17.31.25.05.04.11.08.16.13.11.09.22.17.33.25.05.04.1.07.15.11.12.08.23.16.35.24.05.03.1.06.14.1.12.08.24.16.37.23.04.03.09.05.13.08.13.08.26.15.39.23.04.02.08.04.12.07.14.07.27.15.41.22.03.02.07.03.1.05.1.05.21.1.31.15h0s.05.02.05.02c.18.08.37.16.55.24h.02c-.07-.03-.14-.06-.21-.09.3,0,.61,0,.91-.01.11,0,.22-.01.33-.02.19-.01.39-.03.59-.05.13-.01.26-.03.39-.04.27-.04.54-.08.81-.13.39-.07.77-.16,1.16-.26,2.38-.64,4.76-1.86,7.03-3.64,2.17-1.7,4.23-3.92,6.1-6.64,8.75-12.74,9.82-31.67,2.4-42.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M141.53,99.75h0c.12.01.24.02.36.03.12,0,.24.02.36.03h0c-.24-.03-.48-.05-.72-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M128.63,158.78h-.02c-.19-.07-.37-.15-.55-.24l.08.04.08.04c.16.07.32.14.47.2l.06.02c.17.07.34.13.52.19h.02s.04,0,.04,0c-.23-.08-.47-.17-.7-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M129.66,158.66c-.11,0-.22.01-.33.02.11,0,.22-.01.33-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M144.83,101.97c.24.2.47.41.71.63-.23-.22-.47-.43-.71-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M130.63,158.56c-.13.02-.26.03-.39.04.13-.01.26-.03.39-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M145.62,102.67c.51.49,1.01,1.02,1.49,1.6-.48-.58-.98-1.11-1.49-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M144.91,93.83l.09.02-.09-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M145.85,100.68s.07.03.1.05c.19.08.39.16.58.25h-.01s0-.01,0-.01c-.22-.1-.44-.19-.66-.28h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M154.44,142.24c.12-.27.24-.55.35-.82.07-.17.14-.35.21-.52.1-.26.2-.51.3-.77.07-.18.13-.37.2-.55.09-.26.18-.51.26-.77.06-.19.12-.37.18-.56.08-.26.16-.53.24-.79.05-.18.11-.36.16-.54.08-.29.16-.57.23-.86.04-.16.09-.32.13-.48.1-.41.2-.83.3-1.24.01-.07.03-.13.04-.2.09-.41.18-.83.25-1.25.03-.16.06-.32.09-.49.05-.29.1-.58.15-.87.03-.18.06-.37.08-.55.04-.27.08-.54.11-.81.02-.19.05-.38.07-.58.03-.26.06-.53.08-.79.02-.19.04-.38.05-.58.02-.27.04-.54.06-.81.01-.18.03-.37.03-.55.02-.29.03-.58.03-.87,0-.16.01-.32.02-.48,0-.41.01-.82,0-1.22,0-.07,0-.15,0-.22,0-.41-.02-.81-.03-1.21,0-.16-.02-.31-.03-.47-.02-.28-.03-.57-.05-.85-.01-.18-.03-.35-.05-.53-.02-.26-.05-.52-.07-.78-.02-.18-.04-.36-.06-.55-.03-.25-.06-.5-.1-.75-.03-.18-.05-.36-.08-.54-.04-.25-.08-.5-.13-.75-.03-.17-.06-.34-.09-.51-.05-.27-.11-.54-.17-.8-.03-.14-.06-.29-.1-.44-.09-.38-.19-.77-.29-1.14-.01-.04-.02-.08-.03-.12-.11-.38-.22-.75-.33-1.12-.04-.13-.09-.27-.14-.4-.09-.25-.17-.51-.26-.76-.06-.15-.11-.3-.17-.45-.09-.23-.18-.46-.27-.68-.06-.15-.13-.3-.19-.45-.1-.22-.19-.43-.29-.65-.07-.15-.14-.29-.21-.44-.11-.22-.22-.43-.33-.64-.07-.13-.14-.27-.22-.4-.13-.23-.26-.45-.39-.67-.07-.11-.13-.22-.2-.33-.2-.33-.41-.65-.63-.96-.23-.33-.48-.65-.72-.96-.05-.06-.1-.13-.15-.19-.24-.3-.48-.58-.73-.86-.04-.05-.09-.09-.13-.14-.24-.25-.48-.5-.72-.73l-.1-.1c-.26-.25-.53-.48-.8-.7-.06-.05-.12-.1-.18-.14-.27-.22-.55-.43-.83-.63l-.09-.06c-.27-.18-.54-.35-.81-.51-.05-.03-.11-.07-.16-.1-.29-.17-.58-.32-.87-.46-.06-.03-.12-.06-.18-.09-.04-.02-.09-.04-.14-.06-.19-.09-.38-.17-.58-.25-.06-.02-.11-.05-.17-.07l-.05-.02c-.31-.12-.62-.22-.93-.31-.07-.02-.13-.04-.2-.06-.77-.22-1.57-.37-2.36-.44-.12-.01-.24-.02-.36-.03-.12,0-.24-.01-.37-.02-.1,0-.2-.01-.3-.02.09.04.17.08.26.12,1.07.48,2.1,1.11,3.07,1.89.09.07.18.14.28.22.24.2.47.41.71.63l.08.07c.52.49,1.01,1.02,1.49,1.6h0c.35.43.7.87,1.02,1.34,7.42,10.61,6.35,29.55-2.4,42.28-1.87,2.72-3.93,4.94-6.1,6.64-2.27,1.78-4.65,3-7.03,3.64-.39.1-.77.19-1.16.26-.27.05-.54.09-.81.13-.13.02-.26.03-.39.04-.2.02-.39.04-.59.05-.11,0-.22.02-.33.02-.3.01-.61.02-.91.01.07.03.14.06.21.08.23.09.46.18.7.26.53.18,1.06.34,1.6.45.07.02.15.03.22.04.25.05.51.09.76.13.1.01.21.03.31.04.25.03.49.05.74.06.09,0,.18.01.27.02.33.01.66.01,1,0,.05,0,.11,0,.16,0,.28-.01.57-.03.85-.06.11-.01.21-.03.32-.04.24-.03.49-.07.73-.11.1-.02.21-.03.31-.06.34-.07.68-.14,1.01-.23.29-.08.59-.17.88-.26h0c.09-.03.19-.07.28-.1h.04c.18-.08.37-.14.55-.22h0c.11-.04.22-.09.33-.14h.02c.18-.08.35-.15.53-.23h0c.12-.06.24-.12.36-.17h0c.17-.08.34-.16.51-.25h0c.12-.06.25-.14.37-.2h0c.17-.09.33-.18.5-.27h0s.08-.05.12-.07c.09-.05.18-.11.26-.16.16-.1.32-.19.48-.3h0c.06-.04.11-.08.17-.11.07-.05.14-.1.22-.15.16-.11.32-.21.47-.32.08-.06.17-.12.25-.19.04-.03.09-.07.13-.1h0c.15-.12.31-.23.46-.35.14-.11.29-.23.43-.35.13-.1.26-.21.38-.32.15-.12.29-.25.43-.38.12-.11.25-.22.37-.33.15-.13.29-.27.43-.41.12-.12.24-.23.36-.35l.07-.07c.12-.12.24-.25.36-.38l.02-.02c.11-.11.22-.23.33-.34h0c.14-.16.28-.32.43-.48l.02-.02c.11-.12.21-.23.32-.36h0c.15-.17.29-.35.43-.53l.06-.07c.09-.1.17-.21.26-.31h0c.16-.2.31-.4.46-.61l.06-.08c.07-.09.14-.18.21-.27h0c.24-.33.48-.67.72-1.01,1.09-1.59,2.07-3.28,2.92-5.04l.04-.09c.18-.38.36-.77.54-1.16.07-.15.13-.3.19-.45ZM144.35,155.53h-.06s.08,0,.12.01h-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M113.68,165.79c-.07-.12-.14-.24-.22-.36-.09-.14-.18-.28-.29-.42-.16-.22-.33-.43-.5-.63l-.04-.05c-.16-.19-.33-.38-.51-.56l-.05-.05c-.18-.18-.35-.35-.54-.51l-.04-.04c-.2-.17-.4-.34-.6-.5h0c-.21-.16-.43-.32-.65-.46h0c-.22-.14-.44-.27-.66-.39h-.03c-.22-.13-.44-.24-.66-.33h-.02c-.23-.11-.46-.19-.69-.26-1.5-.47-3.05-.41-4.44.4-.5.29-.95.66-1.34,1.07h0s-.02.03-.02.03c-.41.43-.75.92-1.03,1.46l-26.98,38.17h0c-.28.3-.53.65-.74,1.04h0s0,.01,0,.01c-1.18,2.18-1.12,5.4.41,8.4,2.15,4.22,6.39,6.37,9.46,4.81.47-.24.87-.55,1.23-.92l.04-.04h0c.37-.39.69-.85.94-1.36l27.02-39.27c.42-.46.8-1.01,1.11-1.62l.08-.12v-.02c1.01-2.08,1.3-4.87-.21-7.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M85.69,214.26c.07-.15.14-.3.2-.46.03-.08.06-.16.09-.25.04-.11.07-.22.1-.34.02-.08.05-.16.07-.24.04-.18.08-.36.11-.54.01-.08.02-.17.04-.25.02-.13.03-.26.05-.4,0-.08.02-.16.02-.24.01-.2.02-.4.02-.6,0-.07,0-.15,0-.22,0-.16-.01-.32-.03-.48,0-.08-.01-.15-.02-.23-.02-.22-.05-.44-.09-.66,0-.05-.02-.11-.03-.16-.03-.19-.07-.37-.12-.56-.02-.07-.03-.14-.05-.21-.06-.23-.13-.46-.21-.7l-.03-.09c-.07-.21-.15-.42-.24-.63-.03-.06-.05-.13-.08-.19-.1-.24-.21-.47-.33-.71-2.15-4.22-6.39-6.37-9.46-4.81-.16.08-.31.18-.46.28-.06.04-.13.09-.19.13-.07.05-.13.1-.2.16-.17.14-.33.29-.48.46-.28.31-.53.66-.74,1.04h0s0,.01,0,.01c-1.18,2.18-1.12,5.4.41,8.4,2.15,4.22,6.39,6.37,9.46,4.81.47-.24.87-.55,1.23-.92l.04-.04h0c.37-.39.69-.85.94-1.36h0s0-.01,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M127.81,165.18h0c-.33-.11-.66-.23-.98-.37l-.08-.03c-.31-.13-.62-.27-.92-.42-.04-.02-.08-.04-.12-.06-.3-.15-.59-.3-.88-.47-.04-.02-.09-.05-.13-.08-.29-.17-.58-.35-.86-.53-.04-.03-.09-.06-.13-.09-.28-.19-.57-.39-.84-.6-.04-.03-.07-.06-.11-.09-.28-.22-.56-.44-.84-.68l-.07-.06c-.29-.25-.57-.51-.85-.79-.86-.84-1.68-1.79-2.45-2.84-.07-.1-.11-.15-.15-.21-.09-.13-.14-.2-.19-.27-.04-.06-.08-.12-.12-.17-.26-.38-.51-.77-.76-1.17-.13-.21-.17-.27-.2-.34-.45-.76-.86-1.53-1.24-2.33-6.31-13.19-4.32-33.18,5.21-47.07,4.62-6.72,10.25-10.91,15.86-12.41.31-.08.61-.15.92-.22.07-.02.15-.03.22-.05.3-.06.61-.12.91-.16h.08c.28-.05.57-.09.85-.11.07,0,.14-.01.22-.02.3-.03.6-.05.9-.06.04,0,.08,0,.13,0,.27,0,.54,0,.8,0,.07,0,.14,0,.21,0,.3,0,.59.03.89.05.05,0,.1.01.16.02.26.02.52.06.78.09.06,0,.13.02.19.03.29.05.58.1.87.16h.06s-.08,0-.12-.01l-.09-.02c-1.8-.37-6.03-.98-7.63-1.33-2.64-.57-5.41-.48-8.18.26-5.62,1.51-11.25,5.69-15.86,12.41-9.54,13.89-11.22,33.91-4.92,47.1.38.8.79,1.57,1.24,2.33.04.06.07.12.2.34.24.4.5.78.76,1.17.04.06.08.12.12.17.05.07.1.14.19.27.04.05.08.11.15.21.06.09.13.16.19.25h0c.06-.11.13-.22.2-.32.07-.1.15-.2.24-.29h.01s0-.01,0-.01c.18-.19.38-.35.61-.49,1.43-.83,3.21.08,4.29,1.53.94,1.27.83,2.7.32,3.74h0s-.05.08-.05.08c-.07.13-.14.25-.22.37-.08.12-.16.22-.25.32h0c1.78,1.17,3.68,1.97,5.64,2.39,1.67.36,5.87.98,7.54,1.34-.21-.05-.42-.1-.62-.15l-.07-.02c-.34-.09-.67-.19-1-.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "73.62 203.38 73.59 203.42 73.59 203.42 73.61 203.39 73.62 203.38 73.62 203.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "84.7 215.67 84.7 215.67 84.71 215.68 84.74 215.63 84.74 215.63 84.7 215.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M121.82,274.76c-3.13-4.47-7.09-7.13-11.38-8.04h.06s-.08,0-.12-.01l-.09-.02c-1.8-.37-6.03-.98-7.63-1.33-2.64-.57-5.41-.48-8.18.26-5.62,1.51-11.25,5.69-15.86,12.41-9.54,13.89-11.22,33.91-4.92,47.1.38.8.79,1.57,1.24,2.33.04.06.07.12.2.34.24.4.5.78.76,1.17.04.06.08.12.12.17.05.07.1.14.19.27.04.05.08.11.15.21.06.09.13.16.19.25l-.03.05-2.97,4.18c-1.5-.47-3.05-.41-4.44.4-.5.29-.95.66-1.34,1.07h0s-.02.03-.02.03c-.41.43-.75.92-1.03,1.46l-26.98,38.17h0c-.28.3-.53.65-.74,1.04h0s0,0,0,0l-.03.04h0s.02-.03.02-.03c-1.18,2.18-1.12,5.4.41,8.4,2.15,4.22,6.39,6.37,9.46,4.81.47-.24.87-.55,1.23-.92h0s.03-.04.03-.04h0s0,0,0,0c.37-.39.69-.85.94-1.36l27.02-39.27c.42-.46.8-1.01,1.11-1.62l.08-.12v-.02c1.01-2.08,1.3-4.87-.21-7.46h0s2.61-3.84,2.61-3.84l.02-.03c1.78,1.17,3.68,1.96,5.64,2.39,1.67.36,5.87.98,7.54,1.34-.21-.05-.42-.1-.62-.15,2.83.73,5.81.69,8.8-.11,5.62-1.51,11.25-5.69,15.86-12.42,10.56-15.39,11.86-38.25,2.9-51.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "M110.44,266.72c-.29-.06-.58-.12-.87-.16-.06,0-.12-.02-.19-.03-.26-.04-.52-.07-.78-.09-.05,0-.1-.01-.16-.02-.29-.03-.59-.04-.89-.05-.07,0-.14,0-.21,0-.27,0-.53,0-.8,0-.04,0-.08,0-.13,0-.3.01-.6.03-.9.06-.07,0-.14.01-.22.02-.28.03-.57.06-.85.1h-.08c-.3.06-.61.11-.91.18-.07.01-.15.03-.22.05-.31.07-.61.14-.92.22-5.62,1.51-11.25,5.69-15.86,12.41-9.54,13.89-11.52,33.88-5.21,47.07.38.8.79,1.57,1.24,2.33.04.06.07.12.2.34.24.4.5.78.76,1.17.04.06.08.12.12.17.05.07.1.14.19.27.04.05.08.11.15.21.77,1.05,1.59,2,2.45,2.84.28.27.57.53.85.79l.07.06c.28.24.56.47.84.68.04.03.07.06.11.09.28.21.56.41.84.6.04.03.09.06.13.09.28.19.57.36.86.53.04.03.09.05.13.08.29.17.59.32.88.47.04.02.08.04.12.06.31.15.61.29.92.42l.08.03c.33.13.65.25.98.36h0c.33.11.67.21,1,.3l.07.02c2.83.73,5.81.69,8.8-.11,5.62-1.51,11.25-5.69,15.86-12.42,10.56-15.39,11.86-38.25,2.9-51.07-3.13-4.47-7.09-7.13-11.38-8.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M86.04,324.41c.26.44.53.86.82,1.27.13.19.27.38.41.56.04.06.09.11.13.17.1.13.19.25.29.37.05.06.1.12.16.19.09.11.18.22.27.33.05.06.11.12.17.19.09.1.18.21.28.31.06.06.11.12.17.18.09.1.19.2.28.29.06.06.11.11.17.17.1.09.19.19.29.28.06.05.11.1.17.15.1.09.2.18.3.27.06.05.11.09.17.14h0c-.92-.76-2.92-3.09-4.08-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M113.53,278.47c-.33-.47-.67-.91-1.02-1.33h0c-.48-.58-.98-1.12-1.49-1.61l-.08-.07c-.23-.22-.47-.43-.71-.63-.09-.08-.18-.14-.28-.22-.18-.15-.37-.3-.56-.43h0c-.81-.57-1.65-1.07-2.51-1.46-.09-.04-.17-.08-.26-.12.1,0,.2.01.3.02h0s0,0,0,0h0s-.07,0-.07,0c-1.46-.06-2.96.11-4.45.51-1.11.3-2.22.73-3.33,1.28h0c-3.51,1.75-6.9,4.77-9.81,9-4.92,7.16-7.41,16.29-7.33,24.79,0,.47.02.94.04,1.41.02.47.05.93.09,1.4.07.93.18,1.84.31,2.74.21,1.35.48,2.67.83,3.94.23.85.5,1.68.8,2.48.38,1.02.82,2,1.31,2.94.23.45.48.89.73,1.31,1.16,1.77,3.16,4.1,4.08,4.87h0c.1.09.2.17.31.25.05.04.11.08.16.13.11.09.22.17.33.25.05.04.1.07.15.11.12.08.23.16.35.24.05.03.1.06.14.1.12.08.24.16.37.23.04.03.09.05.13.08.13.08.26.15.39.23.04.02.08.04.12.07.14.07.27.15.41.22.03.02.07.03.1.05.1.05.21.1.31.15h0s.05.02.05.02c.18.08.37.16.55.24h.02c-.07-.03-.14-.06-.21-.09.3,0,.61,0,.91-.01.11,0,.22-.01.33-.02.19-.01.39-.03.59-.05.13-.01.26-.03.39-.04.27-.04.54-.08.81-.13.39-.07.77-.16,1.16-.26,2.38-.64,4.76-1.86,7.03-3.64,2.17-1.7,4.23-3.92,6.1-6.64,8.75-12.74,9.82-31.67,2.4-42.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M106.91,272.61h0c.12.01.24.02.36.03.12,0,.24.02.36.03h0c-.24-.03-.48-.05-.72-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M94.01,331.64h-.02c-.19-.07-.37-.15-.55-.24l.08.04.08.04c.16.07.32.14.47.2l.06.02c.17.07.34.13.52.19h.02s.04,0,.04,0c-.23-.08-.47-.17-.7-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M95.04,331.52c-.11,0-.22.01-.33.02.11,0,.22-.01.33-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M110.22,274.83c.24.2.47.41.71.63-.23-.22-.47-.43-.71-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M96.02,331.42c-.13.02-.26.03-.39.04.13-.01.26-.03.39-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M111,275.53c.51.49,1.01,1.02,1.49,1.6-.48-.58-.98-1.11-1.49-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.3,266.69l.09.02-.09-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M111.24,273.54s.07.03.1.05c.19.08.39.16.58.25h-.01s0-.01,0-.01c-.22-.1-.44-.19-.66-.28h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M119.82,315.1c.12-.27.24-.55.35-.82.07-.17.14-.35.21-.52.1-.26.2-.51.3-.77.07-.18.13-.37.2-.55.09-.26.18-.51.26-.77.06-.19.12-.37.18-.56.08-.26.16-.53.24-.79.05-.18.11-.36.16-.54.08-.29.16-.57.23-.86.04-.16.09-.32.13-.48.1-.41.2-.83.3-1.24.01-.07.03-.13.04-.2.09-.41.18-.83.25-1.25.03-.16.06-.32.09-.49.05-.29.1-.58.15-.87.03-.18.06-.37.08-.55.04-.27.08-.54.11-.81.02-.19.05-.38.07-.58.03-.26.06-.53.08-.79.02-.19.04-.38.05-.58.02-.27.04-.54.06-.81.01-.18.03-.37.03-.55.02-.29.03-.58.03-.87,0-.16.01-.32.02-.48,0-.41.01-.82,0-1.22,0-.07,0-.15,0-.22,0-.41-.02-.81-.03-1.21,0-.16-.02-.31-.03-.47-.02-.28-.03-.57-.05-.85-.01-.18-.03-.35-.05-.53-.02-.26-.05-.52-.07-.78-.02-.18-.04-.36-.06-.55-.03-.25-.06-.5-.1-.75-.03-.18-.05-.36-.08-.54-.04-.25-.08-.5-.13-.75-.03-.17-.06-.34-.09-.51-.05-.27-.11-.54-.17-.8-.03-.14-.06-.29-.1-.44-.09-.38-.19-.77-.29-1.14-.01-.04-.02-.08-.03-.12-.11-.38-.22-.75-.33-1.12-.04-.13-.09-.27-.14-.4-.09-.25-.17-.51-.26-.76-.06-.15-.11-.3-.17-.45-.09-.23-.18-.46-.27-.68-.06-.15-.13-.3-.19-.45-.1-.22-.19-.43-.29-.65-.07-.15-.14-.29-.21-.44-.11-.22-.22-.43-.33-.64-.07-.13-.14-.27-.22-.4-.13-.23-.26-.45-.39-.67-.07-.11-.13-.22-.2-.33-.2-.33-.41-.65-.63-.96-.23-.33-.48-.65-.72-.96-.05-.06-.1-.13-.15-.19-.24-.3-.48-.58-.73-.86-.04-.05-.09-.09-.13-.14-.24-.25-.48-.5-.72-.73l-.1-.1c-.26-.25-.53-.48-.8-.7-.06-.05-.12-.1-.18-.14-.27-.22-.55-.43-.83-.63l-.09-.06c-.27-.18-.54-.35-.81-.51-.05-.03-.11-.07-.16-.1-.29-.17-.58-.32-.87-.46-.06-.03-.12-.06-.18-.09-.04-.02-.09-.04-.14-.06-.19-.09-.38-.17-.58-.25-.06-.02-.11-.05-.17-.07l-.05-.02c-.31-.12-.62-.22-.93-.31-.07-.02-.13-.04-.2-.06-.77-.22-1.57-.37-2.36-.44-.12-.01-.24-.02-.36-.03-.12,0-.24-.01-.37-.02-.1,0-.2-.01-.3-.02.09.04.17.08.26.12,1.07.48,2.1,1.11,3.07,1.89.09.07.18.14.28.22.24.2.47.41.71.63l.08.07c.52.49,1.01,1.02,1.49,1.6h0c.35.43.7.87,1.02,1.34,7.42,10.61,6.35,29.55-2.4,42.28-1.87,2.72-3.93,4.94-6.1,6.64-2.27,1.78-4.65,3-7.03,3.64-.39.1-.77.19-1.16.26-.27.05-.54.09-.81.13-.13.02-.26.03-.39.04-.2.02-.39.04-.59.05-.11,0-.22.02-.33.02-.3.01-.61.02-.91.01.07.03.14.06.21.08.23.09.46.18.7.26.53.18,1.06.34,1.6.45.07.02.15.03.22.04.25.05.51.09.76.13.1.01.21.03.31.04.25.03.49.05.74.06.09,0,.18.01.27.02.33.01.66.01,1,0,.05,0,.11,0,.16,0,.28-.01.57-.03.85-.06.11-.01.21-.03.32-.04.24-.03.49-.07.73-.11.1-.02.21-.03.31-.06.34-.07.68-.14,1.01-.23.29-.08.59-.17.88-.26h0c.09-.03.19-.07.28-.1h.04c.18-.08.37-.14.55-.22h0c.11-.04.22-.09.33-.14h.02c.18-.08.35-.15.53-.23h0c.12-.06.24-.12.36-.17h0c.17-.08.34-.16.51-.25h0c.12-.06.25-.14.37-.2h0c.17-.09.33-.18.5-.27h0s.08-.05.12-.07c.09-.05.18-.11.26-.16.16-.1.32-.19.48-.3h0c.06-.04.11-.08.17-.11.07-.05.14-.1.22-.15.16-.11.32-.21.47-.32.08-.06.17-.12.25-.19.04-.03.09-.07.13-.1h0c.15-.12.31-.23.46-.35.14-.11.29-.23.43-.35.13-.1.26-.21.38-.32.15-.12.29-.25.43-.38.12-.11.25-.22.37-.33.15-.13.29-.27.43-.41.12-.12.24-.23.36-.35l.07-.07c.12-.12.24-.25.36-.38l.02-.02c.11-.11.22-.23.33-.34h0c.14-.16.28-.32.43-.48l.02-.02c.11-.12.21-.23.32-.36h0c.15-.17.29-.35.43-.53l.06-.07c.09-.1.17-.21.26-.31h0c.16-.2.31-.4.46-.61l.06-.08c.07-.09.14-.18.21-.27h0c.24-.33.48-.67.72-1.01,1.09-1.59,2.07-3.28,2.92-5.04l.04-.09c.18-.38.36-.77.54-1.16.07-.15.13-.3.19-.45ZM109.74,328.39h-.06s.08,0,.12.01h-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M79.07,338.65c-.07-.12-.14-.24-.22-.36-.09-.14-.18-.28-.29-.42-.16-.22-.33-.43-.5-.63l-.04-.05c-.16-.19-.33-.38-.51-.56l-.05-.05c-.18-.18-.35-.35-.54-.51l-.04-.04c-.2-.17-.4-.34-.6-.5h0c-.21-.16-.43-.32-.65-.46h0c-.22-.14-.44-.27-.66-.39h-.03c-.22-.13-.44-.24-.66-.33h-.02c-.23-.11-.46-.19-.69-.26-1.5-.47-3.05-.41-4.44.4-.5.29-.95.66-1.34,1.07h0s-.02.03-.02.03c-.41.43-.75.92-1.03,1.46l-26.98,38.17h0c-.28.3-.53.65-.74,1.04h0s0,.01,0,.01c-1.18,2.18-1.12,5.4.41,8.4,2.15,4.22,6.39,6.37,9.46,4.81.47-.24.87-.55,1.23-.92l.04-.04h0c.37-.39.69-.85.94-1.36l27.02-39.27c.42-.46.8-1.01,1.11-1.62l.08-.12v-.02c1.01-2.08,1.3-4.87-.21-7.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M51.07,387.12c.07-.15.14-.3.2-.46.03-.08.06-.16.09-.25.04-.11.07-.22.1-.34.02-.08.05-.16.07-.24.04-.18.08-.36.11-.54.01-.08.02-.17.04-.25.02-.13.03-.26.05-.4,0-.08.02-.16.02-.24.01-.2.02-.4.02-.6,0-.07,0-.15,0-.22,0-.16-.01-.32-.03-.48,0-.08-.01-.15-.02-.23-.02-.22-.05-.44-.09-.66,0-.05-.02-.11-.03-.16-.03-.19-.07-.37-.12-.56-.02-.07-.03-.14-.05-.21-.06-.23-.13-.46-.21-.7l-.03-.09c-.07-.21-.15-.42-.24-.63-.03-.06-.05-.13-.08-.19-.1-.24-.21-.47-.33-.71-2.15-4.22-6.39-6.37-9.46-4.81-.16.08-.31.18-.46.28-.06.04-.13.09-.19.13-.07.05-.13.1-.2.16-.17.14-.33.29-.48.46-.28.31-.53.66-.74,1.04h0s0,.01,0,.01c-1.18,2.18-1.12,5.4.41,8.4,2.15,4.22,6.39,6.37,9.46,4.81.47-.24.87-.55,1.23-.92l.04-.04h0c.37-.39.69-.85.94-1.36h0s0-.01,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M93.19,338.04h0c-.33-.11-.66-.23-.98-.37l-.08-.03c-.31-.13-.62-.27-.92-.42-.04-.02-.08-.04-.12-.06-.3-.15-.59-.3-.88-.47-.04-.02-.09-.05-.13-.08-.29-.17-.58-.35-.86-.53-.04-.03-.09-.06-.13-.09-.28-.19-.57-.39-.84-.6-.04-.03-.07-.06-.11-.09-.28-.22-.56-.44-.84-.68l-.07-.06c-.29-.25-.57-.51-.85-.79-.86-.84-1.68-1.79-2.45-2.84-.07-.1-.11-.15-.15-.21-.09-.13-.14-.2-.19-.27-.04-.06-.08-.12-.12-.17-.26-.38-.51-.77-.76-1.17-.13-.21-.17-.27-.2-.34-.45-.76-.86-1.53-1.24-2.33-6.31-13.19-4.32-33.18,5.21-47.07,4.62-6.72,10.25-10.91,15.86-12.41.31-.08.61-.15.92-.22.07-.02.15-.03.22-.05.3-.06.61-.12.91-.16h.08c.28-.05.57-.09.85-.11.07,0,.14-.01.22-.02.3-.03.6-.05.9-.06.04,0,.08,0,.13,0,.27,0,.54,0,.8,0,.07,0,.14,0,.21,0,.3,0,.59.03.89.05.05,0,.1.01.16.02.26.02.52.06.78.09.06,0,.13.02.19.03.29.05.58.1.87.16h.06s-.08,0-.12-.01l-.09-.02c-1.8-.37-6.03-.98-7.63-1.33-2.64-.57-5.41-.48-8.18.26-5.62,1.51-11.25,5.69-15.86,12.41-9.54,13.89-11.22,33.91-4.92,47.1.38.8.79,1.57,1.24,2.33.04.06.07.12.2.34.24.4.5.78.76,1.17.04.06.08.12.12.17.05.07.1.14.19.27.04.05.08.11.15.21.06.09.13.16.19.25h0c.06-.11.13-.22.2-.32.07-.1.15-.2.24-.29h.01s0-.01,0-.01c.18-.19.38-.35.61-.49,1.43-.83,3.21.08,4.29,1.53.94,1.27.83,2.7.32,3.74h0s-.05.08-.05.08c-.07.13-.14.25-.22.37-.08.12-.16.22-.25.32h0c1.78,1.17,3.68,1.97,5.64,2.39,1.67.36,5.87.98,7.54,1.34-.21-.05-.42-.1-.62-.15l-.07-.02c-.34-.09-.67-.19-1-.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "39 376.24 38.97 376.28 38.98 376.28 38.99 376.25 39 376.24 39 376.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "50.09 388.53 50.09 388.53 50.09 388.54 50.13 388.49 50.13 388.49 50.09 388.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M89.16,299.42c-.03-.95.08-1.89.33-2.84.25-.94.6-1.82,1.06-2.64.46-.82,1.01-1.55,1.64-2.19.64-.64,1.33-1.13,2.08-1.47s1.45-.49,2.11-.43c.66.05,1.24.27,1.73.66.49.39.89.93,1.19,1.62s.46,1.52.49,2.46-.08,1.89-.33,2.84-.6,1.83-1.06,2.64c-.46.82-1.01,1.55-1.64,2.19-.64.64-1.33,1.13-2.08,1.47s-1.45.49-2.11.43c-.66-.05-1.24-.27-1.73-.66-.49-.38-.89-.93-1.19-1.62-.3-.7-.46-1.52-.49-2.46ZM91.35,298.42c.02.54.12,1.01.3,1.4.19.4.43.72.72.96.3.24.63.38,1.01.42.38.04.78-.04,1.21-.24s.82-.48,1.19-.85c.37-.38.69-.81.96-1.31.27-.5.49-1.03.65-1.58.16-.55.23-1.1.21-1.63s-.12-1-.3-1.4c-.19-.4-.43-.71-.72-.96-.3-.24-.63-.38-1.01-.42-.38-.03-.78.04-1.21.24s-.82.48-1.19.85c-.37.38-.69.81-.96,1.31-.27.5-.49,1.03-.65,1.58-.16.55-.23,1.1-.21,1.64ZM106.44,283.96l1.71.47-12.64,34.57-1.71-.47,12.64-34.57ZM101.98,308.47c-.03-.95.08-1.89.33-2.84.25-.94.6-1.82,1.06-2.64.46-.82,1.01-1.55,1.64-2.19.64-.64,1.33-1.13,2.08-1.47s1.45-.49,2.11-.43c.66.05,1.24.27,1.73.66.49.39.89.93,1.19,1.62.3.7.46,1.52.49,2.46s-.08,1.89-.33,2.84c-.25.94-.6,1.83-1.06,2.64-.46.82-1.01,1.55-1.64,2.19-.64.64-1.33,1.13-2.08,1.47s-1.45.49-2.11.43c-.66-.05-1.24-.27-1.73-.65-.49-.39-.89-.93-1.19-1.62-.3-.7-.46-1.52-.49-2.46ZM104.16,307.48c.02.54.12,1.01.3,1.4.19.4.43.72.72.96.29.24.63.38,1.01.42.38.03.78-.05,1.21-.24s.82-.48,1.19-.85c.37-.38.69-.81.96-1.31.27-.5.49-1.03.65-1.58.16-.55.23-1.1.21-1.64s-.12-1-.3-1.4c-.19-.4-.43-.71-.72-.96-.3-.24-.63-.38-1.01-.42-.38-.03-.78.04-1.21.24s-.82.48-1.19.85c-.37.38-.69.81-.96,1.31-.27.5-.49,1.03-.65,1.58-.16.55-.23,1.1-.21,1.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "97.98 329.53 111.75 318.39 112.66 346.78 117.25 343.07 108.69 369.42 94.31 361.62 98.9 357.91 97.98 329.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-227",
    points: "117.25 343.07 114.85 341.77 112.56 343.62 112.66 346.78 117.25 343.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-228",
    points: "111.75 318.39 109.35 317.09 95.59 328.23 96.5 356.61 91.92 360.33 94.31 361.62 98.9 357.91 97.98 329.53 111.75 318.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-218",
    points: "98.9 357.91 96.5 356.61 95.59 328.23 97.98 329.53 98.9 357.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M141.43,121.23l-6.87,3.02c-.09.04-.2-.07-.21-.23l-1.15-15.44c-.02-.26-.26-.32-.3-.07l-3.81,23.76c-.03.18.09.36.2.31l6.25-2.75c.09-.04.19.06.21.21l1.61,14.94c.03.26.26.31.3.06l3.98-23.51"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilityManagementFeatures);
export default __webpack_public_path__ + "static/media/utility-management-features.c4e28a5336e4ed8371d48705e1b3c6bc.svg";
export { ForwardRef as ReactComponent };